require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/VPTZvragen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/VPTZvragen/components/4d34bee6924156ba10a49ab4af2d8872/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Gasthuis Groningen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f2fc59be-2482-4f26-9c86-e4705fc88389/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Gasthuis Hoogezand-Sappemeer') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6947e947-c6af-49c7-b5c6-578556d50832/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Mantel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2a6675de-fa76-40e5-8382-44b519d21352/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Schutse') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6ae85a4f-69dc-45df-a530-05546414b282/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Mare Heymanscentrum') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e51b52aa-d76f-4422-84f4-049e7d58b681/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Tineke Breiderhuis - Hospice Veen en Wolden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f2e0ca27-44b7-4917-86db-cd5ccde586fe/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Sint Maartenhuis') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/994ad336-542c-4bb7-9d82-49e79f31cc0c/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Vredeborgh') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/753f9f5a-b874-46e9-b99a-d41d1eea6810/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Groningen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e862a69c-b355-4802-a633-8fe1427e8f7b/page/vxfDD';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/algemenegegevens/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'locatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/1171408bf118545ef245f98608ba38f1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1171408bf118545ef245f98608ba38f1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevens/components/448f6e21c6e160197d199b5f0e5533a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/3ca2069d55e252d465c771dd840174ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevens/components/d75477565dfc88fc99f5f35d59c2a709/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevens/components/08066c36b2144cd1bcceda99e775d988/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('08066c36b2144cd1bcceda99e775d988', (await Backendless.Data.of('bewonerskenmerken').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevens/components/baca2ba2d4e3dc0b1d81096f49b99748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8641d099117cce4c8724f4fb0b27bc45')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevens/components/d67a9e7990547cc2091f96d65bade0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')) == null) {
    (function (message) { alert(message) })('De datum is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) == null) {
    (function (message) { alert(message) })('Het nieuwe aantal plaatsen/ bedden is nog niet ingevuld');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
      await Backendless.Data.of('wijzigingbedden').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      await Backendless.Data.of('wijzigingbeddengroningen').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    }
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`aantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingbedden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`datumwijziging`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')))),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }), undefined);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['datumwijziging'] = null;
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['nieuwaantalbedden'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevens/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('wijzigingbedden').save( ({ 'datumwijziging': (new Date()),'nieuwaantalbedden': (getObjectProperty(___arguments.context.pageData, 'aantalbedden')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'aantalbedden': ___arguments.value }) );
  ___arguments.context.pageData['aantalbedden'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/a3de9a87d4d43c0377d7a2e6cc97af4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'soorthospice': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/d8994ea604d633fa5f8717c182f40243/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzthuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/341b2b8809d9f55d018f1a86d6332406/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzeigenhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/73d79d677dc8d23658b1b0a5f5425221/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzexternhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/202a4952ea9babcdab7d443b8b120b42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvv`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/237cf1780e31008860ffaafe02495787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzziekenhuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/09290e59bcca769a712f251fb731e30e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvgzggzanders`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/9e2866cfe2ddd474243c94555271ef36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'algemenegegevensvptzinzet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/8ebc20638602d6c7aa037dc536eea233/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Aantal inwoners ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/2a082cb3c35da4c311d845bdaf53752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/85358fc532b23d07d682b922a74c3717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/3bd56a098ae2d9de774f24dcf4c1a864/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/55d4ec1e98886767a8c4cc83e3950ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/cdd2cc514fff167b938de59851733832/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/cada0d232a1919d8c415149d9c4c4089/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['vptzhoeveelvrijwilligers'] = null;
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzhoeveelvrijwilligers`]: null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/a8090a0a6068858f261966d7674a1588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/8fa6af14730f3824a53274342a6cf2da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/be091a82c02cffef69146e24b8f7ff79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/c87215edd09d2592042a12c78387004c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/algemenegegevens/components/16363889b0b3531b274f9febbfe7b315/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/9756d059a346745be468f273342b1b55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevens/components/76cdaa9a7e842d06473383a86be9ae88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevens/components/bb159fcff0074ad1952584ab471c49e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('groningen'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'locatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/1171408bf118545ef245f98608ba38f1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1171408bf118545ef245f98608ba38f1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/448f6e21c6e160197d199b5f0e5533a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/3ca2069d55e252d465c771dd840174ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/d75477565dfc88fc99f5f35d59c2a709/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/08066c36b2144cd1bcceda99e775d988/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('08066c36b2144cd1bcceda99e775d988', (await Backendless.Data.of('bewonerskenmerken').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/baca2ba2d4e3dc0b1d81096f49b99748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb88b0adb70c2921b33a211f041fd4c7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/d67a9e7990547cc2091f96d65bade0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')) == null) {
    (function (message) { alert(message) })('De datum is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) == null) {
    (function (message) { alert(message) })('Het nieuwe aantal plaatsen/ bedden is nog niet ingevuld');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
      await Backendless.Data.of('wijzigingbedden').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      await Backendless.Data.of('wijzigingbeddengroningen').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      await Backendless.Data.of('wijzigingbeddenzuidgelderland').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    }
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`aantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingbedden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`datumwijziging`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')))),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }), undefined);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['datumwijziging'] = null;
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['nieuwaantalbedden'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('wijzigingbedden').save( ({ 'datumwijziging': (new Date()),'nieuwaantalbedden': (getObjectProperty(___arguments.context.pageData, 'aantalbedden')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'aantalbedden': ___arguments.value }) );
  ___arguments.context.pageData['aantalbedden'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/a3de9a87d4d43c0377d7a2e6cc97af4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'soorthospice': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/d8994ea604d633fa5f8717c182f40243/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzthuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/341b2b8809d9f55d018f1a86d6332406/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzeigenhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/73d79d677dc8d23658b1b0a5f5425221/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzexternhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/202a4952ea9babcdab7d443b8b120b42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvv`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/237cf1780e31008860ffaafe02495787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzziekenhuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/09290e59bcca769a712f251fb731e30e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvgzggzanders`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/9e2866cfe2ddd474243c94555271ef36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'algemenegegevensvptzinzet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/8ebc20638602d6c7aa037dc536eea233/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Aantal inwoners ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/2a082cb3c35da4c311d845bdaf53752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/85358fc532b23d07d682b922a74c3717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/a8090a0a6068858f261966d7674a1588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/c87215edd09d2592042a12c78387004c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/algemenegegevensGroningen/components/37d4872d552c44dd194a1247d6b9a898/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwe'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'locatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/1171408bf118545ef245f98608ba38f1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1171408bf118545ef245f98608ba38f1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/448f6e21c6e160197d199b5f0e5533a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/3ca2069d55e252d465c771dd840174ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/d75477565dfc88fc99f5f35d59c2a709/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/08066c36b2144cd1bcceda99e775d988/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('08066c36b2144cd1bcceda99e775d988', (await Backendless.Data.of('bewonerskenmerken').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/baca2ba2d4e3dc0b1d81096f49b99748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb88b0adb70c2921b33a211f041fd4c7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/d67a9e7990547cc2091f96d65bade0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')) == null) {
    (function (message) { alert(message) })('De datum is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) == null) {
    (function (message) { alert(message) })('Het nieuwe aantal plaatsen/ bedden is nog niet ingevuld');
  } else {
    await Backendless.Data.of('wijzigingbeddenoostveluwe').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`aantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingbedden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`datumwijziging`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')))),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }), undefined);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['datumwijziging'] = null;
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['nieuwaantalbedden'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('wijzigingbedden').save( ({ 'datumwijziging': (new Date()),'nieuwaantalbedden': (getObjectProperty(___arguments.context.pageData, 'aantalbedden')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'aantalbedden': ___arguments.value }) );
  ___arguments.context.pageData['aantalbedden'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/a3de9a87d4d43c0377d7a2e6cc97af4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'soorthospice': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/d8994ea604d633fa5f8717c182f40243/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzthuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/341b2b8809d9f55d018f1a86d6332406/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzeigenhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/73d79d677dc8d23658b1b0a5f5425221/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzexternhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/202a4952ea9babcdab7d443b8b120b42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvv`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/237cf1780e31008860ffaafe02495787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzziekenhuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/09290e59bcca769a712f251fb731e30e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvgzggzanders`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/9e2866cfe2ddd474243c94555271ef36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'algemenegegevensvptzinzet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/8ebc20638602d6c7aa037dc536eea233/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Aantal inwoners ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/2a082cb3c35da4c311d845bdaf53752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/85358fc532b23d07d682b922a74c3717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/a8090a0a6068858f261966d7674a1588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/c87215edd09d2592042a12c78387004c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/algemenegegevensOost-Veluwe/components/37d4872d552c44dd194a1247d6b9a898/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('zuidgelderland'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'locatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/1171408bf118545ef245f98608ba38f1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1171408bf118545ef245f98608ba38f1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/448f6e21c6e160197d199b5f0e5533a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/3ca2069d55e252d465c771dd840174ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/d75477565dfc88fc99f5f35d59c2a709/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/08066c36b2144cd1bcceda99e775d988/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('08066c36b2144cd1bcceda99e775d988', (await Backendless.Data.of('bewonerskenmerken').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/baca2ba2d4e3dc0b1d81096f49b99748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb88b0adb70c2921b33a211f041fd4c7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/d67a9e7990547cc2091f96d65bade0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')) == null) {
    (function (message) { alert(message) })('De datum is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) == null) {
    (function (message) { alert(message) })('Het nieuwe aantal plaatsen/ bedden is nog niet ingevuld');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
      await Backendless.Data.of('wijzigingbedden').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      await Backendless.Data.of('wijzigingbeddengroningen').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      await Backendless.Data.of('wijzigingbeddenzuidgelderland').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    }
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`aantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingbedden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`datumwijziging`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')))),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }), undefined);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['datumwijziging'] = null;
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['nieuwaantalbedden'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('wijzigingbedden').save( ({ 'datumwijziging': (new Date()),'nieuwaantalbedden': (getObjectProperty(___arguments.context.pageData, 'aantalbedden')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'aantalbedden': ___arguments.value }) );
  ___arguments.context.pageData['aantalbedden'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/a3de9a87d4d43c0377d7a2e6cc97af4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'soorthospice': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/d8994ea604d633fa5f8717c182f40243/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzthuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/341b2b8809d9f55d018f1a86d6332406/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzeigenhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/73d79d677dc8d23658b1b0a5f5425221/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzexternhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/202a4952ea9babcdab7d443b8b120b42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvv`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/237cf1780e31008860ffaafe02495787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzziekenhuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/09290e59bcca769a712f251fb731e30e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvgzggzanders`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/9e2866cfe2ddd474243c94555271ef36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'algemenegegevensvptzinzet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/8ebc20638602d6c7aa037dc536eea233/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Aantal inwoners ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/2a082cb3c35da4c311d845bdaf53752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/85358fc532b23d07d682b922a74c3717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/a8090a0a6068858f261966d7674a1588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Gelderland/components/c87215edd09d2592042a12c78387004c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('zuidlimburg'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'locatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/1171408bf118545ef245f98608ba38f1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1171408bf118545ef245f98608ba38f1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/448f6e21c6e160197d199b5f0e5533a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/3ca2069d55e252d465c771dd840174ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/d75477565dfc88fc99f5f35d59c2a709/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/08066c36b2144cd1bcceda99e775d988/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('08066c36b2144cd1bcceda99e775d988', (await Backendless.Data.of('bewonerskenmerken').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/baca2ba2d4e3dc0b1d81096f49b99748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb88b0adb70c2921b33a211f041fd4c7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/d67a9e7990547cc2091f96d65bade0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')) == null) {
    (function (message) { alert(message) })('De datum is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) == null) {
    (function (message) { alert(message) })('Het nieuwe aantal plaatsen/ bedden is nog niet ingevuld');
  } else {
    await Backendless.Data.of('wijzigingbeddenzuidlimburg').save( ({ [`datumwijziging`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
    await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`aantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingbedden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`datumwijziging`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'datumwijziging')))),[`nieuwaantalbedden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'nieuwaantalbedden')) }), undefined);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d75477565dfc88fc99f5f35d59c2a709', (await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8641d099117cce4c8724f4fb0b27bc45', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb88b0adb70c2921b33a211f041fd4c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('278453073f887cd1f4bd6da3eb0a046f', false);
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['datumwijziging'] = null;
    ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf')['nieuwaantalbedden'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('wijzigingbedden').save( ({ 'datumwijziging': (new Date()),'nieuwaantalbedden': (getObjectProperty(___arguments.context.pageData, 'aantalbedden')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'aantalbedden': ___arguments.value }) );
  ___arguments.context.pageData['aantalbedden'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/a3de9a87d4d43c0377d7a2e6cc97af4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ 'soorthospice': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/d8994ea604d633fa5f8717c182f40243/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzthuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/341b2b8809d9f55d018f1a86d6332406/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzeigenhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/73d79d677dc8d23658b1b0a5f5425221/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzexternhospice`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/202a4952ea9babcdab7d443b8b120b42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvv`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/237cf1780e31008860ffaafe02495787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzziekenhuis`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/09290e59bcca769a712f251fb731e30e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('algemenegegevens').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`vptzvgzggzanders`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/9e2866cfe2ddd474243c94555271ef36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'algemenegegevensvptzinzet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/8ebc20638602d6c7aa037dc536eea233/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Aantal inwoners ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/2a082cb3c35da4c311d845bdaf53752c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/85358fc532b23d07d682b922a74c3717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/a8090a0a6068858f261966d7674a1588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('algemenegegevens').save( ___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/algemenegegevensZuid-Limburg/components/c87215edd09d2592042a12c78387004c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('baf5442d35d64f5d91c35d423af29acf'), 'vptzsamenwerkingvrijwilligersbeleid')) == 'Uitwisseling vrijwilligers') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd0bf463adcf5f2864be796f6d9dcbce', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/changeclientarnhem/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var datumoverlijdenofvertrek, overledenofvertrek;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('16fbf577616ba29a27475fe1fed99c8e')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'leeftijd')) == null) {
    (function (message) { alert(message) })('De leeftijd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ba6a4051219ffd4ee68490dd2148b2c1')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('De zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6738aecdae8610e75d9b1d82f433ffb8')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingwelkziekenhuis')) == null) {
    (function (message) { alert(message) })('Welk ziekenhuis dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c3fcb01a83c3096352406641ab438aa')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == null) {
    (function (message) { alert(message) })('Of de cliënt is overleden of vertrokken dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a1e82e5af66cf8087a81f2c6b458f8de')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Waar de cliënt naar vertrokken is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79d975b6739448924eccb88c900b0749')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'datumopname')) == null) {
    (function (message) { alert(message) })('De datum van opname dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b55d09849674a6f6a32e1515e003a3ce')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'datumoverlijdenofvertrek')) == null) {
    (function (message) { alert(message) })('De datum van overlijden of vertrek dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d36d7801adee7d7377243faea5bfcbe4')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'datumaanmelding')) == null) {
    (function (message) { alert(message) })('De datum van aanmelding dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46cf9fb564424e6f279f9b81515b7b5c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'datumannulering')) == null) {
    (function (message) { alert(message) })('De datum van annulering dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('382d75a85e5e00c1cb28c5c754d7e094')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'redenannulering')) == null) {
    (function (message) { alert(message) })('De reden van annulering dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('604af339eb4795ec7c094257dca60dfd')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'vptzondersteuning')) == null) {
    (function (message) { alert(message) })('Sprake van ondersteuning vanuit VPTZ/Nabij dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c0b49df3338ec87c6f33fd2d5582d49')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'vptzbezoekwenselijk')) == null) {
    (function (message) { alert(message) })('Wenselijkheid/ mogelijkheid thuis vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('24696cf6abc735d25c0733333cfbe643')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'vptzmogelijkheidondersteuning')) == null) {
    (function (message) { alert(message) })('Gewezen op ondersteuning thuis dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee3a4a9803af0ecb3565f5d3f7da1233')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('De gewenste uitplaatsing die niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4f516f6326af77f900ef1356fc553b7')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('De reden dat de gewenste uitplaatsing niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc6be77a59485c79dd64d66ad2f694aa')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('De andere reden dat de gewenste uitplaatsing niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8a12c93b09fb7da63085539cf2adcf4c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('De sprake van crisiszorg dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf27a8b76ae9663bdeed9377ca0fd26b')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('De sprake van respijtzorg dient ingevuld te worden');
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('382d75a85e5e00c1cb28c5c754d7e094')), 'display')) == true) {
      overledenofvertrek = 'Opname geannuleerd';
      datumoverlijdenofvertrek = (getObjectProperty(___arguments.context.dataModel, 'datumannulering'));
    } else {
      overledenofvertrek = (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek'));
      datumoverlijdenofvertrek = (getObjectProperty(___arguments.context.dataModel, 'datumoverlijdenofvertrek'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`datumaanmelding`]: (getObjectProperty(___arguments.context.dataModel, 'datumaanmelding')),[`datumannulering`]: (getObjectProperty(___arguments.context.dataModel, 'datumannulering')),[`redenannulering`]: (getObjectProperty(___arguments.context.dataModel, 'redenannulering')),[`redenannuleringtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'redenannuleringtoelichting')),[`leeftijd`]: (getObjectProperty(___arguments.context.dataModel, 'leeftijd')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`zorgsettingwelkziekenhuis`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingwelkziekenhuis')),[`overledenofvertrek`]: overledenofvertrek,[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`datumopname`]: (getObjectProperty(___arguments.context.dataModel, 'datumopname')),[`datumoverlijdenofvertrek`]: datumoverlijdenofvertrek,[`vptzondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'vptzondersteuning')),[`vptzbezoekwenselijk`]: (getObjectProperty(___arguments.context.dataModel, 'vptzbezoekwenselijk')),[`vptzmogelijkheidondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'vptzmogelijkheidondersteuning')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) }) ));
    await Backendless.Data.of('historiewijzigingen').save( ({ [`actie`]: 'Wijziging cliënt',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
    await Backendless.Data.of('historieclienten').save( ({ [`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`datumaanmelding`]: (getObjectProperty(___arguments.context.dataModel, 'datumaanmelding')),[`datumannulering`]: (getObjectProperty(___arguments.context.dataModel, 'datumannulering')),[`redenannulering`]: (getObjectProperty(___arguments.context.dataModel, 'redenannulering')),[`redenannuleringtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'redenannuleringtoelichting')),[`leeftijd`]: (getObjectProperty(___arguments.context.dataModel, 'leeftijd')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`zorgsettingwelkziekenhuis`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingwelkziekenhuis')),[`overledenofvertrek`]: overledenofvertrek,[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`datumopname`]: (getObjectProperty(___arguments.context.dataModel, 'datumopname')),[`datumoverlijdenofvertrek`]: datumoverlijdenofvertrek,[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) }) );
    (function (message) { alert(message) })('De wijzigingen zijn opgeslagen');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hospiceclienten', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hospiceclienten', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/changeclientarnhem/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/changeclientarnhem/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/changeclientarnhem/components/9e0a707dbfadf7173f3ef59d3c2c41ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == 'Ziekenhuis' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/6738aecdae8610e75d9b1d82f433ffb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == 'Ziekenhuis' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a1e82e5af66cf8087a81f2c6b458f8de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/b181ee54ed538fde3029a95e3f8d8d0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/1c3fcb01a83c3096352406641ab438aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.dataModel['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.dataModel['datumoverlijdenofvertrek'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/8a02e27e7068684c8924da87d09fc544/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a934c07ff3aa5d343887dd4ffb661406/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a934c07ff3aa5d343887dd4ffb661406', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/changeclientarnhem/components/0d3212035fe30c3a1f46dc4dd0ffe815/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'status'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/13461817ad3fe3074de521c90b838a95/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'datumannulering')) == !null) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'Opname geannuleerd') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt verblijft nog in het hospice') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == null) {
    text = 'Datum overlijden of vertrek';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden') {
    text = 'Datum overlijden';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken') {
    text = 'Datum vertrek';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/b55d09849674a6f6a32e1515e003a3ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'datumannulering')) == !null) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'Opname geannuleerd') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt verblijft nog in het hospice') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.dataModel, 'datumoverlijdenofvertrek'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.dataModel['datumoverlijdenofvertrek'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/changeclientarnhem/components/b38d0465cc958e05680f4daebcbce598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    ___arguments.context.pageData['annuleren'] = true;
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['datumannulering'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['redenannulering'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['redenannuleringtoelichting'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['datumopname'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['overledenofvertrek'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['datumoverlijdenofvertrek'] = null;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4'), 'datumannulering')) == null) {
    text = 'Opname geannuleerd';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4'), 'datumannulering')) != null) {
    text = 'Annulering opname ongedaan maken';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a17f3bc9ff6fc84ccc9d50ade4d5857c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'redenannulering')) == 'Anders') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/7fa1fa855046b5d97136ea4566d728df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'redenannulering')) == 'Anders') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'redenannulering')) == 'Anders') {
    text = 'Eventuele toelichting:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/3056a7366b5aad815f98bddbfa44fe6a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'datumannulering')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1be3c5a663a90a14c1ccf8722e89db35', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79d975b6739448924eccb88c900b0749', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a89240e3e29b439e79a3ab4663f293e6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16fbf577616ba29a27475fe1fed99c8e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1123d6126c5f85cf6e4f13fdc6bb8077', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba6a4051219ffd4ee68490dd2148b2c1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be4ec31269652dba6477b081f6b8d9f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c3fcb01a83c3096352406641ab438aa', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1be3c5a663a90a14c1ccf8722e89db35', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79d975b6739448924eccb88c900b0749', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a89240e3e29b439e79a3ab4663f293e6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16fbf577616ba29a27475fe1fed99c8e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1123d6126c5f85cf6e4f13fdc6bb8077', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba6a4051219ffd4ee68490dd2148b2c1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e0a707dbfadf7173f3ef59d3c2c41ee', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6738aecdae8610e75d9b1d82f433ffb8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9be4ec31269652dba6477b081f6b8d9f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c3fcb01a83c3096352406641ab438aa', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86361ee8743da8f7d3cabd1479c4ec88', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46cf9fb564424e6f279f9b81515b7b5c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ce989ba0b8be15dace4294ac82d38a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('382d75a85e5e00c1cb28c5c754d7e094', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fa1fa855046b5d97136ea4566d728df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a17f3bc9ff6fc84ccc9d50ade4d5857c', true);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/changeclientarnhem/components/d36d7801adee7d7377243faea5bfcbe4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['annuleren'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/changeclientarnhem/components/ba6a4051219ffd4ee68490dd2148b2c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.dataModel['zorgsettingwelkziekenhuis'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a32180de7ee9bc0fae2e817ead26aef6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4'), 'datumaanmelding'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('d36d7801adee7d7377243faea5bfcbe4')['datumaanmelding'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/changeclientarnhem/components/46cf9fb564424e6f279f9b81515b7b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.dataModel, 'datumannulering'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.dataModel['datumannulering'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/79d975b6739448924eccb88c900b0749/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.dataModel, 'datumopname'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.dataModel['datumopname'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/604af339eb4795ec7c094257dca60dfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.dataModel['vptzbezoekwenselijk'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/120ea14afc1a8c6279b1a4558d6d1328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'vptzondersteuning')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/5c0b49df3338ec87c6f33fd2d5582d49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'vptzondersteuning')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/9be3d5a4f06eeea4ecfb504cb1ff8c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/9435054950db553531f8c991dbdf9671/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/24696cf6abc735d25c0733333cfbe643/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/86361ee8743da8f7d3cabd1479c4ec88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/3ce989ba0b8be15dace4294ac82d38a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/382d75a85e5e00c1cb28c5c754d7e094/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/1be3c5a663a90a14c1ccf8722e89db35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/bb78410f1a5298019aeb40661bca909d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a89240e3e29b439e79a3ab4663f293e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/16fbf577616ba29a27475fe1fed99c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/1123d6126c5f85cf6e4f13fdc6bb8077/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/9be4ec31269652dba6477b081f6b8d9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/7b0787e84f5a7df860e41823843957be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/ee3a4a9803af0ecb3565f5d3f7da1233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/d9cc5da32cf868115ae638f484a7efb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/a4f516f6326af77f900ef1356fc553b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/59a50aacaa31b71a4bc15a0c078808f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/bc6be77a59485c79dd64d66ad2f694aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden' && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/278a266b46af4c65b3b1f5b46623e138/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/8a12c93b09fb7da63085539cf2adcf4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/7c439dc2c3aaf5016c0d7356dd39fd4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/changeclientarnhem/components/bf27a8b76ae9663bdeed9377ca0fd26b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var setclientenlijst, vptzgegevens, item, records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old_code_04_11_2026() {
  vptzgegevens = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async vptzgegevens => {; return ({ [`vptzthuis`]: (getObjectProperty(vptzgegevens, 'vptzthuis')),[`vptzeigenhospice`]: (getObjectProperty(vptzgegevens, 'vptzeigenhospice')),[`vptzexternhospice`]: (getObjectProperty(vptzgegevens, 'vptzexternhospice')),[`vptzvv`]: (getObjectProperty(vptzgegevens, 'vptzvv')),[`vptzziekenhuis`]: (getObjectProperty(vptzgegevens, 'vptzziekenhuis')),[`vptzvgzggzanders`]: (getObjectProperty(vptzgegevens, 'vptzvgzggzanders')) });})))[0];
  ___arguments.context.pageData['vptzthuis'] = (getObjectProperty(vptzgegevens, 'vptzthuis'));
  ___arguments.context.pageData['vptzeigenhospice'] = (getObjectProperty(vptzgegevens, 'vptzeigenhospice'));
  ___arguments.context.pageData['vptzexternhospice'] = (getObjectProperty(vptzgegevens, 'vptzexternhospice'));
  ___arguments.context.pageData['vptzvv'] = (getObjectProperty(vptzgegevens, 'vptzvv'));
  ___arguments.context.pageData['vptzziekenhuis'] = (getObjectProperty(vptzgegevens, 'vptzziekenhuis'));
  ___arguments.context.pageData['vptzvgzggzanders'] = (getObjectProperty(vptzgegevens, 'vptzvgzggzanders'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Schutse') {
    if ((getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvv')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) == false) {
      ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
      ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
    } else {
      ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
    }
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  }
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektisbasisvestiginglijst_oud__nu_op_clientenlijst_pagina_on_page_enter() {
  records = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'vektisbasisvestiginglijst','sortBy': 'naam ASC' }));
  ___arguments.context.appData['vektisbasisvestiginglijst'] = (await Promise.all(records.map(async item => {; return ({ [`label`]: textToTitleCase([(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'plaats'))].join('')),[`value`]: (getObjectProperty(item, 'agbcode')) });})));
}


  if (!((await Backendless.UserService.getUserRoles()).includes('groningen'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['match'] = false;
  ___arguments.context.appData['listaangeduidbinnenhospice'] = [];
  ___arguments.context.appData['listaangeduidbuitenhospice'] = [];
  await Backendless.Cache.put('clientnummer', null);
  if ((getObjectProperty(___arguments.context.appData, 'clientnummer')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['hospiceindicatorenopname'] = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Schutse') {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  }
  setclientenlijst = (await Promise.all((await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async setclientenlijst => {; return ({ [`viewannuleringvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname')),[`viewinformatievraag`]: (getObjectProperty(setclientenlijst, 'viewinformatievraag')),[`viewopname`]: (getObjectProperty(setclientenlijst, 'viewopname')),[`viewoverlijden`]: (getObjectProperty(setclientenlijst, 'viewoverlijden')),[`viewuitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide')),[`viewvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewvraagvooropname')),[`labeluitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide')) });})))[0];
  ___arguments.context.pageData['viewannuleringvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname'));
  ___arguments.context.pageData['viewinformatievraag'] = (getObjectProperty(setclientenlijst, 'viewinformatievraag'));
  ___arguments.context.pageData['viewopname'] = (getObjectProperty(setclientenlijst, 'viewopname'));
  ___arguments.context.pageData['viewoverlijden'] = (getObjectProperty(setclientenlijst, 'viewoverlijden'));
  ___arguments.context.pageData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.pageData['viewvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewvraagvooropname'));
  ___arguments.context.pageData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientGroningen/components/6b227cb56c3728c9f5112deaf3943b11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg'));

  return (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/264e3b231174c9aeab18e5e6fed52158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg'));

  return (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/4142588d27adb66380091e0c1a812d57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/fff2f28c2ca2f6ebf10468ee8bc27db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvv')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/3837d9f85ca59f5edf2fa8bb7d36e23a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/9ce8cfa7be56cfe1a3ca3f1efa3be235/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/330187285767b3b231238441e30766f6/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (___arguments['value'].toUpperCase());

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientGroningen/components/4f84a379e5cea37c293465bda233a5c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function delete_clientnummer() {
  await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((await Backendless.Cache.get('clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
}


  await delete_clientnummer();
  ___arguments.context.appData['missingdata'] = false;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'traject')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/247b5fbdb914abccf32fc2b708492baf/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = ___arguments['value'];

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientGroningen/components/4931a9fc60e56d6d148f52910fcf530a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var locatiezorg, oud, clientnummer, checkcodes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datums')) == 0;
}

/**
 * Describe this function...
 */
async function oud_na_bulk_update() {
  clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
  checkcodes = (getObjectProperty(clientnummer, 'value'));
  ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
  console.log(getObjectProperty(clientnummer, 'value'));
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function velden_zichtbaar_na_create() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  } else {
    if (false) {

      ;(function() {
        const callback = async () => {
            (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('32b33d1d57d243e84288cdce88b1a6cf')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  }
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
      locatiezorg = 'Eigen hospice';
    } else {
      locatiezorg = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'locatiezorg'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    if (locatiezorg == 'Eigen hospice') {
      await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg }) );
    } else if (locatiezorg == 'Thuis') {
      await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`thuistrajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`thuistrajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`thuistrajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`thuistrajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`thuistrajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`thuistrajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg }) );
    }
    await velden_zichtbaar_na_create();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    ___arguments.context.pageData['datumschange'] = 1;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/175511af6aff69b4efe833b7ee5a98b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/7a2eb9f915892e22860d0913ed59ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/ef832b57a9c7e80b7a84069da9aabe82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/fb895fc79c7cd844ed884086afb357e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datumopnameblock'] = true;
  } else {
    ___arguments.context.pageData['datumopnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/a5ddf953a4cc11f52ca65fb23eb594e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/7d0dc8747d5df7dbc21c4ed4f587a931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/96ed0b123f897757e8a76e9f6c733cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null;

  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/13296e837dab73a758af9e86225545d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['match'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/b3d672a52cbb7edb7507ae16767e043c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/85ec01271cfa3855ca73d45f406b4d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['datums'] = 0;
  ___arguments.context.pageData['volgende'] = false;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/c28bed65058bfd48ffe5528184b9f456/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/f93fb034cf853aa3fea14ba174867615/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/f9acf8cbfca5440173e532382347c17d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/ac3eb719dce5c25da987af1b9c9277e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, checkcodes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) != true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')) == null) {
    (function (message) { alert(message) })('Achternaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) != true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')) == null) {
    (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) != true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')) == null) {
    (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) != true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) != true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) == true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'hospiceaanmeldenbijander')) == null) {
    (function (message) { alert(message) })('Geef aan of de cliënt van plan is om zich bij andere hospices aan te melden');
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = true;
    await hashpersonaldatacheck();
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`clientadres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientadres')),[`clientgeboorteplaats`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboorteplaats')),[`clientprovincie`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientprovincie')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clienttelefoonbuitenland')),[`contactpersoonadres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoonadres')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoonmail')),[`factuurtennamevan`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurtennamevan')),[`factuuradrespostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuuradrespostcode')),[`factuurwoonplaats`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurwoonplaats')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurmailadres')),[`clientkenmerk`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientkenmerk')),[`zznow`]: (new Date()),[`anoniem`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'hospiceaanmeldenbijander')),[`hospiceaanmeldenbijanderwaar`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'hospiceaanmeldenbijanderwaar')) }) ));
    clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
    checkcodes = (getObjectProperty(clientnummer, 'value'));
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
    await Backendless.Cache.put('clientnummer', (getObjectProperty(clientnummer, 'value')));
    console.log(getObjectProperty(clientnummer, 'value'));
    await Backendless.Data.of('checkcodesrequests').save( ({ [`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`clientnummerref`]: (getObjectProperty(___arguments.context.appData, 'clientnummer')),[`datumrequest`]: (new Date()),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`type`]: 'new',[`anoniem`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) }) );
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\' AND clientnummer is not null'].join(''))))) != 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64feff1498168793951929c6bd97e447', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e68f086d1a2169e1a8874319abe9a1c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28d7af0196e956ed6ce89e16e678a53a', true);
    } else {
      await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64feff1498168793951929c6bd97e447', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c78f4834f1e921eeab5332fa8ca31bf', true);
      ___arguments.context.pageData['traject'] = true;
      ___arguments.context.pageData['volgende'] = true;
    }
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/e6ccf3b4a1c33d67eec5c97d38c848ac/bundle.js', [], () => ({
  /* content */
  /* handler:contentWidthLogic */
  ['contentWidthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'volgende')) == true) {
    width = '50%';
  } else {
    width = '100%';
  }

  return width

  },
  /* handler:contentWidthLogic */
  /* content */
}))

define('./pages/clientGroningen/components/58459711e1dfd197f662ac51ce2c1c73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list, j, listnietzichtbaar;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function velden_wissen_bij_wisselen_tussen_locatiezorg_Thuis_en_Eigen_hospice() {
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'vptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'thuisvptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'zorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'thuiszorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac1261a10206661f9ba90b71d5ab258a')) === 'undefined') {
    addItemToList(list, 'verwijzernaamplaats');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac1261a10206661f9ba90b71d5ab258a')) === 'undefined') {
    addItemToList(list, 'thuisverwijzernaamplaats');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') {
    addItemToList(list, 'thuiscrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') {
    addItemToList(list, 'indicspecifiekedeskundigheid');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59b2c2d77029b68b7d52caae8b5cb14f')) === 'undefined') {
    addItemToList(list, 'indicinschatting');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19479e1cd94684548409e76d327e3c75')) === 'undefined') {
    addItemToList(list, 'indicoverbelast');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a095542b2ad24df2806387ed3ffb15b6')) === 'undefined') {
    addItemToList(list, 'indicontbrekensociaal');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6620c8c4239c3669581b3a919aeb44')) === 'undefined') {
    addItemToList(list, 'indicspecifiekewens');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('374dcd8a57abfd3b86289923d193db96')) === 'undefined') {
    addItemToList(list, 'indicteweinig');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a328b84d2f34d0337a19cee3082946c2')) === 'undefined') {
    addItemToList(list, 'indicanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8977865b67466fc30ebd552ae1edc9a')) === 'undefined') {
    addItemToList(list, 'indicgeenzicht');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') {
    addItemToList(list, 'hospiceindicatorenopnameanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') {
    addItemToList(list, 'hospicerespijtzorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') {
    addItemToList(list, 'hospicecrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerd');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdreden');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdredenander');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') {
    addItemToList(list, 'externhospicesoortondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingstabilistatie');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'thuisoverledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaaranders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'thuisoverledenofvertrekwaarnaaranders');
  }
  listnietzichtbaar = list;
  for (var j_index in listnietzichtbaar) {
    j = listnietzichtbaar[j_index];
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
  }
}


  await indictotaal();
  ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = ___arguments['value'];
  ___arguments.context.appData['missingdata'] = true;
  list = [];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) }), ({ [`label`]: 'Extern hospice',[`value`]: 'Extern hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) }), ({ [`label`]: 'V&V',[`value`]: 'V&V',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvv')) }), ({ [`label`]: 'Ziekenhuis',[`value`]: 'Ziekenhuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) }), ({ [`label`]: 'VGZ/GGZ/Anders',[`value`]: 'VGZ/GGZ/Anders',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) })];

  return [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/clientGroningen/components/837884832f0b33e48e9e43912a14ec3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/6bad11abb8ab7de257343f7a425424fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/4a897b33622261ac53dca37c2c76c033/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['hospiceredengeenondersteuning', ' hospiceredengeenondersteuninganders'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/176263ecef513566fe88673f271af7eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = null;
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['verwijzeragbcode'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listopname = ['vptzinzet', 'zorgsettingvooropname', 'verwijzer', 'verwijzeradres', 'verwijzeragbcode', 'verwijzeranders', 'verwijzeremail', 'verwijzernaamplaats', 'verwijzerplaats', 'verwijzertelefoonnummer', 'verwijzerpostcode', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders', 'hospicerespijtzorg', 'hospicecrisiszorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'externhospicesoortondersteuning'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/62964178ae736dd26e8206c33ae5794a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/de087de4a11b18b25c53935abc0ae26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['hospiceuitplaatsingstabilistatie', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/32b33d1d57d243e84288cdce88b1a6cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}


  await indictotaal();
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onBeforeMount */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}


  ___arguments.context.pageData['datumschange'] = 0;
  await indictotaal();
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientGroningen/components/2395fd42ed6e2307531dff7e7977bd8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/761c47547dc70bbf85cbd6beda4cce21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'opname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/4bdad91c62de3bb949a45defed24e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bdad91c62de3bb949a45defed24e64a')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientGroningen/components/12caf063951860b9b32585b1de579ecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e6b557641d421b9b7936ba078ff482b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/54f5b74a49316c4c9b8d5f722ffee463/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/c4ce5dbc9313e5975f41eb26f88a0599/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/b612ef93b0f539dab02e7f567eb7abf5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/b1cc754841bfc49e4b751efa23f90276/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/b51d4caab0f3a3310a6acacbcb575538/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/55637787e6fc1d1edf994e3c436ca1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/b20eac49f3df3d065e6c5fb780daa244/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['vptzinzet'] = ___arguments['value'];
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuning'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = null;

  },
  /* handler:onChange */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisvptzinzet'));
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet'));
  }

  return return2

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/clientGroningen/components/1c7731e3bfd38d0eddfeb7d37a83efb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['zorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/c4362b01d84ea74771df746c177f186f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/971ae076e945edf3f943a7d99abd13cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Andere reden') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/45c96a5c61e421f6e34cfe52556c77d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/090a373661246688dc739c8fd243851c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/482749564498712cbf649456289ceeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/59b2c2d77029b68b7d52caae8b5cb14f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/19479e1cd94684548409e76d327e3c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/a095542b2ad24df2806387ed3ffb15b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/5b6620c8c4239c3669581b3a919aeb44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/374dcd8a57abfd3b86289923d193db96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/a328b84d2f34d0337a19cee3082946c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/a8977865b67466fc30ebd552ae1edc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/b47a1f9d8fc9cf97057efa4fbe632fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9ba61fa912e8e58e72d494ae079911ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/56082a38033641474723ae4deeb480d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicerespijtzorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/2d055f7689e731a6c45e9aa1806c20f3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicecrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/013b73b4aff560d7fc96f7ba039b3d29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerd'] = ___arguments['value'];
  if (___arguments['value'] == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/e4391dbcb74c893238be47be9199c89a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/5139ca84ec7d0369e6e1cf7be163d543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/5ede8be35b67fc8d6e099f076a7ff794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/de36b5c4383f14474b621ec6f9d92c32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['externhospicesoortondersteuning'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/9a778ff795d1249519d25412114d7a25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/d8239abfdfd1cabe3f0e0523ff39b291/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceuitplaatsingstabilistatie'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/3d6ff9d91351388e8ebed71dcaa880b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/42bc26961d9dc29a7043a8541015c9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/12d2f389d4788352edec3f6d6f994153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e52a1359e76c491e5ec1c512cad13e9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, thuislocatiezorg, test, records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_voorwaarden() {
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == 'Andere reden' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'indicanders')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden';
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Extern hospice' && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null;
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan_eigen_hospice() {
  if ((getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')) != '00000000') {
    records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')),[`zorgsoort`]: (getObjectProperty(records, 'zorgsoort')) });})))[0];
    ___arguments.context.dataModel['verwijzer'] = (getObjectProperty(records, 'naam'));
    ___arguments.context.dataModel['verwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
    ___arguments.context.dataModel['verwijzeradres'] = (getObjectProperty(records, 'adres'));
    ___arguments.context.dataModel['verwijzerpostcode'] = (getObjectProperty(records, 'postcode'));
    ___arguments.context.dataModel['verwijzerplaats'] = (getObjectProperty(records, 'plaats'));
    ___arguments.context.dataModel['verwijzeremail'] = (getObjectProperty(records, 'email'));
    ___arguments.context.dataModel['verwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
    ___arguments.context.dataModel['verwijzerzorgsoort'] = (getObjectProperty(records, 'zorgsoort'));
  }
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan_thuis() {
  if ((getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')) != '00000000') {
    records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')),[`zorgsoort`]: (getObjectProperty(records, 'zorgsoort')) });})))[0];
    ___arguments.context.dataModel['thuisverwijzer'] = (getObjectProperty(records, 'naam'));
    ___arguments.context.dataModel['thuisverwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
    ___arguments.context.dataModel['thuisverwijzeradres'] = (getObjectProperty(records, 'adres'));
    ___arguments.context.dataModel['thuisverwijzerpostcode'] = (getObjectProperty(records, 'postcode'));
    ___arguments.context.dataModel['thuisverwijzerplaats'] = (getObjectProperty(records, 'plaats'));
    ___arguments.context.dataModel['thuisverwijzeremail'] = (getObjectProperty(records, 'email'));
    ___arguments.context.dataModel['thuisverwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
    ___arguments.context.dataModel['thuisverwijzerzorgsoort'] = (getObjectProperty(records, 'zorgsoort'));
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (message) { alert(message) })('De aanpassingen zijn opgeslagen');
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
    ___arguments.context.dataModel['locatiezorg'] = 'Eigen hospice';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
    thuislocatiezorg = 'Eigen hospice';
  } else {
    thuislocatiezorg = 'Thuis';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null) {
    (function (message) { alert(message) })('VPTZ inzet dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisvptzinzet')) == null) {
    (function (message) { alert(message) })('VPTZ inzet dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e246ccd5747b055e5a295446a543ab1c')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiszorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f73f7dac2817ed17b53642a475da6c1')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')) == null) {
    (function (message) { alert(message) })('de verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f73f7dac2817ed17b53642a475da6c1')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')) == null) {
    (function (message) { alert(message) })('de verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('Aanmelding binnen 24 uur van vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null) {
    (function (message) { alert(message) })('Reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 0) {
    (function (message) { alert(message) })('De meest voorkomende indicatoren om een cliënt op te nemen  dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de twee meest voorkomende indicatoren om een cliënt op te nemen ');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van respijtzorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van crisiszorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('Vul in of er sprake is van een niet gerealiseerde uitplaatsing gedurende het traject');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('Vul de reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('Vul de andere reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null) {
    (function (message) { alert(message) })('Vul in wat voor soort ondersteuning de cliënt ontvangt');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null) {
    (function (message) { alert(message) })('Vul in of de cliënt uitgeplaatst is omdat er sprake was van langdurige stabilisatie');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8efd86587bec01f30ff27f2cbedd85ad')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag waar de cliënt naar is uitgeplaatst');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('50927899bf6785c46ac6fa77d6c2dc76')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('50927899bf6785c46ac6fa77d6c2dc76')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaaranders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag waar de cliënt naar is uitgeplaatst');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      await vektis_data_opslaan_eigen_hospice();
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
      await vektis_data_opslaan_thuis();
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`thuisverwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzer')),[`thuisverwijzernaamplaats`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzernaamplaats')),[`thuisverwijzeradres`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeradres')),[`thuisverwijzerpostcode`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerpostcode')),[`thuisverwijzerplaats`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerplaats')),[`thuisverwijzeremail`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeremail')),[`thuisverwijzertelefoonnummer`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzertelefoonnummer')),[`thuisverwijzeragbcode`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')),[`thuisverwijzerzorgsoort`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerzorgsoort')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`thuistrajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatuminformatievraag')),[`thuistrajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumvraagvooropname')),[`thuistrajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')),[`thuistrajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')),[`thuistrajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')),[`thuistrajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')),[`locatiezorg`]: thuislocatiezorg,[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')),[`thuisvptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`thuiszorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuiszorgsettingvooropname')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')),[`thuisoverledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaar')),[`thuisoverledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaaranders')) }) ));
    } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`verwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzer')),[`verwijzernaamplaats`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzernaamplaats')),[`verwijzeradres`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeradres')),[`verwijzerpostcode`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerpostcode')),[`verwijzerplaats`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerplaats')),[`verwijzeremail`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeremail')),[`verwijzertelefoonnummer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzertelefoonnummer')),[`verwijzeragbcode`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')),[`verwijzerzorgsoort`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerzorgsoort')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')),[`locatiezorg`]: (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')),[`vptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.context.dataModel, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.context.dataModel, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.context.dataModel, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`overledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) }) ));
    }
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.appData['missingdata'] = false;
    ___arguments.context.pageData['bevestigingopslaan'] = true;
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/7e1a909bf40c9a713fbb25dcc82a9148/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (!___arguments.newValue) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = null;
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientGroningen/components/bec250ee0bfc77a9c52cc7437b49bcb3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'Man') {
    ___arguments.context.pageData['clientgeslacht'] = 'Man';
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'radio2') {
    ___arguments.context.pageData['clientgeslacht'] = 'Vrouw';
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'radio3') {
    ___arguments.context.pageData['clientgeslacht'] = 'Anders';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/50273806c51f2dee7ff34306b27d62e1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else if ((getObjectProperty(___arguments.context.pageData, 'EXISTING')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50273806c51f2dee7ff34306b27d62e1', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['changegeboortedatum'] = false;
  ___arguments.context.pageData['changepostcode'] = false;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/53a822af18bafd150bd1b2961d9fca2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/583b22ba2a214bcc5a9f4148de46bb0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/cd233f880b858e743956b2d65fa42cca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/089715f15ca3430b00b6a6dc0f75eb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/26ef2f3a685c0416df5eb62d074e9941/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/1aba47677cb7663e2033a1da287a8cac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9932f36b993d02b815c7afcee51c84ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/0d6c86833885bbc8d3e3ddd6dd82b6da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/acda9323b39b6f46eb9ac6393812989b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/6ba5385f0b9429275442fa0159cfee51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/6805aa117dea00b755aa736905f8526e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/a5479337e2b6c189bb9f2ecd83d21f87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/3897480d4f2cd72a3cf11f77b6154286/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e12b9ad910b9f36fcab5f72a6339790f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum uitplaatsing of uitgeleide';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum uitplaatsing';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/44452b3f574edc8351ed966d71d5ff5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false) {
    ___arguments.context.pageData['changegeboortedatum'] = true;
  } else {
    ___arguments.context.pageData['changegeboortedatum'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/726357f7c262ec3f1e1e78c3e1585d5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false) {
    ___arguments.context.pageData['changepostcode'] = true;
  } else {
    ___arguments.context.pageData['changepostcode'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/8b8d05351661e807309e303eb2f73bde/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;


  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeboortedatum'] = ___arguments['value'];

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientGroningen/components/e67e0bd7cdebb96474beb67738cfc8e5/bundle.js', [], () => ({
  /* content */
  /* handler:onValidate */
  ['onValidate'](___arguments) {
      return (___arguments['value'].toUpperCase())

  },
  /* handler:onValidate */
  /* handler:onComplete */
  ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;


  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientpostcode'] = (___arguments['value'].toUpperCase());

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientGroningen/components/5d353b9eea8b074770fcaca16066194e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, oudecode;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function test() {
  await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`clientkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientkenmerk')),[`clientadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientadres')),[`clientgeboorteplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboorteplaats')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoonbuitenland')),[`contactpersoonadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonadres')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonmail')),[`factuurtennamevan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurtennamevan')),[`factuuradrespostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuuradrespostcode')),[`factuurwoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurwoonplaats')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurmailadres')),[`contactverwijzertoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactverwijzertoelichting')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')),[`hospiceaanmeldenbijanderwaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijanderwaar')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
  console.log(['cache clientvoornaam: ',(await Backendless.Cache.get('clientvoornaam')),'property clientvoornaam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam'))].join(''));
  console.log(['cache clientgeboortenaam: ',(await Backendless.Cache.get('clientgeboortenaam')),'property clientgeboortenaam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam'))].join(''));
  console.log(['cache clientgeslacht: ',(await Backendless.Cache.get('clientgeslacht')),'property clientgeslacht: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht'))].join(''));
  console.log(['cache clientgeboortedatum: ',(await Backendless.Cache.get('clientgeboortedatum')),'property clientgeboortedatum: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum'))].join(''));
  console.log(['cache clientpostcode: ',(await Backendless.Cache.get('clientpostcode')),'property clientpostcode: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode'))].join(''));
  console.log(['cache anoniem: ',(await Backendless.Cache.get('anoniem')),'property anoniem: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem'))].join(''));
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function do_something2() {
  oudecode = (await Backendless.Cache.get('clientvoornaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) && (await Backendless.Cache.get('clientgeboortenaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) && (await Backendless.Cache.get('clientgeslacht')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) && (await Backendless.Cache.get('clientgeboortedatum')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) && (await Backendless.Cache.get('clientpostcode')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) && (await Backendless.Cache.get('anoniem')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem'));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function oude_voorwaardes() {
  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam'))) == 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      (function (message) { alert(message) })('Achternaam dient ingevuld te worden');
    }
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam'))) == 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
    }
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht'))) == 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
    }
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum'))) == 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
    }
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode'))) == 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      (function (message) { alert(message) })('Postcode dient ingevuld te worden');
    }
  } else {
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) == null) {
    (function (message) { alert(message) })('Geboortenaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) == null) {
    (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == null) {
    (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientbsn`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientbsn')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`clientadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientadres')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoonbuitenland')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonmail')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
    ___arguments.context.pageData['disablesave'] = false;
  }
}

/**
 * niet werkend gekregen hospiceaanmeldenbijander
 */
async function niet_werkend_gekregen_hospiceaanmeldenbijander() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) == true) {
      (function (message) { alert(message) })('Geef aan of de cliënt van plan is om zich bij andere hospices aan te melden');
    }
  }
}


  await hashpersonaldatacheck();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`clientkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientkenmerk')),[`clientadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientadres')),[`clientgeboorteplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboorteplaats')),[`clientprovincie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientprovincie')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoonbuitenland')),[`contactpersoonadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonadres')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonmail')),[`factuurtennamevan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurtennamevan')),[`factuuradrespostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuuradrespostcode')),[`factuurwoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurwoonplaats')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurmailadres')),[`contactverwijzertoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactverwijzertoelichting')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')),[`hospiceaanmeldenbijanderwaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijanderwaar')) }) );
  if ((await Backendless.Cache.get('clientvoornaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) && (await Backendless.Cache.get('clientgeboortenaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) && (await Backendless.Cache.get('clientgeslacht')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) && (await Backendless.Cache.get('clientgeboortedatum')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) && (await Backendless.Cache.get('clientpostcode')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) && (await Backendless.Cache.get('anoniem')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem'))) {
    ___arguments.context.pageData['isequal'] = true;
  } else {
    ___arguments.context.pageData['isequal'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'isequal')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) == true) {
      console.log('start van else');
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['spinner'] = true;
      if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
        clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
      } else {
        clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
        await Backendless.Data.of('checkcodeschangerequests').save( ({ [`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`clientnummerref`]: clientnummer,[`datumrequest`]: (new Date()),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`type`]: 'change' }) );
        await Backendless.Request.get(`${Backendless.appPath}/services/Hashing/hashsearchchange`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientvoornaam': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam'))),'clientgeboortenaam': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam'))),'clientgeslacht': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht'))),'clientgeboortedatum': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum'))),'clientpostcode': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode'))),'userobjectId': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))),'netwerkpz': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))),'clientnummerref': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer'))),'hospice': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice'))) }).send();
      }
      await new Promise(r => setTimeout(r, 3000 || 0));
      if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND clientnummer is not null'].join(''))))) != 0) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b07c24ec9f75cea7b24bb59384bb7f4', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('948f369b57f1217b6a78277c13737a75', true);
      } else {
        await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`anoniem`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) }) );
        await Backendless.Data.of('checkcodes').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
        await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer'))) }).send();
        await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
      }
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) == null) {
        (function (message) { alert(message) })('Achternaam dient ingevuld te worden');
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) == null) {
        (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == null) {
        (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) == null) {
        (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) == null) {
        (function (message) { alert(message) })('Postcode dient ingevuld te worden');
      } else {
        console.log('start van else');
        ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['spinner'] = true;
        if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
          clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
        } else {
          clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
        }
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) != true) {
          await Backendless.Data.of('checkcodeschangerequests').save( ({ [`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`clientnummerref`]: clientnummer,[`datumrequest`]: (new Date()),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`type`]: 'change' }) );
          await Backendless.Request.get(`${Backendless.appPath}/services/Hashing/hashsearchchange`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientvoornaam': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam'))),'clientgeboortenaam': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam'))),'clientgeslacht': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht'))),'clientgeboortedatum': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum'))),'clientpostcode': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode'))),'userobjectId': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))),'netwerkpz': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))),'clientnummerref': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer'))),'hospice': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice'))) }).send();
        }
        await new Promise(r => setTimeout(r, 3000 || 0));
        if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND clientnummer is not null'].join(''))))) != 0) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b07c24ec9f75cea7b24bb59384bb7f4', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('948f369b57f1217b6a78277c13737a75', true);
        } else {
          await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`anoniem`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) }) );
          await Backendless.Data.of('checkcodes').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
          await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer'))) }).send();
          await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
          await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
        }
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/9a97c8917a6ebdce2fbea0c1be0de22f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/c635a893628e43fa51ed45138e1e462e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/0d2e0b858abe7472b02569f2b2e732bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Man') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Man';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Vrouw') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Vrouw';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Anders';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/465a7d4849db94e2bc24f2cf7fb4cda8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/babed7d3e95d0ba358d6fac53735c519/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/0768b9ad5e6c6344eea51a9e9a86fdc5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/69c131ce4dbc4c4a675e83ba6a79203b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/c8790e7d3155f67aa2050d82efc1b638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'changepostcode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/af292257958cd75785961af64bff71c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'changegeboortedatum'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/28d7af0196e956ed6ce89e16e678a53a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('28d7af0196e956ed6ce89e16e678a53a', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND clientnummer is null'].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/e6d2d042784bc088b073665f9e49b272/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, listcheckcodehospicesmatchnummers, listcheckcodehospicesmatch, j, matches, item, beheerdersmailsall, beheerdersmail, beheerders, data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
}

/**
 * Describe this function...
 */
async function velden_zichtbaar_na_create() {
  data = (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100)))[0];
  if ((getObjectProperty(data, 'trajectdatumuitplaatsing')) != null) {
    if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatumopname')) != null) {
    ___arguments.context.pageData['opname'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatumannuleringvooropname')) != null) {
    ___arguments.context.pageData['annuleren'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if ((getObjectProperty(data, 'trajectdatumvraagvooropname')) != null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(data, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function when_NEW_needed_() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(data, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(data, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  } else {
  }
}


  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1) {
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkfout', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummermatch`]: (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')) }), undefined);
  } else {
    if (((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',')).indexOf(',') !== -1) {
      console.log('meerdere matches geselecteerd >80%');
      matches = (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).slice().sort(listsGetSortCompare("NUMERIC", 1));
      ___arguments.context.appData['clientnummer'] = (matches[0]);
      ___arguments.context.pageData['match'] = true;
      await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
      beheerdersmail = [];
      beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
      for (var j_index in beheerders) {
        j = beheerders[j_index];
        addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
      }
      beheerdersmailsall = beheerdersmail.join(',');
      await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelcreate80', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummergebruikt`]: matches[0],[`clientnummeraangeduid`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',') }), undefined);
    } else if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length && !(((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',')).indexOf(',') !== -1)) {
      console.log('1 match geselecteerd >80%');
      ___arguments.context.appData['clientnummer'] = (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice'));
      ___arguments.context.pageData['match'] = true;
      await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
    }
  }
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1 && !!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length) {
    console.log('100% match en >=80% matches binnen hospice');
    beheerdersmail = [];
    beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
    for (var j_index2 in beheerders) {
      j = beheerders[j_index2];
      addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
    }
    beheerdersmailsall = beheerdersmail.join(',');
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelcreate', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummergebruikt`]: (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')),[`clientnummeraangeduid`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',') }), undefined);
  }
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index3 in matches) {
      j = matches[j_index3];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index4 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index4];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
    if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
      clientnummer = (JSON.stringify((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    } else {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    }
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  }
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
    await velden_zichtbaar_na_create();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e68f086d1a2169e1a8874319abe9a1c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c78f4834f1e921eeab5332fa8ca31bf', true);
    ___arguments.context.pageData['traject'] = true;
    ___arguments.context.pageData['volgende'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/e89932161012fa539f42d60d2a6e4323/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e89932161012fa539f42d60d2a6e4323', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))).setSortBy(['hashmatch DESC', 'clientgeboortenaam ASC']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/aa7977733d63765d513b4415ed215f63/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa7977733d63765d513b4415ed215f63', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setSortBy('clientgeboortenaam ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/a061278c148b1ff466567cbe1b46089f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'hashmatch')) == true) {
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(___arguments.context.dataModel, 'clientnummer'));
    ___arguments.context.pageData['match'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/67fe641a82bb5565e6b8c357af5ed879/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var origineel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  origineel = (await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/19e8db545b8357b2b3f9aa125dfc150d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9dcfd3fef8ce11b4b4a6420ecc273a41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/de270291a31f965256a48a631503c67d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e0dad0fc8688079dce6e6e3169f6ac08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1) {
    if (___arguments.value == true) {
      addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
    } else if (___arguments.value == false) {
      (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
    }
  } else {
    if (___arguments.value == true) {
      addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
    } else if (___arguments.value == false) {
      (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
    }
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/2e68f086d1a2169e1a8874319abe9a1c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = false;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/clientGroningen/components/56470f6983baed67868ac78e39397d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/13b3133c1d5772a7ed68fdac2298960c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e492eac1fadd409413a18a81d2d16a08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/21fc5ea75c1c8f060446e5d46211e1f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false) {
    ___arguments.context.pageData['changegeboortedatum'] = true;
  } else {
    ___arguments.context.pageData['changegeboortedatum'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/b8ee5cc5026c02b2bb72ee7451386efd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false) {
    ___arguments.context.pageData['changepostcode'] = true;
  } else {
    ___arguments.context.pageData['changepostcode'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/948f369b57f1217b6a78277c13737a75/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['spinner'] = false;
  ___arguments.context.appData['listaangeduidbinnenhospice'] = [];
  ___arguments.context.appData['listaangeduidbuitenhospice'] = [];

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/clientGroningen/components/dc87c1925c15f848f47208d49ca21c76/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'hashmatch')) == true) {
    ___arguments.context.pageData['match'] = true;
    (function (message) { alert(message) })((['Er is een match binnen uw eigen hospice. Wilt u deze wijziging toch opslaan, dan ontvangt de coördinator een mail om de dossiers samen te voegen. \n','\n','Indien u de cliënt toch niet wilt wijzigen sluit dan deze pagina door op het kruisje te klikken.\n'].join('')));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/e964f3b52818d5ea8946f26dca319aa8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'clientnummer')));
    (function (message) { alert(message) })((String('Er is een match binnen uw eigen hospice. Wilt u deze wijziging toch opslaan, dan ontvangt de coördinator een mail om de cliëntdossiers samen te voegen. \n')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'clientnummer')) + 1) - 1), 1);
  }
  if (!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length) {
    ___arguments.context.pageData['match'] = false;
  } else {
    ___arguments.context.pageData['match'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/5b45e70795837ade92f9d94bcd7be354/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/618ebbeb4b6e8013b9d65183126d98fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/55a7c33ea3a46f4f89ad61fd29f15104/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/2778dbc3dd9e89c8adde15f4f8cbc75d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/20beeb7885a219eff302316a46ba0931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/f88a6c2849827c2e1ae2223e92630468/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }

  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/89266601cd5f36e519555d43bd4dd975/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, listcheckcodehospicesmatchnummers, listcheckcodehospicesmatch, j, matches, item, beheerdersmailsall, beheerdersmail, beheerders, oud, tempcheckcodehospicesmatchnummers, tempcheckcodehospicesmatch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function do_something() {
  oud = (getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(10)))[0]), 'email'));
}

/**
 * Describe this function...
 */
async function eerste_versie_matches_buiten_hospice() {
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index4 in matches) {
      j = matches[j_index4];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    tempcheckcodehospicesmatch = (getObjectProperty(((await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',clientnummer,'\''].join(''))).setProperties('checkcodehospicesmatch').setPageSize(10)))[0]), 'checkcodehospicesmatch'));
    addItemToList(listcheckcodehospicesmatch, tempcheckcodehospicesmatch);
    tempcheckcodehospicesmatchnummers = (getObjectProperty(((await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',clientnummer,'\''].join(''))).setProperties('checkcodehospicesmatchnummers').setPageSize(10)))[0]), 'checkcodehospicesmatchnummers'));
    addItemToList(listcheckcodehospicesmatchnummers, tempcheckcodehospicesmatchnummers);
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index5 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index5];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
  }
}

/**
 * Describe this function...
 */
async function oud_31_01_2025() {
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))),'oldcheckcode': JSON.stringify((await Backendless.Cache.get('oldcheckcode'))) }).send();
}


  await hashpersonaldatacheck();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: null,[`checkcodehospicesmatchnummers`]: null,[`checkcodehospicesmatchnummersaantal`]: null }) );
  if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
    beheerdersmail = [];
    beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
    for (var j_index in beheerders) {
      j = beheerders[j_index];
      addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
    }
    beheerdersmailsall = beheerdersmail.join(',');
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelchange', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummerreferentie`]: clientnummer,[`listaangeduidbinnenhospice`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(','),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  }
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index2 in matches) {
      j = matches[j_index2];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index3 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index3];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
  }
  await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`anoniem`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')),[`hospiceaanmeldenbijanderwaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijanderwaar')) }) );
  await Backendless.Data.of('checkcodes').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))),'oldcheckcode': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'oldcheckcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/5b07c24ec9f75cea7b24bb59384bb7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function niet_in_gebruik() {
  await Backendless.Cache.put('hospiceaanmeldenbijander', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')));
  await Backendless.Cache.put('hospiceaanmeldenbijanderwaar', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijanderwaar')));
}


  await Backendless.Cache.put('clientvoornaam', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')));
  await Backendless.Cache.put('clientgeboortenaam', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')));
  await Backendless.Cache.put('clientgeboortedatum', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')));
  await Backendless.Cache.put('clientgeslacht', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')));
  await Backendless.Cache.put('clientpostcode', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')));
  await Backendless.Cache.put('anoniem', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')));
  ___arguments.context.pageData['oldcheckcode'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'checkcode'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/b3fc190796ca8f55c48849d42e3aec45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var clientnummer, origineel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  origineel = (await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/2abd26fc426cf5c7d8d2be94d47734af/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2abd26fc426cf5c7d8d2be94d47734af', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setSortBy('clientgeboortenaam ASC').setGroupBy('clientnummer').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/412faae7bf76b80d1ab5f14d06926c83/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, mapmatches, item, matches, clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('412faae7bf76b80d1ab5f14d06926c83', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))).setSortBy(['hashmatch DESC', 'clientgeboortenaam ASC']).setGroupBy('clientnummer').setPageSize(100))));
  matches = (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(100)));
  mapmatches = (await Promise.all(matches.map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  for (var j_index in mapmatches) {
    j = mapmatches[j_index];
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), j);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/7f6802d7d9e1678a44b49ef57c4ffb25/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f6802d7d9e1678a44b49ef57c4ffb25', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND clientnummer is null'].join(''))).setGroupBy('clientnummer').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientGroningen/components/f8c220a6e97aba3168032c2d2fe612d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((['clientnummer van app data:',(getObjectProperty(___arguments.context.appData, 'clientnummer')),' \n','object to text:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),' \n','text to object:',(JSON.stringify((getObjectProperty(___arguments.context.appData, 'clientnummer')))),' \n'].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/d993137bdfc802fed5d61e35ba1d1387/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    if (___arguments.value == true) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = '00000000';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeranders'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = null;
    } else {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = null;
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    if (___arguments.value == true) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzer'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeradres'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = '00000000';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeranders'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeremail'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzernaamplaats'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzerplaats'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzerpostcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzertelefoonnummer'] = null;
    } else {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzer'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzernaamplaats'] = null;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/7f73f7dac2817ed17b53642a475da6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var records, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan() {
  records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = (textToTitleCase(getObjectProperty(records, 'naam')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = (textToTitleCase(getObjectProperty(records, 'adres')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = ((getObjectProperty(records, 'postcode')).toUpperCase());
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = (textToTitleCase(getObjectProperty(records, 'plaats')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = (getObjectProperty(records, 'email'));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
}


  ___arguments.context.appData['missingdata'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = ___arguments['inputValue'];
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = ___arguments['inputValue'];
  }
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['selected'] = false;

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['selected'] = false;

  },
  /* handler:onButtonClearClick */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzeragbcode'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzeragbcode'));
  }

  return return2

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/clientGroningen/components/2d2b2bd63366e0b66f26c3198711012b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function visibility_instellen() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzer'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzernaamplaats'] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9dd852e2ce819f466aa30f2c4f26292', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('404cc48c20c802dcfd6fe4666d41779d', true);
}


  await visibility_instellen();
  ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientGroningen/components/f9dd852e2ce819f466aa30f2c4f26292/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats')) != null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats')) != null;
  }

  return return2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/404cc48c20c802dcfd6fe4666d41779d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats')) == null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats')) == null;
  }

  return return2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/6ce40dceaf29c49b2d0bb161b5ecff3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/71cc3b6a67fea615683ef369cb9b967c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/651e857d2de58de76a16437f6decf8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/cdccf1e326a352dac7966512e123a093/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var nietgebruikt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  nietgebruikt = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice';

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/5077dbec107bf7458e8ca9f6554d1691/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/16e30a838c37b3bee463a5ce6be67e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/7f0f2d94fcdb878a9d8af671f88bd3ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Extern hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/f17fe7f8c3fb2147d1666cedd22c8beb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/b4a910e9779478197123e8bd3572134b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bevestigingopslaan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/bbac7fba03381b6f58d7056d5ece9143/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/81ad5f1763773f38f1cb9f470c9a0f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) != 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/8efd86587bec01f30ff27f2cbedd85ad/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['thuisoverledenofvertrekwaarnaar'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['thuisoverledenofvertrekwaarnaaranders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/50927899bf6785c46ac6fa77d6c2dc76/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['thuisoverledenofvertrekwaarnaaranders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'thuisoverledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/aa969f37d784cb69415b46cbd3aee38c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'thuisoverledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/d9d10936ba03fc55722128bf6c4bbc04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminformatievraag'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/b3db4876571754427962b2590809afa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumvraagvooropname'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/3e199711159b7a617bcb441dad94aaa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['thuisredengeenondersteuning', 'thuisredengeenondersteuninganders'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/28018ac64d321f119e2710630c3ab476/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumopname'] = null;
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['verwijzeragbcode'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    listopname = ['thuisvptzinzet', 'thuiszorgsettingvooropname', 'thuisverwijzer', 'thuisverwijzeradres', 'thuisverwijzeragbcode', 'thuisverwijzeremail', 'thuisverwijzernaamplaats', 'thuisverwijzerplaats', 'thuisverwijzertelefoonnummer', 'thuisverwijzerpostcode', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/a16e4fae5102a24fe804f1a5f19fc886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/361a4cac3a966d792c1b0b49780b11e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/7cfbaece3d9e241a8dee472cab57b33c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/a2e9f54fdc46520b8fda547e4a810165/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e246ccd5747b055e5a295446a543ab1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiszorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/ac1261a10206661f9ba90b71d5ab258a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats'));
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/62cc8dddaa6420b3fef6a293491f85f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum annulering vraag voor opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum annulering vraag voor ondersteuning thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/cdc733c8b4e586bcf10707e776fa9051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum vraag voor opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum vraag voor ondersteuning thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e25c8674c919a675713390728cb84ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum start ondersteuning thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/1b0690e7d3dd20461bab9dee7eb3e465/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzernaamplaats'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzernaamplaats'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/6875eaa3251c67a2d81c4b1c9e5df1ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzertelefoonnummer'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzertelefoonnummer'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9afd7388ae673a1cbc03dfd2b7d44b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzeremail'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzeremail'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9fa8cfdd2d35b38446189d0b73f36ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/b1a866d87d588b26ed4239e84778b14d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/e3e8a4f882c84c2294282c83ba598de8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'anoniem'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/66684dac93f8568fd3c5b90996584d58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['anoniem'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = null;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = null;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijanderwaar'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/c16cf6787528ec8ba19e13f835d75645/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/d27eb108217275186ff80fb5f5a9f7b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijanderwaar'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/87c35fb8723893b8a2e48978e5b8c5c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = 'Ja';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = 'Nee';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == 'Onbekend') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = 'Onbekend';
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'anoniem')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/9f98a708a9e8075567ff9028602cb9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/47ec2781bc52e5c8a828fafa29a8f008/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/48a74f78ba84ee98c415d5a77c2c6258/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anoniem')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/b48e2c18f4887a6871a87746a658725c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['anoniem'] = ___arguments.value;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['visible2'] = null;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = null;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijanderwaar'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/21020ea8484ecd1e64de55be82758969/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'anoniem'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/5b4b440df7db65433d8846da5e3846d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'anoniem'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientGroningen/components/dfe70128fb481da879a870f8caf88898/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijanderwaar'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientGroningen/components/759b55b8dba889c84c454cf894585cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = ___arguments.value;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijanderwaar'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var setclientenlijst, vptzgegevens, item, records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
}

/**
 * Describe this function...
 */
async function locatiezorgbepaling_enkel_gebruikt_bij_Groningen() {
  if ((getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvv')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) == false) {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
  }
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektisbasisvestiginglijst_oud__nu_op_clientenlijst_pagina_on_page_enter() {
  records = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'vektisbasisvestiginglijst','sortBy': 'naam ASC' }));
  ___arguments.context.appData['vektisbasisvestiginglijst'] = (await Promise.all(records.map(async item => {; return ({ [`label`]: textToTitleCase([(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'plaats'))].join('')),[`value`]: (getObjectProperty(item, 'agbcode')) });})));
}


  if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwe'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['match'] = false;
  ___arguments.context.appData['listaangeduidbinnenhospice'] = [];
  ___arguments.context.appData['listaangeduidbuitenhospice'] = [];
  await Backendless.Cache.put('clientnummer', null);
  if ((getObjectProperty(___arguments.context.appData, 'clientnummer')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['hospiceindicatorenopname'] = [];
  ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
  vptzgegevens = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async vptzgegevens => {; return ({ [`vptzthuis`]: (getObjectProperty(vptzgegevens, 'vptzthuis')),[`vptzeigenhospice`]: (getObjectProperty(vptzgegevens, 'vptzeigenhospice')),[`vptzexternhospice`]: (getObjectProperty(vptzgegevens, 'vptzexternhospice')),[`vptzvv`]: (getObjectProperty(vptzgegevens, 'vptzvv')),[`vptzziekenhuis`]: (getObjectProperty(vptzgegevens, 'vptzziekenhuis')),[`vptzvgzggzanders`]: (getObjectProperty(vptzgegevens, 'vptzvgzggzanders')) });})))[0];
  ___arguments.context.pageData['vptzthuis'] = (getObjectProperty(vptzgegevens, 'vptzthuis'));
  ___arguments.context.pageData['vptzeigenhospice'] = (getObjectProperty(vptzgegevens, 'vptzeigenhospice'));
  ___arguments.context.pageData['vptzexternhospice'] = (getObjectProperty(vptzgegevens, 'vptzexternhospice'));
  ___arguments.context.pageData['vptzvv'] = (getObjectProperty(vptzgegevens, 'vptzvv'));
  ___arguments.context.pageData['vptzziekenhuis'] = (getObjectProperty(vptzgegevens, 'vptzziekenhuis'));
  ___arguments.context.pageData['vptzvgzggzanders'] = (getObjectProperty(vptzgegevens, 'vptzvgzggzanders'));
  setclientenlijst = (await Promise.all((await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async setclientenlijst => {; return ({ [`viewannuleringvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname')),[`viewinformatievraag`]: (getObjectProperty(setclientenlijst, 'viewinformatievraag')),[`viewopname`]: (getObjectProperty(setclientenlijst, 'viewopname')),[`viewoverlijden`]: (getObjectProperty(setclientenlijst, 'viewoverlijden')),[`viewuitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide')),[`viewvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewvraagvooropname')),[`labeluitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide')) });})))[0];
  ___arguments.context.pageData['viewannuleringvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname'));
  ___arguments.context.pageData['viewinformatievraag'] = (getObjectProperty(setclientenlijst, 'viewinformatievraag'));
  ___arguments.context.pageData['viewopname'] = (getObjectProperty(setclientenlijst, 'viewopname'));
  ___arguments.context.pageData['viewoverlijden'] = (getObjectProperty(setclientenlijst, 'viewoverlijden'));
  ___arguments.context.pageData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.pageData['viewvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewvraagvooropname'));
  ___arguments.context.pageData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6b227cb56c3728c9f5112deaf3943b11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/264e3b231174c9aeab18e5e6fed52158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4142588d27adb66380091e0c1a812d57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/fff2f28c2ca2f6ebf10468ee8bc27db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvv')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/3837d9f85ca59f5edf2fa8bb7d36e23a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9ce8cfa7be56cfe1a3ca3f1efa3be235/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4f84a379e5cea37c293465bda233a5c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function delete_clientnummer() {
  await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((await Backendless.Cache.get('clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
}


  await delete_clientnummer();
  ___arguments.context.appData['missingdata'] = false;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'traject')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/247b5fbdb914abccf32fc2b708492baf/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = ___arguments['value'];

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4931a9fc60e56d6d148f52910fcf530a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var locatiezorg, clientnummer, checkcodes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud_na_bulk_update() {
  clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
  checkcodes = (getObjectProperty(clientnummer, 'value'));
  ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
  console.log(getObjectProperty(clientnummer, 'value'));
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function velden_zichtbaar_na_create() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['vraagvooropname'] = true;
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['vraagvooropname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
  } else {
    if (false) {

      ;(function() {
        const callback = async () => {
            (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('32b33d1d57d243e84288cdce88b1a6cf')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['vraagvooropname'] = true;
    } else {
      ___arguments.context.pageData['vraagvooropname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
  }
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminzetterminalethuiszorg')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('96ed0b123f897757e8a76e9f6c733cc2')), 'display')) == true && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('96ed0b123f897757e8a76e9f6c733cc2')), 'display')) == false) {
      locatiezorg = 'Eigen hospice';
    } else {
      locatiezorg = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'locatiezorg'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    if (locatiezorg == 'Eigen hospice') {
      await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg,[`trajectdatuminzetterminalethuiszorg`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminzetterminalethuiszorg')) }) );
    } else if (locatiezorg == 'Thuis') {
      await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`thuistrajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`thuistrajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`thuistrajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`thuistrajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`thuistrajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`thuistrajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg,[`thuistrajectdatuminzetterminalethuiszorg`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminzetterminalethuiszorg')) }) );
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
    await velden_zichtbaar_na_create();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/175511af6aff69b4efe833b7ee5a98b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7a2eb9f915892e22860d0913ed59ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['vraagvooropnameblock'] = true;
  } else {
    ___arguments.context.pageData['vraagvooropnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ef832b57a9c7e80b7a84069da9aabe82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/fb895fc79c7cd844ed884086afb357e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datumopnameblock'] = true;
  } else {
    ___arguments.context.pageData['datumopnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a5ddf953a4cc11f52ca65fb23eb594e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7d0dc8747d5df7dbc21c4ed4f587a931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/96ed0b123f897757e8a76e9f6c733cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null;

  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/13296e837dab73a758af9e86225545d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['match'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'hospice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b3d672a52cbb7edb7507ae16767e043c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/85ec01271cfa3855ca73d45f406b4d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['datums'] = 0;
  ___arguments.context.pageData['volgende'] = false;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c28bed65058bfd48ffe5528184b9f456/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f93fb034cf853aa3fea14ba174867615/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f9acf8cbfca5440173e532382347c17d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ac3eb719dce5c25da987af1b9c9277e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, checkcodes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')) == null) {
    (function (message) { alert(message) })('Achternaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')) == null) {
    (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')) == null) {
    (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Woonplaats dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'delenakkoord')) == null) {
    (function (message) { alert(message) })('De toestemming van de cliënt om gegevens te delen moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientmobiel')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clienttelefoon')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientemailadres')) == null) {
    (function (message) { alert(message) })('Een telefoonnummer of  e-mailadres moet ingevuld');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgewenst')) == null) {
    (function (message) { alert(message) })('De gewenste opnamedatum moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgepland')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgeplandonbekend')) != true) {
    (function (message) { alert(message) })('De geplande opnamedatum moet ingevuld worden, indien het onbekend is vink dan onbekend aan.');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'hospiceaanmeldenbijander')) == null) {
    (function (message) { alert(message) })('Of de cliënt zich gaat aanmelden bij andere hospices moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == null) {
    (function (message) { alert(message) })('Of de cliënt op de algemene wachtlijst moet worden geplaatst moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == 'Ja' && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatstredenniet')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt op de algemene wachtlijst geplaatst wordt moet ingevuld worden');
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = true;
    await hashpersonaldatacheck();
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`clientbsn`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientbsn')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`clientadres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientadres')),[`clientgeboorteplaats`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboorteplaats')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clienttelefoonbuitenland')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactpersoonmail')),[`factuurtennamevan`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurtennamevan')),[`factuuradrespostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuuradrespostcode')),[`factuurwoonplaats`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurwoonplaats')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'factuurmailadres')),[`contacthuisarts`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contacthuisarts')),[`contacthuisartstelefoon`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contacthuisartstelefoon')),[`contacthuisartsemail`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contacthuisartsemail')),[`opnamedatumgewenst`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgewenst')),[`opnamedatumgepland`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgepland')),[`opnamedatumgewenstonbekend`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgewenstonbekend')),[`opnamedatumgeplandonbekend`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'opnamedatumgeplandonbekend')),[`delenakkoord`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'delenakkoord')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'hospiceaanmeldenbijander')),[`contactbellenclient`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactbellenclient')),[`contactbellencontactpersoon`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactbellencontactpersoon')),[`contactbellenverwijzer`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactbellenverwijzer')),[`contactbellenhuisarts`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'contactbellenhuisarts')),[`clientvoorkeur1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoorkeur1')),[`clientvoorkeur2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoorkeur2')),[`clientdirectgeplaatst`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')),[`clientdirectgeplaatstredenniet`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatstredenniet')) }) ));
    await Backendless.Data.of('gegevensdelentoestemming').save( ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datum`]: (new Date()),[`delenakkoord`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'delenakkoord')) }) );
    clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
    checkcodes = (getObjectProperty(clientnummer, 'value'));
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
    await Backendless.Cache.put('clientnummer', (getObjectProperty(clientnummer, 'value')));
    console.log(getObjectProperty(clientnummer, 'value'));
    await Backendless.Data.of('checkcodesrequests').save( ({ [`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientwoonplaats')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`clientnummerref`]: (getObjectProperty(___arguments.context.appData, 'clientnummer')),[`datumrequest`]: (new Date()),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`type`]: 'new',[`delenakkoord`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'delenakkoord')) }) );
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\' AND clientnummer is not null'].join(''))))) != 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64feff1498168793951929c6bd97e447', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e68f086d1a2169e1a8874319abe9a1c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28d7af0196e956ed6ce89e16e678a53a', true);
    } else {
      await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64feff1498168793951929c6bd97e447', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c78f4834f1e921eeab5332fa8ca31bf', true);
      ___arguments.context.pageData['traject'] = true;
      ___arguments.context.pageData['volgende'] = true;
    }
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e6ccf3b4a1c33d67eec5c97d38c848ac/bundle.js', [], () => ({
  /* content */
  /* handler:contentWidthLogic */
  ['contentWidthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'volgende')) == true) {
    width = '50%';
  } else {
    width = '100%';
  }

  return width

  },
  /* handler:contentWidthLogic */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/58459711e1dfd197f662ac51ce2c1c73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list, j, listnietzichtbaar;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function velden_wissen_bij_wisselen_tussen_locatiezorg_Thuis_en_Eigen_hospice() {
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'vptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'thuisvptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'zorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'thuiszorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac1261a10206661f9ba90b71d5ab258a')) === 'undefined') {
    addItemToList(list, 'verwijzernaamplaats');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac1261a10206661f9ba90b71d5ab258a')) === 'undefined') {
    addItemToList(list, 'thuisverwijzernaamplaats');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') {
    addItemToList(list, 'thuiscrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') {
    addItemToList(list, 'indicspecifiekedeskundigheid');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59b2c2d77029b68b7d52caae8b5cb14f')) === 'undefined') {
    addItemToList(list, 'indicinschatting');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19479e1cd94684548409e76d327e3c75')) === 'undefined') {
    addItemToList(list, 'indicoverbelast');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a095542b2ad24df2806387ed3ffb15b6')) === 'undefined') {
    addItemToList(list, 'indicontbrekensociaal');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6620c8c4239c3669581b3a919aeb44')) === 'undefined') {
    addItemToList(list, 'indicspecifiekewens');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('374dcd8a57abfd3b86289923d193db96')) === 'undefined') {
    addItemToList(list, 'indicteweinig');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a328b84d2f34d0337a19cee3082946c2')) === 'undefined') {
    addItemToList(list, 'indicanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8977865b67466fc30ebd552ae1edc9a')) === 'undefined') {
    addItemToList(list, 'indicgeenzicht');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') {
    addItemToList(list, 'hospiceindicatorenopnameanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') {
    addItemToList(list, 'hospicerespijtzorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') {
    addItemToList(list, 'hospicecrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerd');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdreden');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdredenander');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') {
    addItemToList(list, 'externhospicesoortondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingstabilistatie');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'thuisoverledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaaranders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'thuisoverledenofvertrekwaarnaaranders');
  }
  listnietzichtbaar = list;
  for (var j_index in listnietzichtbaar) {
    j = listnietzichtbaar[j_index];
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
  }
}


  await indictotaal();
  ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = ___arguments['value'];
  ___arguments.context.appData['missingdata'] = true;
  list = [];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) }), ({ [`label`]: 'Extern hospice',[`value`]: 'Extern hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) }), ({ [`label`]: 'V&V',[`value`]: 'V&V',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvv')) }), ({ [`label`]: 'Ziekenhuis',[`value`]: 'Ziekenhuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) }), ({ [`label`]: 'VGZ/GGZ/Anders',[`value`]: 'VGZ/GGZ/Anders',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) })];

  return [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/837884832f0b33e48e9e43912a14ec3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6bad11abb8ab7de257343f7a425424fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listopname, date, listdelete;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  if (___arguments.value == null) {
    listdelete = ['vptzinzet'];
    for (var j_index2 in listdelete) {
      j = listdelete[j_index2];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = null;
    listdelete = ['hoofddiagnose', 'zorgsettingvooropname', 'hospiceredenopname', 'hospiceafwijkendgedrag', 'hospiceafwijkendgedragtoelichting', 'verwijzer', 'verwijzeradres', 'verwijzeragbcode', 'verwijzeranders', 'verwijzeremail', 'verwijzernaamplaats', 'verwijzerplaats', 'verwijzertelefoonnummer', 'verwijzerpostcode', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders'];
    for (var j_index in listdelete) {
      j = listdelete[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['vraagvooropname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['vraagvooropname'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4a897b33622261ac53dca37c2c76c033/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    listannulering = ['hospiceredengeenondersteuning', ' hospiceredengeenondersteuninganders'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/176263ecef513566fe88673f271af7eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date, j, listopname;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function oude_code() {
  if (___arguments.value == null) {
    listopname = ['zorgsettingvooropname', 'verwijzer', 'verwijzeradres', 'verwijzeragbcode', 'verwijzeranders', 'verwijzeremail', 'verwijzernaamplaats', 'verwijzerplaats', 'verwijzertelefoonnummer', 'verwijzerpostcode', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders', 'hospicerespijtzorg', 'hospicecrisiszorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'externhospicesoortondersteuning'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/62964178ae736dd26e8206c33ae5794a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/de087de4a11b18b25c53935abc0ae26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    listuitplaatsing = ['hospiceredenafsluiten', 'overledenofvertrekwaarnaar', 'hospiceredenafsluitenlocatie'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/32b33d1d57d243e84288cdce88b1a6cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}


  await indictotaal();
  ___arguments.context.pageData['hospice'] = (getObjectProperty(___arguments.context.dataModel, 'hospice'));
  ___arguments.context.pageData['clientnummer'] = (getObjectProperty(___arguments.context.dataModel, 'clientnummer'));
  ___arguments.context.pageData['woonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'clientpostcode'));
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onBeforeMount */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}


  await indictotaal();
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 500;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
          ___arguments.context.appData['missingdata'] = true;

          ;(function() {
            const callback = async () => {
                (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

            };

            const timerId = '';
            const timerDelay = 1000;

            runSetTimeout(timerId, callback, timerDelay)
          })()
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

          };

          const timerId = '';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

          };

          const timerId = '';
          const timerDelay = 1000;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) != null) {
        if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) != null) {
        } else {
          ___arguments.context.pageData['viewuitplaatsing'] = true;
        }
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
        ___arguments.context.pageData['vraagvooropname'] = true;
      } else {
        ___arguments.context.pageData['vraagvooropname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) != null) {
        ___arguments.context.pageData['opname'] = true;
      } else {
        ___arguments.context.pageData['opname'] = false;
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) != null) {
        ___arguments.context.pageData['annuleren'] = true;
      } else {
        ___arguments.context.pageData['annuleren'] = false;
      }
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2395fd42ed6e2307531dff7e7977bd8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/761c47547dc70bbf85cbd6beda4cce21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'opname'));

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4bdad91c62de3bb949a45defed24e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bdad91c62de3bb949a45defed24e64a')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/12caf063951860b9b32585b1de579ecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e6b557641d421b9b7936ba078ff482b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/54f5b74a49316c4c9b8d5f722ffee463/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c4ce5dbc9313e5975f41eb26f88a0599/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b612ef93b0f539dab02e7f567eb7abf5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b1cc754841bfc49e4b751efa23f90276/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/55637787e6fc1d1edf994e3c436ca1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1c7731e3bfd38d0eddfeb7d37a83efb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['zorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c4362b01d84ea74771df746c177f186f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/482749564498712cbf649456289ceeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/59b2c2d77029b68b7d52caae8b5cb14f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicinschatting'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicinschatting'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicinschatting'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/19479e1cd94684548409e76d327e3c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicoverbelast'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicoverbelast'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicoverbelast'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a095542b2ad24df2806387ed3ffb15b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicontbrekensociaal'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicontbrekensociaal'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicontbrekensociaal'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5b6620c8c4239c3669581b3a919aeb44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/374dcd8a57abfd3b86289923d193db96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a328b84d2f34d0337a19cee3082946c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicanders'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicanders'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['indicanders'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hospiceindicatorenopnameanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a8977865b67466fc30ebd552ae1edc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b47a1f9d8fc9cf97057efa4fbe632fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9ba61fa912e8e58e72d494ae079911ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/56082a38033641474723ae4deeb480d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicerespijtzorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2d055f7689e731a6c45e9aa1806c20f3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicecrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e4391dbcb74c893238be47be9199c89a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5139ca84ec7d0369e6e1cf7be163d543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5ede8be35b67fc8d6e099f076a7ff794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e52a1359e76c491e5ec1c512cad13e9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, thuislocatiezorg, test, records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_voorwaarden() {
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == 'Andere reden' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'indicanders')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden';
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Extern hospice' && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null;
}

/**
 * Describe this function...
 */
async function do_something2() {
  clientnummer = !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1454cec15e830e6e3746558cf036ea8b')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredenopname')) == null;
  (function (message) { alert(message) })('Reden opname dient ingevuld te worden');
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan_eigen_hospice() {
  if ((getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')) != '00000000') {
    records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')),[`zorgsoort`]: (getObjectProperty(records, 'zorgsoort')) });})))[0];
    ___arguments.context.dataModel['verwijzer'] = (getObjectProperty(records, 'naam'));
    ___arguments.context.dataModel['verwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
    ___arguments.context.dataModel['verwijzeradres'] = (getObjectProperty(records, 'adres'));
    ___arguments.context.dataModel['verwijzerpostcode'] = (getObjectProperty(records, 'postcode'));
    ___arguments.context.dataModel['verwijzerplaats'] = (getObjectProperty(records, 'plaats'));
    ___arguments.context.dataModel['verwijzeremail'] = (getObjectProperty(records, 'email'));
    ___arguments.context.dataModel['verwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
    ___arguments.context.dataModel['verwijzerzorgsoort'] = (getObjectProperty(records, 'zorgsoort'));
  }
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan_thuis() {
  if ((getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')) != '00000000') {
    records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')),[`zorgsoort`]: (getObjectProperty(records, 'zorgsoort')) });})))[0];
    ___arguments.context.dataModel['thuisverwijzer'] = (getObjectProperty(records, 'naam'));
    ___arguments.context.dataModel['thuisverwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
    ___arguments.context.dataModel['thuisverwijzeradres'] = (getObjectProperty(records, 'adres'));
    ___arguments.context.dataModel['thuisverwijzerpostcode'] = (getObjectProperty(records, 'postcode'));
    ___arguments.context.dataModel['thuisverwijzerplaats'] = (getObjectProperty(records, 'plaats'));
    ___arguments.context.dataModel['thuisverwijzeremail'] = (getObjectProperty(records, 'email'));
    ___arguments.context.dataModel['thuisverwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
    ___arguments.context.dataModel['thuisverwijzerzorgsoort'] = (getObjectProperty(records, 'zorgsoort'));
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (message) { alert(message) })('De aanpassingen zijn opgeslagen');
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
    ___arguments.context.dataModel['locatiezorg'] = 'Eigen hospice';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
    thuislocatiezorg = 'Eigen hospice';
  } else {
    thuislocatiezorg = 'Thuis';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminzetterminalethuiszorg')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminzetterminalethuiszorg')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0128c22edac245a169c64a2978d69db3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hoofddiagnose')) == null) {
    (function (message) { alert(message) })('Hoofddiagnose dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('66fb9c08f6d9a868fff8dd6a2bc890ee')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hoofddiagnoseoverige')) == null) {
    (function (message) { alert(message) })('Toelichting bij hoofddiagnose dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca7f25a2b4f0733759e80daec09dec7')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceafwijkendgedrag')) == null) {
    (function (message) { alert(message) })('Sprake van afwijkend gedrag dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e246ccd5747b055e5a295446a543ab1c')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiszorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f73f7dac2817ed17b53642a475da6c1')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')) == null) {
    (function (message) { alert(message) })('de verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f73f7dac2817ed17b53642a475da6c1')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')) == null) {
    (function (message) { alert(message) })('de verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('Aanmelding binnen 24 uur van vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 0) {
    (function (message) { alert(message) })('De meest voorkomende indicatoren om een cliënt op te nemen  dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de twee meest voorkomende indicatoren om een cliënt op te nemen ');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van respijtzorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van crisiszorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('Vul de reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('Vul de andere reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('177d257e6948f5fb59d93f38661a2ca5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredenafsluiten')) == null) {
    (function (message) { alert(message) })('Vul de reden van afsluiting in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dae1e9a506cfb6274bff4a7fefaf327c')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredenafsluitenlocatie')) == null) {
    (function (message) { alert(message) })('Vul de locatie bij reden van afsluiting in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bde9300551ebc6d66dab22313ca7ded1')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else if (false) {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      await vektis_data_opslaan_eigen_hospice();
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumvraagvooropname')) != null) {
      await vektis_data_opslaan_thuis();
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis') {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`thuisverwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzer')),[`thuisverwijzernaamplaats`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzernaamplaats')),[`thuisverwijzeradres`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeradres')),[`thuisverwijzerpostcode`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerpostcode')),[`thuisverwijzerplaats`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerplaats')),[`thuisverwijzeremail`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeremail')),[`thuisverwijzertelefoonnummer`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzertelefoonnummer')),[`thuisverwijzeragbcode`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzeragbcode')),[`thuisverwijzerzorgsoort`]: (getObjectProperty(___arguments.context.dataModel, 'thuisverwijzerzorgsoort')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`thuistrajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatuminformatievraag')),[`thuistrajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumvraagvooropname')),[`thuistrajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumannuleringvooropname')),[`thuistrajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumopname')),[`thuistrajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumoverlijden')),[`thuistrajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatumuitplaatsing')),[`locatiezorg`]: thuislocatiezorg,[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')),[`thuisvptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`thuiszorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'thuiszorgsettingvooropname')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')),[`thuisoverledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaar')),[`thuisoverledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisoverledenofvertrekwaarnaaranders')),[`thuistrajectdatuminzetterminalethuiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuistrajectdatuminzetterminalethuiszorg')) }) ));
    } else if ((getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice') {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`verwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzer')),[`verwijzernaamplaats`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzernaamplaats')),[`verwijzeradres`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeradres')),[`verwijzerpostcode`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerpostcode')),[`verwijzerplaats`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerplaats')),[`verwijzeremail`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeremail')),[`verwijzertelefoonnummer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzertelefoonnummer')),[`verwijzeragbcode`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeragbcode')),[`verwijzerzorgsoort`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerzorgsoort')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')),[`locatiezorg`]: (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')),[`vptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.context.dataModel, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.context.dataModel, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.context.dataModel, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`overledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')),[`hoofddiagnose`]: (getObjectProperty(___arguments.context.dataModel, 'hoofddiagnose')),[`hospiceafwijkendgedrag`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceafwijkendgedrag')),[`hospiceafwijkendgedragtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceafwijkendgedragtoelichting')),[`trajectdatuminzetterminalethuiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminzetterminalethuiszorg')),[`hospiceredenopname`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredenopname')),[`hospiceredenafsluiten`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredenafsluiten')),[`hospiceredenafsluitenlocatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredenafsluitenlocatie')),[`hospiceinzetlaatstedagen`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceinzetlaatstedagen')) }) ));
    }
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.appData['missingdata'] = false;
    ___arguments.context.pageData['bevestigingopslaan'] = true;
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == (getObjectProperty(___arguments.context.dataModel, 'hospice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7e1a909bf40c9a713fbb25dcc82a9148/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumopname')) != null ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (!___arguments.newValue) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = null;
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/bec250ee0bfc77a9c52cc7437b49bcb3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'Man') {
    ___arguments.context.pageData['clientgeslacht'] = 'Man';
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'radio2') {
    ___arguments.context.pageData['clientgeslacht'] = 'Vrouw';
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'visible')) == 'radio3') {
    ___arguments.context.pageData['clientgeslacht'] = 'Anders';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/50273806c51f2dee7ff34306b27d62e1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else if ((getObjectProperty(___arguments.context.pageData, 'EXISTING')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50273806c51f2dee7ff34306b27d62e1', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['changegeboortedatum'] = false;
  ___arguments.context.pageData['changepostcode'] = false;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/583b22ba2a214bcc5a9f4148de46bb0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/cd233f880b858e743956b2d65fa42cca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/089715f15ca3430b00b6a6dc0f75eb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/26ef2f3a685c0416df5eb62d074e9941/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1aba47677cb7663e2033a1da287a8cac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9932f36b993d02b815c7afcee51c84ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0d6c86833885bbc8d3e3ddd6dd82b6da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/acda9323b39b6f46eb9ac6393812989b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6ba5385f0b9429275442fa0159cfee51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6805aa117dea00b755aa736905f8526e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a5479337e2b6c189bb9f2ecd83d21f87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/3897480d4f2cd72a3cf11f77b6154286/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e12b9ad910b9f36fcab5f72a6339790f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum afsluiting zorgtraject';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum afsluiting zorgtraject';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/44452b3f574edc8351ed966d71d5ff5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false) {
    ___arguments.context.pageData['changegeboortedatum'] = true;
  } else {
    ___arguments.context.pageData['changegeboortedatum'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/726357f7c262ec3f1e1e78c3e1585d5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false) {
    ___arguments.context.pageData['changepostcode'] = true;
  } else {
    ___arguments.context.pageData['changepostcode'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/8b8d05351661e807309e303eb2f73bde/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;


  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeboortedatum'] = ___arguments['value'];

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5d353b9eea8b074770fcaca16066194e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) == null) {
    (function (message) { alert(message) })('Geboortenaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) == null) {
    (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == null) {
    (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientbsn`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientbsn')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`clientadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientadres')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')),[`clienttelefoonbuitenland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoonbuitenland')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonmail')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
    ___arguments.context.pageData['disablesave'] = false;
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientemailadres')) == null) {
    (function (message) { alert(message) })('Een telefoonnummer of e-mailadres moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) == null) {
    (function (message) { alert(message) })('De toestemming van de cliënt om gegevens te delen moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgewenst')) == null) {
    (function (message) { alert(message) })('De gewenste opnamedatum moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgepland')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgeplandonbekend')) != true) {
    (function (message) { alert(message) })('De geplande opnamedatum moet ingevuld worden, indien het onbekend is vink dan onbekend aan.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == null) {
    (function (message) { alert(message) })('Of de cliënt zich bij een ander hospice aan gaat melden moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == null) {
    (function (message) { alert(message) })('Of de cliënt op de algemene wachtlijst moet worden geplaatst moet ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatstredenniet')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt op de algemene wachtlijst geplaatst wordt moet ingevuld worden');
  } else {
    await hashpersonaldatacheck();
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`clientadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientadres')),[`clientgeboorteplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboorteplaats')),[`clientmobiel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientmobiel')),[`clienttelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clienttelefoon')),[`clientemailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientemailadres')),[`contactpersoonnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonnaam')),[`contactpersoontelefoon1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon1')),[`contactpersoontelefoon2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoontelefoon2')),[`contactpersoonmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactpersoonmail')),[`factuurtennamevan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurtennamevan')),[`factuuradrespostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuuradrespostcode')),[`factuurwoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurwoonplaats')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'factuurmailadres')),[`contacthuisarts`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contacthuisarts')),[`contacthuisartstelefoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contacthuisartstelefoon')),[`contacthuisartsemail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contacthuisartsemail')),[`opnamedatumgewenst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgewenst')),[`opnamedatumgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgepland')),[`opnamedatumgewenstonbekend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgewenstonbekend')),[`opnamedatumgeplandonbekend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'opnamedatumgeplandonbekend')),[`delenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')),[`hospiceaanmeldenbijander`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')),[`contactbellenclient`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactbellenclient')),[`contactbellencontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactbellencontactpersoon')),[`contactbellenverwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactbellenverwijzer')),[`contactbellenhuisarts`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'contactbellenhuisarts')),[`clientvoorkeur1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoorkeur1')),[`clientvoorkeur2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoorkeur2')),[`clientdirectgeplaatst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')),[`clientdirectgeplaatstredenniet`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatstredenniet')) }) );
    if ((await Backendless.Cache.get('delenakkoord')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord'))) {
      await Backendless.Data.of('gegevensdelentoestemming').save( ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datum`]: (new Date()),[`delenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) }) );
    }
    if ((await Backendless.Cache.get('clientvoornaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')) && (await Backendless.Cache.get('clientgeboortenaam')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')) && (await Backendless.Cache.get('clientgeslacht')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) && (await Backendless.Cache.get('clientgeboortedatum')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')) && (await Backendless.Cache.get('clientpostcode')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) && (await Backendless.Cache.get('delenakkoord')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord'))) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
    } else {
      if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam'))) == 0) {
        (function (message) { alert(message) })('Achternaam dient ingevuld te worden');
      } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam'))) == 0) {
        (function (message) { alert(message) })('Voornaam dient ingevuld te worden');
      } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht'))) == 0) {
        (function (message) { alert(message) })('Geslacht dient geselecteerd te worden');
      } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum'))) == 0) {
        (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
      } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode'))) == 0) {
        (function (message) { alert(message) })('Woonplaats dient ingevuld te worden');
      } else {
        ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['spinner'] = true;
        if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
          clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
        } else {
          clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
        }
        await Backendless.Data.of('checkcodeschangerequests').save( ({ [`delenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`clientnummerref`]: clientnummer,[`datumrequest`]: (new Date()),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`type`]: 'change' }) );
        await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashsearchchangebuiten`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),'userobjectId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'netwerkpz': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'clientnummerref': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer')),'hospice': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) });
        await new Promise(r => setTimeout(r, 1000 || 0));
        if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND clientnummer is not null'].join(''))))) != 0) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ccc7ad718085022622d490e44b713479', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b07c24ec9f75cea7b24bb59384bb7f4', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('948f369b57f1217b6a78277c13737a75', true);
        } else {
          await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`delenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) }) );
          await Backendless.Data.of('checkcodes').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')),[`delenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) }) );
          await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientnummer'))));
          await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
          await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');
        }
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9a97c8917a6ebdce2fbea0c1be0de22f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c635a893628e43fa51ed45138e1e462e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0d2e0b858abe7472b02569f2b2e732bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Man') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Man';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Vrouw') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Vrouw';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')) == 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible'] = 'Anders';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/465a7d4849db94e2bc24f2cf7fb4cda8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/babed7d3e95d0ba358d6fac53735c519/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0768b9ad5e6c6344eea51a9e9a86fdc5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientgeslacht'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/69c131ce4dbc4c4a675e83ba6a79203b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c8790e7d3155f67aa2050d82efc1b638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'changepostcode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/af292257958cd75785961af64bff71c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'changegeboortedatum'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/28d7af0196e956ed6ce89e16e678a53a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('28d7af0196e956ed6ce89e16e678a53a', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND clientnummer is null'].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e6d2d042784bc088b073665f9e49b272/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, listcheckcodehospicesmatchnummers, listcheckcodehospicesmatch, j, matches, item, beheerdersmailsall, beheerdersmail, beheerders, data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchall`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
}

/**
 * Describe this function...
 */
async function oud_was_ipv_checkcodehospicesmatchall() {
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
}

/**
 * Describe this function...
 */
async function velden_zichtbaar_na_create() {
  data = (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100)))[0];
  if ((getObjectProperty(data, 'trajectdatumuitplaatsing')) != null) {
    if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatumvraagvooropname')) != null) {
    ___arguments.context.pageData['vraagvooropopname'] = true;
  } else {
    ___arguments.context.pageData['vraagvooropname'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatumopname')) != null) {
    ___arguments.context.pageData['opname'] = true;
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if ((getObjectProperty(data, 'trajectdatumannuleringvooropname')) != null) {
    ___arguments.context.pageData['annuleren'] = true;
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(data, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(data, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function when_NEW_needed_() {
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(data, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(data, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(data, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(data, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  } else {
  }
}


  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1) {
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkfout', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummermatch`]: (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')) }), undefined);
  } else {
    if (((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',')).indexOf(',') !== -1) {
      console.log('meerdere matches geselecteerd >80%');
      matches = (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).slice().sort(listsGetSortCompare("NUMERIC", 1));
      ___arguments.context.appData['clientnummer'] = (matches[0]);
      ___arguments.context.pageData['match'] = true;
      await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
      beheerdersmail = [];
      beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
      for (var j_index in beheerders) {
        j = beheerders[j_index];
        addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
      }
      beheerdersmailsall = beheerdersmail.join(',');
      await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelcreate80', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummergebruikt`]: matches[0],[`clientnummeraangeduid`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',') }), undefined);
    } else if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length && !(((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',')).indexOf(',') !== -1)) {
      console.log('1 match geselecteerd >80%');
      ___arguments.context.appData['clientnummer'] = (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice'));
      ___arguments.context.pageData['match'] = true;
      await Backendless.Data.of('clienten').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
    }
  }
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1 && !!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length) {
    console.log('100% match en >=80% matches binnen hospice');
    beheerdersmail = [];
    beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
    for (var j_index2 in beheerders) {
      j = beheerders[j_index2];
      addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
    }
    beheerdersmailsall = beheerdersmail.join(',');
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelcreate', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummergebruikt`]: (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')),[`clientnummeraangeduid`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(',') }), undefined);
  }
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index3 in matches) {
      j = matches[j_index3];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index4 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index4];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
    if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
      clientnummer = (JSON.stringify((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    } else {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    }
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  }
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\''].join('')) );
  if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
    await velden_zichtbaar_na_create();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e68f086d1a2169e1a8874319abe9a1c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2c78f4834f1e921eeab5332fa8ca31bf', true);
    ___arguments.context.pageData['traject'] = true;
    ___arguments.context.pageData['volgende'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e89932161012fa539f42d60d2a6e4323/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e89932161012fa539f42d60d2a6e4323', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))).setSortBy(['hashmatch DESC', 'clientgeboortenaam ASC']).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/aa7977733d63765d513b4415ed215f63/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa7977733d63765d513b4415ed215f63', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setSortBy('clientgeboortenaam ASC').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a061278c148b1ff466567cbe1b46089f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'hashmatch')) == true) {
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(___arguments.context.dataModel, 'clientnummer'));
    ___arguments.context.pageData['match'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/67fe641a82bb5565e6b8c357af5ed879/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var origineel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  origineel = (await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true;

  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/19e8db545b8357b2b3f9aa125dfc150d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9dcfd3fef8ce11b4b4a6420ecc273a41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/de270291a31f965256a48a631503c67d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e0dad0fc8688079dce6e6e3169f6ac08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  if ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',(await Backendless.Cache.get('clientnummer')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))))) == 1) {
    if (___arguments.value == true) {
      addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
    } else if (___arguments.value == false) {
      (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
    }
  } else {
    if (___arguments.value == true) {
      addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
    } else if (___arguments.value == false) {
      (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
    }
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a061278c148b1ff466567cbe1b46089f'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2e68f086d1a2169e1a8874319abe9a1c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = false;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/56470f6983baed67868ac78e39397d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/13b3133c1d5772a7ed68fdac2298960c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e492eac1fadd409413a18a81d2d16a08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e92fe0011837b4ad12b21784463ee885'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/21fc5ea75c1c8f060446e5d46211e1f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changegeboortedatum')) == false) {
    ___arguments.context.pageData['changegeboortedatum'] = true;
  } else {
    ___arguments.context.pageData['changegeboortedatum'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b8ee5cc5026c02b2bb72ee7451386efd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'changepostcode')) == false) {
    ___arguments.context.pageData['changepostcode'] = true;
  } else {
    ___arguments.context.pageData['changepostcode'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/948f369b57f1217b6a78277c13737a75/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['spinner'] = false;
  ___arguments.context.appData['listaangeduidbinnenhospice'] = [];
  ___arguments.context.appData['listaangeduidbuitenhospice'] = [];

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/dc87c1925c15f848f47208d49ca21c76/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'hashmatch')) == true) {
    ___arguments.context.pageData['match'] = true;
    (function (message) { alert(message) })((['Er is een match binnen uw eigen hospice. Wilt u deze wijziging toch opslaan, dan ontvangt de coördinator een mail om de dossiers samen te voegen. \n','\n','Indien u de cliënt toch niet wilt wijzigen sluit dan deze pagina door op het kruisje te klikken.\n'].join('')));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e964f3b52818d5ea8946f26dca319aa8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'clientnummer')));
    (function (message) { alert(message) })((String('Er is een match binnen uw eigen hospice. Wilt u deze wijziging toch opslaan, dan ontvangt de coördinator een mail om de cliëntdossiers samen te voegen. \n')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'clientnummer')) + 1) - 1), 1);
  }
  if (!(getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).length) {
    ___arguments.context.pageData['match'] = false;
  } else {
    ___arguments.context.pageData['match'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5b45e70795837ade92f9d94bcd7be354/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/618ebbeb4b6e8013b9d65183126d98fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc87c1925c15f848f47208d49ca21c76'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/55a7c33ea3a46f4f89ad61fd29f15104/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'hashmatch')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2778dbc3dd9e89c8adde15f4f8cbc75d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'hashmatch')) == false ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/20beeb7885a219eff302316a46ba0931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'clientnummer')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).splice((((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6ae6547e62973aca4ad8ce3a9ec8911'), 'clientnummer')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f88a6c2849827c2e1ae2223e92630468/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }

  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/89266601cd5f36e519555d43bd4dd975/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, listcheckcodehospicesmatchnummers, listcheckcodehospicesmatch, j, matches, item, beheerdersmailsall, beheerdersmail, beheerders, oud, tempcheckcodehospicesmatchnummers, tempcheckcodehospicesmatch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),'clientgeboortenaam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),'clientgeslacht': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function do_something() {
  oud = (getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(10)))[0]), 'email'));
}

/**
 * Describe this function...
 */
async function eerste_versie_matches_buiten_hospice() {
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index4 in matches) {
      j = matches[j_index4];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    tempcheckcodehospicesmatch = (getObjectProperty(((await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',clientnummer,'\''].join(''))).setProperties('checkcodehospicesmatch').setPageSize(10)))[0]), 'checkcodehospicesmatch'));
    addItemToList(listcheckcodehospicesmatch, tempcheckcodehospicesmatch);
    tempcheckcodehospicesmatchnummers = (getObjectProperty(((await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',clientnummer,'\''].join(''))).setProperties('checkcodehospicesmatchnummers').setPageSize(10)))[0]), 'checkcodehospicesmatchnummers'));
    addItemToList(listcheckcodehospicesmatchnummers, tempcheckcodehospicesmatchnummers);
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index5 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index5];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatch`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify(clientnummer) }).send();
  }
}

/**
 * Describe this function...
 */
async function oud_31_01_2025() {
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))),'oldcheckcode': JSON.stringify((await Backendless.Cache.get('oldcheckcode'))) }).send();
}


  await hashpersonaldatacheck();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(clientnummer));
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: null,[`checkcodehospicesmatchnummers`]: null,[`checkcodehospicesmatchnummersaantal`]: null }) );
  if ((getObjectProperty(___arguments.context.pageData, 'match')) == true) {
    beheerdersmail = [];
    beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
    for (var j_index in beheerders) {
      j = beheerders[j_index];
      addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
    }
    beheerdersmailsall = beheerdersmail.join(',');
    await Backendless.Messaging.sendEmailFromTemplate('persoonsvergelijkdubbelchange', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`clientnummerreferentie`]: clientnummer,[`listaangeduidbinnenhospice`]: (getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')).join(','),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  }
  if (!!(getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).length) {
    listcheckcodehospicesmatch = [];
    listcheckcodehospicesmatchnummers = [];
    matches = (await Promise.all((getObjectProperty(___arguments.context.appData, 'listaangeduidbuitenhospice')).map(async item => {; return item;})));
    for (var j_index2 in matches) {
      j = matches[j_index2];
      addItemToList(listcheckcodehospicesmatch, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('hospice').setPageSize(10)))[0]), 'hospice')));
      addItemToList(listcheckcodehospicesmatchnummers, (getObjectProperty(((await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',j,'\''].join(''))).setProperties('clientnummer').setPageSize(10)))[0]), 'clientnummer')));
    }
    ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = 0;
    for (var j_index3 in listcheckcodehospicesmatchnummers) {
      j = listcheckcodehospicesmatchnummers[j_index3];
      if (j != null) {
        ___arguments.context.pageData['checkcodehospicesmatchnummersaantal'] = ((getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) + 1);
      }
    }
    await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcodehospicesmatch`]: listcheckcodehospicesmatch.join(','),[`checkcodehospicesmatchnummers`]: listcheckcodehospicesmatchnummers.join(','),[`checkcodehospicesmatchnummersaantal`]: (getObjectProperty(___arguments.context.pageData, 'checkcodehospicesmatchnummersaantal')) }) );
  }
  await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
  await Backendless.Data.of('checkcodes').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`clientvoornaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')),[`clientgeboortenaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')),[`clientgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')) }) );
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'checkcode': (await Backendless.Cache.get('hash')),'oldcheckcode': (getObjectProperty(___arguments.context.pageData, 'oldcheckcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(clientnummer));
  await Backendless.Data.of('checkcodestemp').bulkDelete( (['clientnummerref=\'',clientnummer,'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(1))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3eea6d3f1c18824b247e757dd1862f81');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5b07c24ec9f75cea7b24bb59384bb7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put('clientvoornaam', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientvoornaam')));
  await Backendless.Cache.put('clientgeboortenaam', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortenaam')));
  await Backendless.Cache.put('clientgeboortedatum', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeboortedatum')));
  await Backendless.Cache.put('clientgeslacht', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientgeslacht')));
  await Backendless.Cache.put('clientpostcode', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientpostcode')));
  await Backendless.Cache.put('delenakkoord', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')));
  ___arguments.context.pageData['oldcheckcode'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'checkcode'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b3fc190796ca8f55c48849d42e3aec45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var clientnummer, origineel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  origineel = (await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true;

  return ((await Backendless.Data.of('checkcodestemp').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2abd26fc426cf5c7d8d2be94d47734af/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2abd26fc426cf5c7d8d2be94d47734af', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice<>\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setSortBy('clientgeboortenaam ASC').setGroupBy('clientnummer').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/412faae7bf76b80d1ab5f14d06926c83/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, mapmatches, item, matches, clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('412faae7bf76b80d1ab5f14d06926c83', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer is not null'].join(''))).setSortBy(['hashmatch DESC', 'clientgeboortenaam ASC']).setGroupBy('clientnummer').setPageSize(100))));
  matches = (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND hashmatch = TRUE'].join(''))).setProperties('clientnummer').setPageSize(100)));
  mapmatches = (await Promise.all(matches.map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  for (var j_index in mapmatches) {
    j = mapmatches[j_index];
    addItemToList((getObjectProperty(___arguments.context.appData, 'listaangeduidbinnenhospice')), j);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7f6802d7d9e1678a44b49ef57c4ffb25/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f6802d7d9e1678a44b49ef57c4ffb25', (await Backendless.Data.of('checkcodestemp').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummerref=\'',clientnummer,'\' AND clientnummer is null'].join(''))).setGroupBy('clientnummer').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f8c220a6e97aba3168032c2d2fe612d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((['clientnummer van app data:',(getObjectProperty(___arguments.context.appData, 'clientnummer')),' \n','object to text:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),' \n','text to object:',(JSON.stringify((getObjectProperty(___arguments.context.appData, 'clientnummer')))),' \n'].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/d993137bdfc802fed5d61e35ba1d1387/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    if (___arguments.value == true) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = '00000000';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeranders'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = null;
    } else {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = null;
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    if (___arguments.value == true) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzer'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeradres'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = '00000000';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeranders'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeremail'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzernaamplaats'] = 'Aangemeld door de cliënt en/ of naaste zelf';
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzerplaats'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzerpostcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzertelefoonnummer'] = null;
    } else {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzer'] = null;
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzernaamplaats'] = null;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7f73f7dac2817ed17b53642a475da6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var records, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

/**
 * Describe this function...
 */
async function vektis_data_opslaan() {
  records = (await Promise.all((await Backendless.Data.of('vektisbasisvestigingstap4').find(Backendless.DataQueryBuilder.create().setWhereClause((['agbcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzeragbcode')),'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`adres`]: (getObjectProperty(records, 'adres')),[`agbcode`]: (getObjectProperty(records, 'agbcode')),[`email`]: (getObjectProperty(records, 'email')),[`naam`]: (getObjectProperty(records, 'naam')),[`plaats`]: (getObjectProperty(records, 'plaats')),[`postcode`]: (getObjectProperty(records, 'postcode')),[`telefoonnummer`]: (getObjectProperty(records, 'telefoonnummer')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = (textToTitleCase(getObjectProperty(records, 'naam')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = (textToTitleCase([(getObjectProperty(records, 'naam')),' - ',(getObjectProperty(records, 'plaats'))].join('')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = (textToTitleCase(getObjectProperty(records, 'adres')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = ((getObjectProperty(records, 'postcode')).toUpperCase());
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = (textToTitleCase(getObjectProperty(records, 'plaats')));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = (getObjectProperty(records, 'email'));
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = (getObjectProperty(records, 'telefoonnummer'));
}


  ___arguments.context.appData['missingdata'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = ___arguments['inputValue'];
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisverwijzeragbcode'] = ___arguments['inputValue'];
  }
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['selected'] = false;

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzernaamplaats'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeradres'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerpostcode'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerplaats'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeremail'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzertelefoonnummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzeragbcode'] = null;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['selected'] = false;

  },
  /* handler:onButtonClearClick */
  /* handler:valueLogic */
  ['valueLogic'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzeragbcode'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzeragbcode'));
  }

  return return2

  },
  /* handler:valueLogic */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2d2b2bd63366e0b66f26c3198711012b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function visibility_instellen() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86'), 'locatiezorg')) == 'Eigen hospice') {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['verwijzeragbcode'] = null;
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['verwijzer'] = null;
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['verwijzernaamplaats'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86'), 'locatiezorg')) == 'Thuis') {
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['thuisverwijzeragbcode'] = null;
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['thuisverwijzer'] = null;
    ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['thuisverwijzernaamplaats'] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9dd852e2ce819f466aa30f2c4f26292', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('404cc48c20c802dcfd6fe4666d41779d', true);
}


  await visibility_instellen();
  ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f9dd852e2ce819f466aa30f2c4f26292/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats')) != null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats')) != null;
  }

  return return2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/404cc48c20c802dcfd6fe4666d41779d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats')) == null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats')) == null;
  }

  return return2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6ce40dceaf29c49b2d0bb161b5ecff3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/651e857d2de58de76a16437f6decf8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5077dbec107bf7458e8ca9f6554d1691/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/16e30a838c37b3bee463a5ce6be67e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b4a910e9779478197123e8bd3572134b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bevestigingopslaan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/d9d10936ba03fc55722128bf6c4bbc04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminformatievraag'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/b3db4876571754427962b2590809afa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['vraagvooropname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da1827e191cfa9e7d5f2ee95f41228e6')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['vraagvooropname'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/3e199711159b7a617bcb441dad94aaa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['thuisredengeenondersteuning', 'thuisredengeenondersteuninganders'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/28018ac64d321f119e2710630c3ab476/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumopname'] = null;
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['verwijzeragbcode'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    listopname = ['thuisvptzinzet', 'thuiszorgsettingvooropname', 'thuisverwijzer', 'thuisverwijzeradres', 'thuisverwijzeragbcode', 'thuisverwijzeremail', 'thuisverwijzernaamplaats', 'thuisverwijzerplaats', 'thuisverwijzertelefoonnummer', 'thuisverwijzerpostcode', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a16e4fae5102a24fe804f1a5f19fc886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/361a4cac3a966d792c1b0b49780b11e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'thuistrajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7cfbaece3d9e241a8dee472cab57b33c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a2e9f54fdc46520b8fda547e4a810165/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e246ccd5747b055e5a295446a543ab1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiszorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ac1261a10206661f9ba90b71d5ab258a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzernaamplaats'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisverwijzernaamplaats'));
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/62cc8dddaa6420b3fef6a293491f85f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum annulering aanmelding voor opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum annulering aanmelding voor opname thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/cdc733c8b4e586bcf10707e776fa9051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum aanmelding voor opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum vraag voor ondersteuning thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e25c8674c919a675713390728cb84ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice') {
    text = 'Datum opname';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis') {
    text = 'Datum start ondersteuning thuis';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1b0690e7d3dd20461bab9dee7eb3e465/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzernaamplaats'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzernaamplaats'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6875eaa3251c67a2d81c4b1c9e5df1ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzertelefoonnummer'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzertelefoonnummer'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9afd7388ae673a1cbc03dfd2b7d44b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Eigen hospice') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'verwijzeremail'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'locatiezorg')) == 'Thuis') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'thuisverwijzeremail'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0b7c4d3e471dfc423b61a3b68c2e5916/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function woonplaats_opslaan() {
  records = (await Promise.all((await Backendless.Data.of('woonplaatsen').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaatscode=\'',___arguments['inputValue'],'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`woonplaats`]: (getObjectProperty(records, 'woonplaats')) });})))[0];
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (getObjectProperty(records, 'woonplaats'));
}


  await woonplaats_opslaan();

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = null;

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ccfea09f8ff85861af24e82ecb561cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientpostcode'] = '';

  },
  /* handler:onButtonClearClick */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function woonplaats_opslaan() {
  records = (await Promise.all((await Backendless.Data.of('woonplaatsen').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaatscode=\'',___arguments['inputValue'],'\''].join(''))).setPageSize(10))).map(async records => {; return ({ [`woonplaats`]: (getObjectProperty(records, 'woonplaats')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientpostcode'] = (getObjectProperty(records, 'woonplaats'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (getObjectProperty(records, 'woonplaats'));
}


  await woonplaats_opslaan();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/75b5be9b136b3415520bf18fd89a1dce/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgewenst'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgewenst'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a422382532b4f0394f6b4b8f3321b7b7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgepland'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgepland'] = (date.valueOf());
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgeplandonbekend'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/217baeefbc1e8a91a4a34b517ba1b03d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgewenst')) != null) {
    date = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgewenst'))));
  } else {
    date = null;
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5e6a63f8f9c53b18b76c8a1683a7d085/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgepland')) != null) {
    date = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgepland'))));
  } else {
    date = null;
  }

  return date

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgepland')) != null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/43ca5e66667e91f805194957ddf4d74d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgewenst'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgewenst'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9575ca444686588210262d1b2f6cc6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgepland'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgepland'] = (date.valueOf());
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgeplandonbekend'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/76b166b345ef6f3214c555e40f7c01bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientemailadres'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0666587baa43ff5fc3cb24fd7bc87c86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'vraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/0128c22edac245a169c64a2978d69db3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hoofddiagnose'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e316c4b4092b16327f823f44bf63286b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['delenakkoord'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4b28168420a9b7b9e90a849345b8f314/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['delenakkoord'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == 'Ja') {
    (function (message) { alert(message) })('Een cliënt kan niet op de algemene wachtlijst geplaatst worden als de cliënt geen toestemming geeft zijn gegevens te delen met andere hospices');
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientdirectgeplaatst'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['visible3'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1ad40b7540f6d8dd736fb89c786d1ac7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['delenakkoord'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/6094ec8611b128de19aeb168d621910e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['delenakkoord'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja') {
    (function (message) { alert(message) })('Een cliënt kan niet op de algemene wachtlijst geplaatst worden als de cliënt geen toestemming geeft zijn gegevens te delen met andere hospices');
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientdirectgeplaatst'] = null;
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible3'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/111e0d8830263773bb92fbaae9f2a0e7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible1'] = 'Ja';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible1'] = 'Nee';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1672427c57ff839abf0c958ac7ba37e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminzetterminalethuiszorg'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminzetterminalethuiszorg'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/f11cc93ea6e29142a3eabcc92db99138/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminzetterminalethuiszorg'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['thuistrajectdatuminzetterminalethuiszorg'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4065e78a4461246501f589834a689e02/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminzetterminalethuiszorg'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminzetterminalethuiszorg'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1454cec15e830e6e3746558cf036ea8b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hospiceredenopname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/a353479772ca9da73ea45196a05b7557/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['opnamedatumgepland'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/30aadbb1ae3fe693d795afab1bdfdb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['opnamedatumgepland'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/89eb88382577c38a39ffff25078103d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'opnamedatumgeplandonbekend')) != null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7ca7f25a2b4f0733759e80daec09dec7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hospiceafwijkendgedrag'] = ___arguments['value'];
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hospiceafwijkendgedragtoelichting'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/9d796c9a3495eb4b6976b8e60a2f1b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'hospiceredenafsluiten')) == 'Uitplaatsing naar andere locatie' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) != 'Thuis' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/177d257e6948f5fb59d93f38661a2ca5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceredenafsluitenlocatie'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceinzetlaatstedagen'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceredenafsluiten'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/5e6d1e45902d57b9bf08473878c64543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'hospiceredenafsluiten')) == 'Uitplaatsing naar andere locatie')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/bde9300551ebc6d66dab22313ca7ded1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = ___arguments['value'];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Thuis') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceredenafsluitenlocatie'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1aedb71b6f794db62001efcc3a980b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/7aa2fbc44912a6a689aa0842a78a5401/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1aeed1f95e41cf0763e6295bb7dba0ef/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = 'Ja';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'hospiceaanmeldenbijander')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible2'] = 'Nee';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/08a5aa6e4bb8849cd30d4f9c3c5de7da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/536f369845681be24a7e8b6d072df8e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['hospiceaanmeldenbijander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/bf97ce8552ea0d622c56a1a7c784cacb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientredennietdirectgeplaatst'] = null;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientdirectgeplaatst'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'delenakkoord')) == 'Nee')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c19e3c3e95b4fa7ab3122921646e6578/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientdirectgeplaatst'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e32a776be538a06ee04fc50adaaa275e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ac61b2ba1b563ba847fed382d46efcfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible3'] = 'Ja';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['visible3'] = 'Nee';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/50741268357ae1931a3c652b8f5163cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/1378e1cbe7323efd4de79566f7765b55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientdirectgeplaatstredenniet'] = null;
  ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientdirectgeplaatst'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'delenakkoord')) == 'Nee')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/705d2c714466911d97ba2ea362247ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b')['clientdirectgeplaatst'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/30dfa888e2f2a64a87432cb4b528563b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/98c8876ecf86d3489a76e5e337a6b132/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ce54c908bd03f78768b9ffb62ce790fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85ec01271cfa3855ca73d45f406b4d6b'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/c63b51020577c11df52ab62f4b32fa0c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/ec78b89d3762186778c80561814d93e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/796f9fdbe7d6b859a21e98fa926be25c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86'), 'hospiceafwijkendgedrag')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/da4ec6d5c1ac22e67dcac0a6aabd3996/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e2b1bdf3187a73b510b5a7296d4eff22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32b33d1d57d243e84288cdce88b1a6cf'), 'clientdirectgeplaatst')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/3fe8c728c5f8973352e807110838855a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) != (getObjectProperty(___arguments.context.pageData, 'hospice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/3d18ab373268f2b826981c053b7588d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;


  if (___arguments.value == null) {
    ___arguments.context.pageData['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.pageData['trajectdatumopname'] = (date.valueOf());
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'trajectdatumopname'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/2af8a9a85628f778ec5a7bf83e368588/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'trajectdatumopname')) == null) {
    (function (message) { alert(message) })('De opnamedatum moet eerst ingevuld worden');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e83874fbe96863c84cf33bd835184218', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/521124837bb8ea5c057a051840385e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e83874fbe96863c84cf33bd835184218', false);
  ___arguments.context.pageData['trajectdatumopname'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/64cd629907464be13bd8322db398fd08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var beheerdersmailsall, beheerdersmail, j, beheerders, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  beheerdersmail = [];
  beheerders = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\' AND beheerder = TRUE'].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return item;})));
  for (var j_index in beheerders) {
    j = beheerders[j_index];
    addItemToList(beheerdersmail, (getObjectProperty(j, 'email')));
  }
  beheerdersmailsall = beheerdersmail.join(',');
  await Backendless.Messaging.sendEmailFromTemplate('clientopgepaktvanwachtlijst', Backendless.EmailEnvelope.create({ addresses: beheerdersmailsall, ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`clientnummer`]: (getObjectProperty(___arguments.context.pageData, 'clientnummer')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`woonplaats`]: (getObjectProperty(___arguments.context.pageData, 'woonplaats')) }), undefined);
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(getObjectProperty(___arguments.context.pageData, 'clientnummer')),'\''].join('')), ({ [`trajectdatumopname`]: (getObjectProperty(___arguments.context.pageData, 'trajectdatumopname')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) }) );
  ___arguments.context.pageData['hospice'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/e5ef4ef815417b6f54194a6b0018fbc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'hospiceredenafsluiten')) == 'Overlijden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/4ecb130939484ea8b0a8bc6607587bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceinzetlaatstedagen'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/16050af8bd49b4b8a628d7f885f2d3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86')['hospiceredenopname'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientOost-Veluwe/components/95b89da82d8bc70bbbd8482fd2e82248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0666587baa43ff5fc3cb24fd7bc87c86'), 'hoofddiagnose')) == 'Overige')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var setclientenlijst, vptzgegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function locatiezorgbepaling_enkel_gebruikt_bij_Groningen() {
  if ((getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvv')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) == false) {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('zuidgelderland'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['change'] = false;
  ___arguments.context.pageData['datums'] = 0;
  if ((getObjectProperty(___arguments.context.appData, 'clientnummer')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['hospiceindicatorenopname'] = [];
  ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
  vptzgegevens = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async vptzgegevens => {; return ({ [`vptzthuis`]: (getObjectProperty(vptzgegevens, 'vptzthuis')),[`vptzeigenhospice`]: (getObjectProperty(vptzgegevens, 'vptzeigenhospice')),[`vptzexternhospice`]: (getObjectProperty(vptzgegevens, 'vptzexternhospice')),[`vptzvv`]: (getObjectProperty(vptzgegevens, 'vptzvv')),[`vptzziekenhuis`]: (getObjectProperty(vptzgegevens, 'vptzziekenhuis')),[`vptzvgzggzanders`]: (getObjectProperty(vptzgegevens, 'vptzvgzggzanders')) });})))[0];
  ___arguments.context.pageData['vptzthuis'] = (getObjectProperty(vptzgegevens, 'vptzthuis'));
  ___arguments.context.pageData['vptzeigenhospice'] = (getObjectProperty(vptzgegevens, 'vptzeigenhospice'));
  ___arguments.context.pageData['vptzexternhospice'] = (getObjectProperty(vptzgegevens, 'vptzexternhospice'));
  ___arguments.context.pageData['vptzvv'] = (getObjectProperty(vptzgegevens, 'vptzvv'));
  ___arguments.context.pageData['vptzziekenhuis'] = (getObjectProperty(vptzgegevens, 'vptzziekenhuis'));
  ___arguments.context.pageData['vptzvgzggzanders'] = (getObjectProperty(vptzgegevens, 'vptzvgzggzanders'));
  setclientenlijst = (await Promise.all((await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async setclientenlijst => {; return ({ [`viewannuleringvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname')),[`viewinformatievraag`]: (getObjectProperty(setclientenlijst, 'viewinformatievraag')),[`viewopname`]: (getObjectProperty(setclientenlijst, 'viewopname')),[`viewoverlijden`]: (getObjectProperty(setclientenlijst, 'viewoverlijden')),[`viewuitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide')),[`viewvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewvraagvooropname')),[`labeluitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide')) });})))[0];
  ___arguments.context.pageData['viewannuleringvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname'));
  ___arguments.context.pageData['viewinformatievraag'] = (getObjectProperty(setclientenlijst, 'viewinformatievraag'));
  ___arguments.context.pageData['viewopname'] = (getObjectProperty(setclientenlijst, 'viewopname'));
  ___arguments.context.pageData['viewoverlijden'] = (getObjectProperty(setclientenlijst, 'viewoverlijden'));
  ___arguments.context.pageData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.pageData['viewvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewvraagvooropname'));
  ___arguments.context.pageData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/6b227cb56c3728c9f5112deaf3943b11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/264e3b231174c9aeab18e5e6fed52158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/4142588d27adb66380091e0c1a812d57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/fff2f28c2ca2f6ebf10468ee8bc27db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvv')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/3837d9f85ca59f5edf2fa8bb7d36e23a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/9ce8cfa7be56cfe1a3ca3f1efa3be235/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/4f84a379e5cea37c293465bda233a5c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/247b5fbdb914abccf32fc2b708492baf/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function testhashsecure() {
  (function (message) { alert(message) })((await Backendless.Cache.get('hash')));
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = ___arguments['value'];
  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/4931a9fc60e56d6d148f52910fcf530a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, checkcodes, item, locatiezorg, oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datums')) == 0;
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = true;
    await hashpersonaldatacheck();
    locatiezorg = 'Eigen hospice';
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg }) ));
    clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
    checkcodes = (getObjectProperty(clientnummer, 'value'));
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
    console.log(getObjectProperty(clientnummer, 'value'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodecountzuidgelderland`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))) }).send();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/175511af6aff69b4efe833b7ee5a98b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/7a2eb9f915892e22860d0913ed59ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/ef832b57a9c7e80b7a84069da9aabe82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/fb895fc79c7cd844ed884086afb357e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datumopnameblock'] = true;
  } else {
    ___arguments.context.pageData['datumopnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a5ddf953a4cc11f52ca65fb23eb594e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/7d0dc8747d5df7dbc21c4ed4f587a931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/96ed0b123f897757e8a76e9f6c733cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/13296e837dab73a758af9e86225545d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b3d672a52cbb7edb7507ae16767e043c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/58459711e1dfd197f662ac51ce2c1c73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listnietzichtbaar, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = ___arguments['value'];
  ___arguments.context.appData['missingdata'] = true;
  list = [];
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'vptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'zorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0ac6794445d63d57d2307d575cf8a95')) === 'undefined') {
    addItemToList(list, 'verwijzer');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') {
    addItemToList(list, 'thuiscrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') {
    addItemToList(list, 'indicspecifiekedeskundigheid');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59b2c2d77029b68b7d52caae8b5cb14f')) === 'undefined') {
    addItemToList(list, 'indicinschatting');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19479e1cd94684548409e76d327e3c75')) === 'undefined') {
    addItemToList(list, 'indicoverbelast');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a095542b2ad24df2806387ed3ffb15b6')) === 'undefined') {
    addItemToList(list, 'indicontbrekensociaal');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6620c8c4239c3669581b3a919aeb44')) === 'undefined') {
    addItemToList(list, 'indicspecifiekewens');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('374dcd8a57abfd3b86289923d193db96')) === 'undefined') {
    addItemToList(list, 'indicteweinig');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a328b84d2f34d0337a19cee3082946c2')) === 'undefined') {
    addItemToList(list, 'indicanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8977865b67466fc30ebd552ae1edc9a')) === 'undefined') {
    addItemToList(list, 'indicgeenzicht');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') {
    addItemToList(list, 'hospiceindicatorenopnameanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') {
    addItemToList(list, 'hospicerespijtzorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') {
    addItemToList(list, 'hospicecrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerd');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdreden');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdredenander');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') {
    addItemToList(list, 'externhospicesoortondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingstabilistatie');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaaranders');
  }
  listnietzichtbaar = list;
  for (var j_index in listnietzichtbaar) {
    j = listnietzichtbaar[j_index];
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) }), ({ [`label`]: 'Extern hospice',[`value`]: 'Extern hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) }), ({ [`label`]: 'V&V',[`value`]: 'V&V',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvv')) }), ({ [`label`]: 'Ziekenhuis',[`value`]: 'Ziekenhuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) }), ({ [`label`]: 'VGZ/GGZ/Anders',[`value`]: 'VGZ/GGZ/Anders',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/837884832f0b33e48e9e43912a14ec3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/6bad11abb8ab7de257343f7a425424fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/4a897b33622261ac53dca37c2c76c033/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['thuisredengeenondersteuning', 'thuisredengeenondersteuninganders', 'hospiceredengeenondersteuning', ' hospiceredengeenondersteuninganders', 'annuleringcontraindicatietoelichting', 'annuleringnaamhospice', 'annuleringnaamverpleeghuis', 'annuleringtoelichting'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/176263ecef513566fe88673f271af7eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listopname = ['vptzinzet', 'zorgsettingvooropname', 'zorgsettingvooropnameanders', 'verwijzeranders', 'verwijzerziekenhuis', 'verwijzerziekenhuistoelichting', 'verwijzer', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders', 'hospicerespijtzorg', 'hospicecrisiszorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'externhospicesoortondersteuning'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/62964178ae736dd26e8206c33ae5794a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/de087de4a11b18b25c53935abc0ae26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['hospiceuitplaatsingstabilistatie', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/32b33d1d57d243e84288cdce88b1a6cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353424369994a8439a9b25aff6bfbd2c')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
}


  ___arguments.context.pageData['datumschange'] = 0;
  await indictotaal();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  } else {

    ;(function() {
      const callback = async () => {
          (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('32b33d1d57d243e84288cdce88b1a6cf')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/2395fd42ed6e2307531dff7e7977bd8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/761c47547dc70bbf85cbd6beda4cce21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'opname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/4bdad91c62de3bb949a45defed24e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bdad91c62de3bb949a45defed24e64a')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/12caf063951860b9b32585b1de579ecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e6b557641d421b9b7936ba078ff482b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/54f5b74a49316c4c9b8d5f722ffee463/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/c4ce5dbc9313e5975f41eb26f88a0599/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b612ef93b0f539dab02e7f567eb7abf5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b1cc754841bfc49e4b751efa23f90276/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/55637787e6fc1d1edf994e3c436ca1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b20eac49f3df3d065e6c5fb780daa244/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['vptzinzet'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/1c7731e3bfd38d0eddfeb7d37a83efb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['zorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/c4362b01d84ea74771df746c177f186f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/0ce3c6117ed63d3dde11e3b8fbf42482/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/971ae076e945edf3f943a7d99abd13cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Andere reden') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/c58d8635150d3c8775485c02ce710167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/342aeadd57333494e8a74c24353441b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/45c96a5c61e421f6e34cfe52556c77d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/090a373661246688dc739c8fd243851c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/482749564498712cbf649456289ceeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/59b2c2d77029b68b7d52caae8b5cb14f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/19479e1cd94684548409e76d327e3c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a095542b2ad24df2806387ed3ffb15b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/5b6620c8c4239c3669581b3a919aeb44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/374dcd8a57abfd3b86289923d193db96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a328b84d2f34d0337a19cee3082946c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a8977865b67466fc30ebd552ae1edc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b47a1f9d8fc9cf97057efa4fbe632fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/9ba61fa912e8e58e72d494ae079911ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/56082a38033641474723ae4deeb480d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicerespijtzorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a4041f861f7abbfe9722f9222c4e3aad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/2d055f7689e731a6c45e9aa1806c20f3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicecrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e556b12810f5995b9963f9f841c640cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/013b73b4aff560d7fc96f7ba039b3d29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerd'] = ___arguments['value'];
  if (___arguments['value'] == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/1c1f6179b541d5d657791f980835025c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e4391dbcb74c893238be47be9199c89a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/11187f2a048207d8c10808dbd68f9ee7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/5139ca84ec7d0369e6e1cf7be163d543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/5ede8be35b67fc8d6e099f076a7ff794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/de36b5c4383f14474b621ec6f9d92c32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['externhospicesoortondersteuning'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/3a33676308dbe89a8048726d620104e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Extern hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/9a778ff795d1249519d25412114d7a25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/d8239abfdfd1cabe3f0e0523ff39b291/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceuitplaatsingstabilistatie'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/3d6ff9d91351388e8ebed71dcaa880b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/42bc26961d9dc29a7043a8541015c9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/12d2f389d4788352edec3f6d6f994153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e52a1359e76c491e5ec1c512cad13e9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var oud, clientnummer, test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datumschange')) == 0;
}

/**
 * Describe this function...
 */
async function oude_voorwaarden() {
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == 'Andere reden' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'indicanders')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden';
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Extern hospice' && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null;
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
    ___arguments.context.dataModel['locatiezorg'] = 'Eigen hospice';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting waarom niet plaatsbaar dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')) == null) {
    (function (message) { alert(message) })('Naam hospice dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')) == null) {
    (function (message) { alert(message) })('Naam verpleeghuis dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null) {
    (function (message) { alert(message) })('VPTZ inzet dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')) == null) {
    (function (message) { alert(message) })('Toelichting op zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53d441b373243eca73e7315e56bd8aee')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')) == null) {
    (function (message) { alert(message) })('Toelichting bij verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')) == null) {
    (function (message) { alert(message) })('Welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting bij welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('Aanmelding binnen 24 uur van vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null) {
    (function (message) { alert(message) })('Reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 0) {
    (function (message) { alert(message) })('De meest voorkomende indicatoren om een cliënt op te nemen  dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de twee meest voorkomende indicatoren om een cliënt op te nemen ');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van respijtzorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van crisiszorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('Vul in of er sprake is van een niet gerealiseerde uitplaatsing gedurende het traject');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('Vul de reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('Vul de andere reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null) {
    (function (message) { alert(message) })('Vul in wat voor soort ondersteuning de cliënt ontvangt');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null) {
    (function (message) { alert(message) })('Vul in of de cliënt uitgeplaatst is omdat er sprake was van langdurige stabilisatie');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')), 'display')) == true && ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null) == null) {
    (function (message) { alert(message) })('Vul de toelichinting in bij de vraag waar de cliënt naar is uitgeplaatst');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`annuleringcontraindicatietoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')),[`annuleringnaamhospice`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')),[`annuleringnaamverpleeghuis`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')),[`annuleringtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringtoelichting')),[`zorgsettingvooropnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')),[`verwijzeranders`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')),[`verwijzerziekenhuis`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')),[`verwijzerziekenhuistoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')),[`locatiezorg`]: (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')),[`informatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'informatievraag')),[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')),[`vptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`verwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzer')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.context.dataModel, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.context.dataModel, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.context.dataModel, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`externhospicesoortondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`overledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) }) ));
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.appData['missingdata'] = false;
    ___arguments.context.pageData['bevestigingopslaan'] = true;
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/7e1a909bf40c9a713fbb25dcc82a9148/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null ? true : false));

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (!___arguments.newValue) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = null;
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/53a822af18bafd150bd1b2961d9fca2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/583b22ba2a214bcc5a9f4148de46bb0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/cd233f880b858e743956b2d65fa42cca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/089715f15ca3430b00b6a6dc0f75eb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/26ef2f3a685c0416df5eb62d074e9941/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/1aba47677cb7663e2033a1da287a8cac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/9932f36b993d02b815c7afcee51c84ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/0d6c86833885bbc8d3e3ddd6dd82b6da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/acda9323b39b6f46eb9ac6393812989b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/6ba5385f0b9429275442fa0159cfee51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/6805aa117dea00b755aa736905f8526e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/a5479337e2b6c189bb9f2ecd83d21f87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/3897480d4f2cd72a3cf11f77b6154286/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e12b9ad910b9f36fcab5f72a6339790f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/3dd1c0f207f29cb4c39ad9b5434e005e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else {
    ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['spinner'] = true;
    await hashpersonaldatacheck();
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Data.of('checkcodes').bulkUpdate( (['clientnummer=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodecountzuidgelderland`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((await Backendless.Cache.get('hash'))),'oldcheckcode': JSON.stringify((await Backendless.Cache.get('oldcheckcode'))) }).send();
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.pageData['change'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/bd9250790022e23128fe77d3864f67d2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['kenmerk'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/e4ccbecc4c73de6130aa9d8a1b77dc51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientpostcode'] = ___arguments.value;
  await searchcheckcodes();

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/88ec679d7628b0163f79cbb8d51a1853/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/da3dc4f3e36319dececa129e9c0e5a59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/1cdd178db2b7e28c57f8f3ec69298788/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['kenmerk'] = (getObjectProperty(___arguments.context.appData, 'kenmerk'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (getObjectProperty(___arguments.context.appData, 'clientpostcode'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = (getObjectProperty(___arguments.context.appData, 'clientgeboortedatum'));
  await Backendless.Cache.put('oldcheckcode', (getObjectProperty(___arguments.context.dataModel, 'checkcode')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/50273806c51f2dee7ff34306b27d62e1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50273806c51f2dee7ff34306b27d62e1', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/63cd1de5c795e644cfcbb321fb8e5264/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientgeboortedatum'] = ___arguments['value'];
  await searchcheckcodes();

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/719d0e821819ff9558abb51ef6fe4e83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/1a5a28de6ec3747ef343f9e7da4fe9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/04645dbdd7430f55096388e263ec5f28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/2993a06e8824485cc41c471c51df3f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Contra-indicatie opname')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/07bb4c7f293f995e919bfc8a9e6dcc8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/29eff59680ba58374595c4a15d3218c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Overgeplaatst naar een ander hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/c4d84565f1aca773666f3436c58b69b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Verpleeghuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/53d441b373243eca73e7315e56bd8aee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/c54335e318ef11ffb5cc27abe11e0181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/2efb01df6f6cd6c1cdd7082f4af448a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'zorgsettingvooropname')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/6cced3686ca2c84459c59be795f420e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzerziekenhuis')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/b53b85bb05b1f88b79bf13119945f346/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Ziekenhuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/7cb728d25e9f9a253c930436dfe8f87c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerziekenhuis'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/67c5db92dfeb3464e377ddd92cfddd53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Gelderland/components/2b1850b2bb8811ece866052a18ecd3d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bevestigingopslaan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var setclientenlijst, vptzgegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function locatiezorgbepaling_enkel_gebruikt_bij_Groningen() {
  if ((getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvv')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) == false) {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('zuidlimburg'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['change'] = false;
  ___arguments.context.pageData['datums'] = 0;
  if ((getObjectProperty(___arguments.context.appData, 'clientnummer')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['hospiceindicatorenopname'] = [];
  ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
  vptzgegevens = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async vptzgegevens => {; return ({ [`vptzthuis`]: (getObjectProperty(vptzgegevens, 'vptzthuis')),[`vptzeigenhospice`]: (getObjectProperty(vptzgegevens, 'vptzeigenhospice')),[`vptzexternhospice`]: (getObjectProperty(vptzgegevens, 'vptzexternhospice')),[`vptzvv`]: (getObjectProperty(vptzgegevens, 'vptzvv')),[`vptzziekenhuis`]: (getObjectProperty(vptzgegevens, 'vptzziekenhuis')),[`vptzvgzggzanders`]: (getObjectProperty(vptzgegevens, 'vptzvgzggzanders')) });})))[0];
  ___arguments.context.pageData['vptzthuis'] = (getObjectProperty(vptzgegevens, 'vptzthuis'));
  ___arguments.context.pageData['vptzeigenhospice'] = (getObjectProperty(vptzgegevens, 'vptzeigenhospice'));
  ___arguments.context.pageData['vptzexternhospice'] = (getObjectProperty(vptzgegevens, 'vptzexternhospice'));
  ___arguments.context.pageData['vptzvv'] = (getObjectProperty(vptzgegevens, 'vptzvv'));
  ___arguments.context.pageData['vptzziekenhuis'] = (getObjectProperty(vptzgegevens, 'vptzziekenhuis'));
  ___arguments.context.pageData['vptzvgzggzanders'] = (getObjectProperty(vptzgegevens, 'vptzvgzggzanders'));
  setclientenlijst = (await Promise.all((await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async setclientenlijst => {; return ({ [`viewannuleringvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname')),[`viewinformatievraag`]: (getObjectProperty(setclientenlijst, 'viewinformatievraag')),[`viewopname`]: (getObjectProperty(setclientenlijst, 'viewopname')),[`viewoverlijden`]: (getObjectProperty(setclientenlijst, 'viewoverlijden')),[`viewuitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide')),[`viewvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewvraagvooropname')),[`labeluitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide')) });})))[0];
  ___arguments.context.pageData['viewannuleringvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname'));
  ___arguments.context.pageData['viewinformatievraag'] = (getObjectProperty(setclientenlijst, 'viewinformatievraag'));
  ___arguments.context.pageData['viewopname'] = (getObjectProperty(setclientenlijst, 'viewopname'));
  ___arguments.context.pageData['viewoverlijden'] = (getObjectProperty(setclientenlijst, 'viewoverlijden'));
  ___arguments.context.pageData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.pageData['viewvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewvraagvooropname'));
  ___arguments.context.pageData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/6b227cb56c3728c9f5112deaf3943b11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/264e3b231174c9aeab18e5e6fed52158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4142588d27adb66380091e0c1a812d57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/fff2f28c2ca2f6ebf10468ee8bc27db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvv')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/3837d9f85ca59f5edf2fa8bb7d36e23a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/9ce8cfa7be56cfe1a3ca3f1efa3be235/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4f84a379e5cea37c293465bda233a5c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/247b5fbdb914abccf32fc2b708492baf/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function testhashsecure() {
  (function (message) { alert(message) })((await Backendless.Cache.get('hash')));
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = ___arguments['value'];
  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4931a9fc60e56d6d148f52910fcf530a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, checkcodes, item, locatiezorg, oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datums')) == 0;
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = true;
    await hashpersonaldatacheck();
    locatiezorg = 'Eigen hospice';
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg }) ));
    clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
    checkcodes = (getObjectProperty(clientnummer, 'value'));
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
    console.log(getObjectProperty(clientnummer, 'value'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodezuidlimburg`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'checkcode': (await Backendless.Cache.get('hash')) });
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/175511af6aff69b4efe833b7ee5a98b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/7a2eb9f915892e22860d0913ed59ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/ef832b57a9c7e80b7a84069da9aabe82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/fb895fc79c7cd844ed884086afb357e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datumopnameblock'] = true;
  } else {
    ___arguments.context.pageData['datumopnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a5ddf953a4cc11f52ca65fb23eb594e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/7d0dc8747d5df7dbc21c4ed4f587a931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/96ed0b123f897757e8a76e9f6c733cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/13296e837dab73a758af9e86225545d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b3d672a52cbb7edb7507ae16767e043c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/58459711e1dfd197f662ac51ce2c1c73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listnietzichtbaar, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = ___arguments['value'];
  ___arguments.context.appData['missingdata'] = true;
  list = [];
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'vptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'zorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0ac6794445d63d57d2307d575cf8a95')) === 'undefined') {
    addItemToList(list, 'verwijzer');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') {
    addItemToList(list, 'thuiscrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') {
    addItemToList(list, 'indicspecifiekedeskundigheid');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59b2c2d77029b68b7d52caae8b5cb14f')) === 'undefined') {
    addItemToList(list, 'indicinschatting');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19479e1cd94684548409e76d327e3c75')) === 'undefined') {
    addItemToList(list, 'indicoverbelast');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a095542b2ad24df2806387ed3ffb15b6')) === 'undefined') {
    addItemToList(list, 'indicontbrekensociaal');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6620c8c4239c3669581b3a919aeb44')) === 'undefined') {
    addItemToList(list, 'indicspecifiekewens');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('374dcd8a57abfd3b86289923d193db96')) === 'undefined') {
    addItemToList(list, 'indicteweinig');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a328b84d2f34d0337a19cee3082946c2')) === 'undefined') {
    addItemToList(list, 'indicanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8977865b67466fc30ebd552ae1edc9a')) === 'undefined') {
    addItemToList(list, 'indicgeenzicht');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') {
    addItemToList(list, 'hospiceindicatorenopnameanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') {
    addItemToList(list, 'hospicerespijtzorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') {
    addItemToList(list, 'hospicecrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerd');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdreden');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdredenander');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') {
    addItemToList(list, 'externhospicesoortondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingstabilistatie');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaaranders');
  }
  listnietzichtbaar = list;
  for (var j_index in listnietzichtbaar) {
    j = listnietzichtbaar[j_index];
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) }), ({ [`label`]: 'Extern hospice',[`value`]: 'Extern hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) }), ({ [`label`]: 'V&V',[`value`]: 'V&V',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvv')) }), ({ [`label`]: 'Ziekenhuis',[`value`]: 'Ziekenhuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) }), ({ [`label`]: 'VGZ/GGZ/Anders',[`value`]: 'VGZ/GGZ/Anders',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/837884832f0b33e48e9e43912a14ec3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/6bad11abb8ab7de257343f7a425424fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4a897b33622261ac53dca37c2c76c033/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['thuisredengeenondersteuning', 'thuisredengeenondersteuninganders', 'hospiceredengeenondersteuning', ' hospiceredengeenondersteuninganders', 'annuleringcontraindicatietoelichting', 'annuleringnaamhospice', 'annuleringnaamverpleeghuis', 'annuleringtoelichting'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/176263ecef513566fe88673f271af7eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listopname = ['vptzinzet', 'zorgsettingvooropname', 'zorgsettingvooropnameanders', 'verwijzeranders', 'verwijzerziekenhuis', 'verwijzerziekenhuistoelichting', 'verwijzer', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders', 'hospicerespijtzorg', 'hospicecrisiszorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'externhospicesoortondersteuning'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/62964178ae736dd26e8206c33ae5794a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['overlijden'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4038a6d4a2d8bb1fbce8fb085108d2d8')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['overlijden'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/de087de4a11b18b25c53935abc0ae26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['hospiceuitplaatsingstabilistatie', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/32b33d1d57d243e84288cdce88b1a6cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353424369994a8439a9b25aff6bfbd2c')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
}


  ___arguments.context.pageData['datumschange'] = 0;
  await indictotaal();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['overlijden'] = true;
      ___arguments.context.appData['missingdata'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['overlijden'] = false;
    }
  } else {

    ;(function() {
      const callback = async () => {
          (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('32b33d1d57d243e84288cdce88b1a6cf')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['overlijden'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['overlijden'] = false;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/2395fd42ed6e2307531dff7e7977bd8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/761c47547dc70bbf85cbd6beda4cce21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'opname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4bdad91c62de3bb949a45defed24e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bdad91c62de3bb949a45defed24e64a')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/12caf063951860b9b32585b1de579ecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e6b557641d421b9b7936ba078ff482b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/54f5b74a49316c4c9b8d5f722ffee463/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/c4ce5dbc9313e5975f41eb26f88a0599/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b612ef93b0f539dab02e7f567eb7abf5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b1cc754841bfc49e4b751efa23f90276/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/55637787e6fc1d1edf994e3c436ca1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b20eac49f3df3d065e6c5fb780daa244/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['vptzinzet'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/1c7731e3bfd38d0eddfeb7d37a83efb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['zorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/c4362b01d84ea74771df746c177f186f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/0ce3c6117ed63d3dde11e3b8fbf42482/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/971ae076e945edf3f943a7d99abd13cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Andere reden') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/c58d8635150d3c8775485c02ce710167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/342aeadd57333494e8a74c24353441b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/45c96a5c61e421f6e34cfe52556c77d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/090a373661246688dc739c8fd243851c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/482749564498712cbf649456289ceeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/59b2c2d77029b68b7d52caae8b5cb14f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/19479e1cd94684548409e76d327e3c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a095542b2ad24df2806387ed3ffb15b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/5b6620c8c4239c3669581b3a919aeb44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/374dcd8a57abfd3b86289923d193db96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a328b84d2f34d0337a19cee3082946c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a8977865b67466fc30ebd552ae1edc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b47a1f9d8fc9cf97057efa4fbe632fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/9ba61fa912e8e58e72d494ae079911ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/56082a38033641474723ae4deeb480d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicerespijtzorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a4041f861f7abbfe9722f9222c4e3aad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/2d055f7689e731a6c45e9aa1806c20f3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicecrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e556b12810f5995b9963f9f841c640cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/013b73b4aff560d7fc96f7ba039b3d29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerd'] = ___arguments['value'];
  if (___arguments['value'] == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/1c1f6179b541d5d657791f980835025c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e4391dbcb74c893238be47be9199c89a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/11187f2a048207d8c10808dbd68f9ee7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/5139ca84ec7d0369e6e1cf7be163d543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/5ede8be35b67fc8d6e099f076a7ff794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/de36b5c4383f14474b621ec6f9d92c32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['externhospicesoortondersteuning'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/3a33676308dbe89a8048726d620104e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Extern hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/9a778ff795d1249519d25412114d7a25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/d8239abfdfd1cabe3f0e0523ff39b291/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceuitplaatsingstabilistatie'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/3d6ff9d91351388e8ebed71dcaa880b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/42bc26961d9dc29a7043a8541015c9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/12d2f389d4788352edec3f6d6f994153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e52a1359e76c491e5ec1c512cad13e9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var oud, clientnummer, test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datumschange')) == 0;
}

/**
 * Describe this function...
 */
async function oude_voorwaarden() {
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == 'Andere reden' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'indicanders')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden';
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Extern hospice' && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null;
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
    ___arguments.context.dataModel['locatiezorg'] = 'Eigen hospice';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting waarom niet plaatsbaar dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')) == null) {
    (function (message) { alert(message) })('Naam hospice dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')) == null) {
    (function (message) { alert(message) })('Naam verpleeghuis dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null) {
    (function (message) { alert(message) })('VPTZ inzet dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')) == null) {
    (function (message) { alert(message) })('Toelichting op zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53d441b373243eca73e7315e56bd8aee')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')) == null) {
    (function (message) { alert(message) })('Toelichting bij verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')) == null) {
    (function (message) { alert(message) })('Welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting bij welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('Aanmelding binnen 24 uur van vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null) {
    (function (message) { alert(message) })('Reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 0) {
    (function (message) { alert(message) })('De meest voorkomende indicatoren om een cliënt op te nemen  dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de twee meest voorkomende indicatoren om een cliënt op te nemen ');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van respijtzorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van crisiszorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('Vul in of er sprake is van een niet gerealiseerde uitplaatsing gedurende het traject');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('Vul de reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('Vul de andere reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null) {
    (function (message) { alert(message) })('Vul in wat voor soort ondersteuning de cliënt ontvangt');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null) {
    (function (message) { alert(message) })('Vul in of de cliënt uitgeplaatst is omdat er sprake was van langdurige stabilisatie');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')), 'display')) == true && ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag waar de cliënt naar is uitgeplaatst');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4038a6d4a2d8bb1fbce8fb085108d2d8')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekte')) == null) {
    (function (message) { alert(message) })('Vul in wat de meest voorkomende onderliggende ziekte bij overlijden is.');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e148090895d881a863345da6b1987208')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e148090895d881a863345da6b1987208')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekteanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag wat is de meest voorkomende onderliggende ziekte bij overlijden.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`overledenmeestvoorkomendeziekte`]: (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekte')),[`overledenmeestvoorkomendeziekteanders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekteanders')),[`annuleringcontraindicatietoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')),[`annuleringnaamhospice`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')),[`annuleringnaamverpleeghuis`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')),[`annuleringtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringtoelichting')),[`zorgsettingvooropnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')),[`verwijzeranders`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')),[`verwijzerziekenhuis`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')),[`verwijzerziekenhuistoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')),[`locatiezorg`]: (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')),[`informatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'informatievraag')),[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')),[`vptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`verwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzer')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.context.dataModel, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.context.dataModel, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.context.dataModel, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`externhospicesoortondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`overledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')),[`overledenaanvullendbsted`]: (getObjectProperty(___arguments.context.dataModel, 'overledenaanvullendbsted')),[`overledenaanvullendeuthanasie`]: (getObjectProperty(___arguments.context.dataModel, 'overledenaanvullendeuthanasie')),[`overledenaanvullendsedatie`]: (getObjectProperty(___arguments.context.dataModel, 'overledenaanvullendsedatie')) }) ));
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.appData['missingdata'] = false;
    ___arguments.context.pageData['bevestigingopslaan'] = true;
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/7e1a909bf40c9a713fbb25dcc82a9148/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null ? true : false));

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (!___arguments.newValue) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = null;
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/53a822af18bafd150bd1b2961d9fca2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/583b22ba2a214bcc5a9f4148de46bb0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/cd233f880b858e743956b2d65fa42cca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/089715f15ca3430b00b6a6dc0f75eb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/26ef2f3a685c0416df5eb62d074e9941/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/1aba47677cb7663e2033a1da287a8cac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/9932f36b993d02b815c7afcee51c84ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/0d6c86833885bbc8d3e3ddd6dd82b6da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/acda9323b39b6f46eb9ac6393812989b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/6ba5385f0b9429275442fa0159cfee51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/6805aa117dea00b755aa736905f8526e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a5479337e2b6c189bb9f2ecd83d21f87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/3897480d4f2cd72a3cf11f77b6154286/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e12b9ad910b9f36fcab5f72a6339790f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/3dd1c0f207f29cb4c39ad9b5434e005e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else {
    ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['spinner'] = true;
    await hashpersonaldatacheck();
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Data.of('checkcodes').bulkUpdate( (['clientnummer=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodezuidlimburg`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'checkcode': (await Backendless.Cache.get('hash')),'oldcheckcode': (await Backendless.Cache.get('oldcheckcode')) });
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.pageData['change'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/bd9250790022e23128fe77d3864f67d2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['kenmerk'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e4ccbecc4c73de6130aa9d8a1b77dc51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientpostcode'] = ___arguments.value;
  await searchcheckcodes();

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/88ec679d7628b0163f79cbb8d51a1853/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/da3dc4f3e36319dececa129e9c0e5a59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/1cdd178db2b7e28c57f8f3ec69298788/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['kenmerk'] = (getObjectProperty(___arguments.context.appData, 'kenmerk'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (getObjectProperty(___arguments.context.appData, 'clientpostcode'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = (getObjectProperty(___arguments.context.appData, 'clientgeboortedatum'));
  await Backendless.Cache.put('oldcheckcode', (getObjectProperty(___arguments.context.dataModel, 'checkcode')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/50273806c51f2dee7ff34306b27d62e1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50273806c51f2dee7ff34306b27d62e1', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/63cd1de5c795e644cfcbb321fb8e5264/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientgeboortedatum'] = ___arguments['value'];
  await searchcheckcodes();

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/719d0e821819ff9558abb51ef6fe4e83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/1a5a28de6ec3747ef343f9e7da4fe9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/04645dbdd7430f55096388e263ec5f28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/2993a06e8824485cc41c471c51df3f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Contra-indicatie opname')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/07bb4c7f293f995e919bfc8a9e6dcc8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/29eff59680ba58374595c4a15d3218c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Overgeplaatst naar een ander hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/c4d84565f1aca773666f3436c58b69b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Verpleeghuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/53d441b373243eca73e7315e56bd8aee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/c54335e318ef11ffb5cc27abe11e0181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/2efb01df6f6cd6c1cdd7082f4af448a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'zorgsettingvooropname')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/6cced3686ca2c84459c59be795f420e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzerziekenhuis')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/b53b85bb05b1f88b79bf13119945f346/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Ziekenhuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/7cb728d25e9f9a253c930436dfe8f87c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerziekenhuis'] = ___arguments['value'];
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerziekenhuistoelichting'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/67c5db92dfeb3464e377ddd92cfddd53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/2b1850b2bb8811ece866052a18ecd3d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bevestigingopslaan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/e148090895d881a863345da6b1987208/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788'), 'overledenmeestvoorkomendeziekte')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekteanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/33021ada079828b821de56c87e56e788/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'overlijden'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('33021ada079828b821de56c87e56e788')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/d5e1bd589e580c4deea79bd8ee17ad77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788'), 'overledenmeestvoorkomendeziekte')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/4038a6d4a2d8bb1fbce8fb085108d2d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekte'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekteanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/73587635e3864458f3c81508cb5dde98/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendbsted'] = true;
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendbsted'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/83d89f288f72ff67c967a04122ac46ba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendeuthanasie'] = true;
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendeuthanasie'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg/components/a598a9056a986f4eaff965b999e8d6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendsedatie'] = true;
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenaanvullendsedatie'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var setclientenlijst, vptzgegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('zuidlimburg'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['change'] = false;
  ___arguments.context.pageData['datums'] = 0;
  if ((getObjectProperty(___arguments.context.appData, 'clientnummer')) == null) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['hospiceindicatorenopname'] = [];
  vptzgegevens = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async vptzgegevens => {; return ({ [`vptzthuis`]: (getObjectProperty(vptzgegevens, 'vptzthuis')),[`vptzeigenhospice`]: (getObjectProperty(vptzgegevens, 'vptzeigenhospice')),[`vptzexternhospice`]: (getObjectProperty(vptzgegevens, 'vptzexternhospice')),[`vptzvv`]: (getObjectProperty(vptzgegevens, 'vptzvv')),[`vptzziekenhuis`]: (getObjectProperty(vptzgegevens, 'vptzziekenhuis')),[`vptzvgzggzanders`]: (getObjectProperty(vptzgegevens, 'vptzvgzggzanders')) });})))[0];
  ___arguments.context.pageData['vptzthuis'] = (getObjectProperty(vptzgegevens, 'vptzthuis'));
  ___arguments.context.pageData['vptzeigenhospice'] = (getObjectProperty(vptzgegevens, 'vptzeigenhospice'));
  ___arguments.context.pageData['vptzexternhospice'] = (getObjectProperty(vptzgegevens, 'vptzexternhospice'));
  ___arguments.context.pageData['vptzvv'] = (getObjectProperty(vptzgegevens, 'vptzvv'));
  ___arguments.context.pageData['vptzziekenhuis'] = (getObjectProperty(vptzgegevens, 'vptzziekenhuis'));
  ___arguments.context.pageData['vptzvgzggzanders'] = (getObjectProperty(vptzgegevens, 'vptzvgzggzanders'));
  if ((getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvv')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) == false && (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) == false) {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = false;
    ___arguments.context.pageData['locatiezorg'] = 'Eigen hospice';
  } else {
    ___arguments.context.pageData['viewwaarontvangtdepatientdezorg'] = true;
  }
  setclientenlijst = (await Promise.all((await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))).map(async setclientenlijst => {; return ({ [`viewannuleringvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname')),[`viewinformatievraag`]: (getObjectProperty(setclientenlijst, 'viewinformatievraag')),[`viewopname`]: (getObjectProperty(setclientenlijst, 'viewopname')),[`viewoverlijden`]: (getObjectProperty(setclientenlijst, 'viewoverlijden')),[`viewuitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide')),[`viewvraagvooropname`]: (getObjectProperty(setclientenlijst, 'viewvraagvooropname')),[`labeluitplaatsingofuitgeleide`]: (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide')) });})))[0];
  ___arguments.context.pageData['viewannuleringvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewannuleringvraagvooropname'));
  ___arguments.context.pageData['viewinformatievraag'] = (getObjectProperty(setclientenlijst, 'viewinformatievraag'));
  ___arguments.context.pageData['viewopname'] = (getObjectProperty(setclientenlijst, 'viewopname'));
  ___arguments.context.pageData['viewoverlijden'] = (getObjectProperty(setclientenlijst, 'viewoverlijden'));
  ___arguments.context.pageData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.pageData['viewvraagvooropname'] = (getObjectProperty(setclientenlijst, 'viewvraagvooropname'));
  ___arguments.context.pageData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(setclientenlijst, 'labeluitplaatsingofuitgeleide'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/6b227cb56c3728c9f5112deaf3943b11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzthuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/264e3b231174c9aeab18e5e6fed52158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4142588d27adb66380091e0c1a812d57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/fff2f28c2ca2f6ebf10468ee8bc27db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvv')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/3837d9f85ca59f5edf2fa8bb7d36e23a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/9ce8cfa7be56cfe1a3ca3f1efa3be235/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == true ? (getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) : (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4f84a379e5cea37c293465bda233a5c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/247b5fbdb914abccf32fc2b708492baf/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function testhashsecure() {
  (function (message) { alert(message) })((await Backendless.Cache.get('hash')));
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = ___arguments['value'];
  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4931a9fc60e56d6d148f52910fcf530a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, checkcodes, item, locatiezorg, oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datums')) == 0;
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['spinner'] = true;
    await hashpersonaldatacheck();
    locatiezorg = 'Eigen hospice';
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['NEW'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`checkcode`]: (await Backendless.Cache.get('hash')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumuitplaatsing')),[`locatiezorg`]: locatiezorg }) ));
    clientnummer = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'created ASC','properties': ['clientnummer'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'clientnummer')) });}))).slice(-1)[0];
    checkcodes = (getObjectProperty(clientnummer, 'value'));
    ___arguments.context.appData['clientnummer'] = (getObjectProperty(clientnummer, 'value'));
    console.log(getObjectProperty(clientnummer, 'value'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',(getObjectProperty(___arguments.context.appData, 'clientnummer')),'\''].join(''))).setPageSize(1))));
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodezuidlimburg`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'checkcode': (await Backendless.Cache.get('hash')) });
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e6ccf3b4a1c33d67eec5c97d38c848ac');
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/175511af6aff69b4efe833b7ee5a98b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/7a2eb9f915892e22860d0913ed59ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/ef832b57a9c7e80b7a84069da9aabe82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/fb895fc79c7cd844ed884086afb357e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datumopnameblock'] = true;
  } else {
    ___arguments.context.pageData['datumopnameblock'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumopname'] = null;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['locatiezorg'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a5ddf953a4cc11f52ca65fb23eb594e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/7d0dc8747d5df7dbc21c4ed4f587a931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == null) {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) + 1);
  } else {
    ___arguments.context.pageData['datums'] = ((getObjectProperty(___arguments.context.pageData, 'datums')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/96ed0b123f897757e8a76e9f6c733cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'trajectdatumopname')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/13296e837dab73a758af9e86225545d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b3d672a52cbb7edb7507ae16767e043c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/58459711e1dfd197f662ac51ce2c1c73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, listnietzichtbaar, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = ___arguments['value'];
  ___arguments.context.appData['missingdata'] = true;
  list = [];
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') {
    addItemToList(list, 'thuisredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') {
    addItemToList(list, 'hospiceredengeenondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') {
    addItemToList(list, 'vptzinzet');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') {
    addItemToList(list, 'zorgsettingvooropname');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0ac6794445d63d57d2307d575cf8a95')) === 'undefined') {
    addItemToList(list, 'verwijzer');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') {
    addItemToList(list, 'thuiscrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') {
    addItemToList(list, 'thuisbehoefteondersteuninganders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('482749564498712cbf649456289ceeca')) === 'undefined') {
    addItemToList(list, 'indicspecifiekedeskundigheid');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59b2c2d77029b68b7d52caae8b5cb14f')) === 'undefined') {
    addItemToList(list, 'indicinschatting');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19479e1cd94684548409e76d327e3c75')) === 'undefined') {
    addItemToList(list, 'indicoverbelast');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a095542b2ad24df2806387ed3ffb15b6')) === 'undefined') {
    addItemToList(list, 'indicontbrekensociaal');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6620c8c4239c3669581b3a919aeb44')) === 'undefined') {
    addItemToList(list, 'indicspecifiekewens');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('374dcd8a57abfd3b86289923d193db96')) === 'undefined') {
    addItemToList(list, 'indicteweinig');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a328b84d2f34d0337a19cee3082946c2')) === 'undefined') {
    addItemToList(list, 'indicanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8977865b67466fc30ebd552ae1edc9a')) === 'undefined') {
    addItemToList(list, 'indicgeenzicht');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') {
    addItemToList(list, 'hospiceindicatorenopnameanders');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') {
    addItemToList(list, 'hospicerespijtzorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') {
    addItemToList(list, 'hospicecrisiszorg');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerd');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdreden');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingnietgerealiseerdredenander');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') {
    addItemToList(list, 'externhospicesoortondersteuning');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') {
    addItemToList(list, 'hospiceuitplaatsingstabilistatie');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaar');
  }
  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') {
    addItemToList(list, 'overledenofvertrekwaarnaaranders');
  }
  listnietzichtbaar = list;
  for (var j_index in listnietzichtbaar) {
    j = listnietzichtbaar[j_index];
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
  }

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ [`label`]: 'Thuis',[`value`]: 'Thuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzthuis')) }), ({ [`label`]: 'Eigen hospice',[`value`]: 'Eigen hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzeigenhospice')) }), ({ [`label`]: 'Extern hospice',[`value`]: 'Extern hospice',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzexternhospice')) }), ({ [`label`]: 'V&V',[`value`]: 'V&V',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvv')) }), ({ [`label`]: 'Ziekenhuis',[`value`]: 'Ziekenhuis',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzziekenhuis')) }), ({ [`label`]: 'VGZ/GGZ/Anders',[`value`]: 'VGZ/GGZ/Anders',[`checked`]: 'visible',[`disabled`]: !(getObjectProperty(___arguments.context.pageData, 'vptzvgzggzanders')) })]

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/837884832f0b33e48e9e43912a14ec3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatuminformatievraag`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatuminformatievraag'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/6bad11abb8ab7de257343f7a425424fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumvraagvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumvraagvooropname'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4a897b33622261ac53dca37c2c76c033/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listannulering, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumannuleringvooropname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumannuleringvooropname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['annuleren'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listannulering = ['thuisredengeenondersteuning', 'thuisredengeenondersteuninganders', 'hospiceredengeenondersteuning', ' hospiceredengeenondersteuninganders', 'annuleringcontraindicatietoelichting', 'annuleringnaamhospice', 'annuleringnaamverpleeghuis', 'annuleringtoelichting'];
    for (var j_index in listannulering) {
      j = listannulering[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/176263ecef513566fe88673f271af7eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listopname, date;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumopname`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumopname'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    ___arguments.context.appData['missingdata'] = true;
    ___arguments.context.pageData['opname'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['opname'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listopname = ['vptzinzet', 'zorgsettingvooropname', 'zorgsettingvooropnameanders', 'verwijzeranders', 'verwijzerziekenhuis', 'verwijzerziekenhuistoelichting', 'verwijzer', 'thuiscrisiszorg', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'indicspecifiekedeskundigheid', 'indicinschatting', 'indicoverbelast', 'indicontbrekensociaal', 'indicspecifiekewens', 'indicteweinig', 'indicanders', 'indicgeenzicht', 'hospiceindicatorenopnameanders', 'hospicerespijtzorg', 'hospicecrisiszorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'externhospicesoortondersteuning'];
    for (var j_index in listopname) {
      j = listopname[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/62964178ae736dd26e8206c33ae5794a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumoverlijden`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumoverlijden'] = (date.valueOf());
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }
  if (___arguments.value == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumuitplaatsing')) != null) {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value != null) {
    ___arguments.context.pageData['overlijden'] = true;

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4038a6d4a2d8bb1fbce8fb085108d2d8')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['overlijden'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/de087de4a11b18b25c53935abc0ae26d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, listuitplaatsing, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: null }) );
  await Backendless.Data.of('clienten').bulkUpdate( (['clientnummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))),'\''].join('')), ({ [`trajectdatumuitplaatsing`]: (date.valueOf()) }) );
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == null) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = null;
  } else {
    date = (new Date(___arguments.value));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['trajectdatumuitplaatsing'] = (date.valueOf());
  }
  if (___arguments.value != null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumoverlijden')) != null) {
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  } else {
    ___arguments.context.pageData['viewuitplaatsing'] = false;
  }
  if (___arguments.value == null) {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) - 1);
    listuitplaatsing = ['hospiceuitplaatsingstabilistatie', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders'];
    for (var j_index in listuitplaatsing) {
      j = listuitplaatsing[j_index];
      ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')[j] = null;
    }
  } else {
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/32b33d1d57d243e84288cdce88b1a6cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function indictotaal() {
  ___arguments.context.pageData['indictotaal'] = 0;
  if ((getObjectProperty(___arguments.context.dataModel, 'indicanders')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicinschatting')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'indicteweinig')) == '1') {
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);

    ;(function() {
      const callback = async () => {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('353424369994a8439a9b25aff6bfbd2c')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
    ___arguments.context.pageData['viewinformatievraag'] = true;
    ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
  } else {
    ___arguments.context.pageData['viewinformatievraag'] = false;
  }
}


  ___arguments.context.pageData['datumschange'] = 0;
  await indictotaal();
  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
        ___arguments.context.appData['missingdata'] = true;

        ;(function() {
          const callback = async () => {
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('203f31076b8310165f2a7b46807ec3b6')));

          };

          const timerId = '';
          const timerDelay = 500;

          runSetTimeout(timerId, callback, timerDelay)
        })()
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('806d0d522be9b83e2b1a691e46178412')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      ___arguments.context.appData['missingdata'] = true;

      ;(function() {
        const callback = async () => {
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('862e3e1bad65ce457793240bbbd5b133')));

        };

        const timerId = '';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['overlijden'] = true;
      ___arguments.context.appData['missingdata'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['overlijden'] = false;
    }
  } else {

    ;(function() {
      const callback = async () => {
          (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('32b33d1d57d243e84288cdce88b1a6cf')));

      };

      const timerId = '';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null) {
      if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      } else {
        ___arguments.context.pageData['viewuitplaatsing'] = true;
        ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
      }
    } else {
      ___arguments.context.pageData['viewuitplaatsing'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null) {
      ___arguments.context.pageData['opname'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['opname'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null) {
      ___arguments.context.pageData['annuleren'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['annuleren'] = false;
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null) {
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) != null) {
      ___arguments.context.pageData['overlijden'] = true;
      ___arguments.context.pageData['datumschange'] = ((getObjectProperty(___arguments.context.pageData, 'datumschange')) + 1);
    } else {
      ___arguments.context.pageData['overlijden'] = false;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/2395fd42ed6e2307531dff7e7977bd8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/761c47547dc70bbf85cbd6beda4cce21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'opname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4bdad91c62de3bb949a45defed24e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewuitplaatsing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bdad91c62de3bb949a45defed24e64a')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/12caf063951860b9b32585b1de579ecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Thuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e6b557641d421b9b7936ba078ff482b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/54f5b74a49316c4c9b8d5f722ffee463/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/c4ce5dbc9313e5975f41eb26f88a0599/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'thuisredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['thuisredengeenondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b612ef93b0f539dab02e7f567eb7abf5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b1cc754841bfc49e4b751efa23f90276/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b')['hospiceredengeenondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/55637787e6fc1d1edf994e3c436ca1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b20eac49f3df3d065e6c5fb780daa244/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['vptzinzet'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/1c7731e3bfd38d0eddfeb7d37a83efb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['zorgsettingvooropname'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/c4362b01d84ea74771df746c177f186f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuiscrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/0ce3c6117ed63d3dde11e3b8fbf42482/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/971ae076e945edf3f943a7d99abd13cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuning'] = ___arguments['value'];
  if (___arguments['value'] != 'Andere reden') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/c58d8635150d3c8775485c02ce710167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Thuis';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/342aeadd57333494e8a74c24353441b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/45c96a5c61e421f6e34cfe52556c77d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/090a373661246688dc739c8fd243851c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'thuisbehoefteondersteuning')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['thuisbehoefteondersteuninganders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/482749564498712cbf649456289ceeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekedeskundigheid'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/59b2c2d77029b68b7d52caae8b5cb14f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicinschatting'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/19479e1cd94684548409e76d327e3c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicoverbelast'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a095542b2ad24df2806387ed3ffb15b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicontbrekensociaal'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/5b6620c8c4239c3669581b3a919aeb44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicspecifiekewens'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/374dcd8a57abfd3b86289923d193db96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicteweinig'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a328b84d2f34d0337a19cee3082946c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicanders'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a8977865b67466fc30ebd552ae1edc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 2 && ___arguments.value == true) {
    (function (message) { alert(message) })('Er mogen maar 2 antwoorden geselecteerd worden.');
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
  } else {
  }
}


  ___arguments.context.appData['missingdata'] = true;
  if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = true;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) + 1);
  } else if (___arguments.value == false) {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['indicgeenzicht'] = false;
    ___arguments.context.pageData['indictotaal'] = ((getObjectProperty(___arguments.context.pageData, 'indictotaal')) - 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b47a1f9d8fc9cf97057efa4fbe632fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/9ba61fa912e8e58e72d494ae079911ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'indicanders')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceindicatorenopnameanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/56082a38033641474723ae4deeb480d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicerespijtzorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a4041f861f7abbfe9722f9222c4e3aad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/2d055f7689e731a6c45e9aa1806c20f3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospicecrisiszorg'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e556b12810f5995b9963f9f841c640cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/013b73b4aff560d7fc96f7ba039b3d29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerd'] = ___arguments['value'];
  if (___arguments['value'] == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = null;
    ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/1c1f6179b541d5d657791f980835025c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e4391dbcb74c893238be47be9199c89a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdreden'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/11187f2a048207d8c10808dbd68f9ee7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/5139ca84ec7d0369e6e1cf7be163d543/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/5ede8be35b67fc8d6e099f076a7ff794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['hospiceuitplaatsingnietgerealiseerdredenander'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/de36b5c4383f14474b621ec6f9d92c32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['externhospicesoortondersteuning'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/3a33676308dbe89a8048726d620104e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'locatiezorg')) == 'Extern hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/9a778ff795d1249519d25412114d7a25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'locatiezorg')) == 'Eigen hospice';
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/d8239abfdfd1cabe3f0e0523ff39b291/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['hospiceuitplaatsingstabilistatie'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/3d6ff9d91351388e8ebed71dcaa880b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/42bc26961d9dc29a7043a8541015c9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaar'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a')['overledenofvertrekwaarnaaranders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/12d2f389d4788352edec3f6d6f994153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bdad91c62de3bb949a45defed24e64a'), 'overledenofvertrekwaarnaar')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e52a1359e76c491e5ec1c512cad13e9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer, oud, temp, test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_datumcheck() {
  oud = (getObjectProperty(___arguments.context.pageData, 'datumschange')) == 0;
}

/**
 * Describe this function...
 */
async function oude_voorwaarden() {
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Thuis' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == 'Andere reden' && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'indicanders')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden';
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Extern hospice' && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == 'Anders' && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null;
  test = (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) != null && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null;
}

/**
 * Describe this function...
 */
async function do_something() {
  temp = !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4038a6d4a2d8bb1fbce8fb085108d2d8')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekte')) == null;
  temp = !(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e148090895d881a863345da6b1987208')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e148090895d881a863345da6b1987208')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekteanders')) == null;
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false) {
    ___arguments.context.dataModel['locatiezorg'] = 'Eigen hospice';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')) == null && (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')) == null) {
    (function (message) { alert(message) })('Er moet een datum ingevuld worden bij het traject');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null || (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == null) {
    (function (message) { alert(message) })('Waar de cliënt zorg gaat ontvangen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6b557641d421b9b7936ba078ff482b9')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ce5dbc9313e5975f41eb26f88a0599')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1cc754841bfc49e4b751efa23f90276')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')) == null) {
    (function (message) { alert(message) })('Reden waarom de cliënt niet is ondersteund dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('55637787e6fc1d1edf994e3c436ca1a6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting waarom niet plaatsbaar dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d82463a7c6c27029caac1b6a2e150dfa')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')) == null) {
    (function (message) { alert(message) })('Naam hospice dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d414967468ee70554def25ef6ceacf2')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')) == null) {
    (function (message) { alert(message) })('Naam verpleeghuis dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20eac49f3df3d065e6c5fb780daa244')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')) == null) {
    (function (message) { alert(message) })('VPTZ inzet dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c7731e3bfd38d0eddfeb7d37a83efb5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('Zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('890d657b67bb38834622c9df0dddedde')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')) == null) {
    (function (message) { alert(message) })('Toelichting op zorgsetting voor opname dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53d441b373243eca73e7315e56bd8aee')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5a91178238f31326745a6151367ba33')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')) == null) {
    (function (message) { alert(message) })('Toelichting bij verwijzer dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb728d25e9f9a253c930436dfe8f87c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')) == null) {
    (function (message) { alert(message) })('Welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d3d2d375d616aadf50ac37b9a977cda5')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')) == null) {
    (function (message) { alert(message) })('Toelichting bij welk ziekenhuis heeft doorverwezen dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4362b01d84ea74771df746c177f186f')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('Aanmelding binnen 24 uur van vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('971ae076e945edf3f943a7d99abd13cb')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')) == null) {
    (function (message) { alert(message) })('Reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('090a373661246688dc739c8fd243851c')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')) == null) {
    (function (message) { alert(message) })('Andere reden voor behoefe aan ondersteuning van een vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')) != null && (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')) == 'Eigen hospice' && (getObjectProperty(___arguments.context.pageData, 'indictotaal')) == 0) {
    (function (message) { alert(message) })('De meest voorkomende indicatoren om een cliënt op te nemen  dient ingevuld te worden');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9ba61fa912e8e58e72d494ae079911ef')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de twee meest voorkomende indicatoren om een cliënt op te nemen ');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56082a38033641474723ae4deeb480d5')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van respijtzorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2d055f7689e731a6c45e9aa1806c20f3')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')) == null) {
    (function (message) { alert(message) })('Vul de sprake van crisiszorg in');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('013b73b4aff560d7fc96f7ba039b3d29')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('Vul in of er sprake is van een niet gerealiseerde uitplaatsing gedurende het traject');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4391dbcb74c893238be47be9199c89a')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('Vul de reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ede8be35b67fc8d6e099f076a7ff794')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('Vul de andere reden in waarom de uitplaatsing niet gerealiseerd werd');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de36b5c4383f14474b621ec6f9d92c32')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')) == null) {
    (function (message) { alert(message) })('Vul in wat voor soort ondersteuning de cliënt ontvangt');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d8239abfdfd1cabe3f0e0523ff39b291')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')) == null) {
    (function (message) { alert(message) })('Vul in of de cliënt uitgeplaatst is omdat er sprake was van langdurige stabilisatie');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42bc26961d9dc29a7043a8541015c9d4')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Vul in waar de cliënt naar is uitgeplaatst');
  } else if (!(typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')) === 'undefined') && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d6ff9d91351388e8ebed71dcaa880b3')), 'display')) == true && ((getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) == null) == null) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag waar de cliënt naar is uitgeplaatst');
  } else if (false) {
    (function (message) { alert(message) })('Vul in wat de meest voorkomende onderliggende ziekte bij overlijden is.');
  } else if (false) {
    (function (message) { alert(message) })('Vul de toelichting in bij de vraag wat is de meest voorkomende onderliggende ziekte bij overlijden.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
      clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
    } else {
      clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`overledenmeestvoorkomendeziekte`]: (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekte')),[`overledenmeestvoorkomendeziekteanders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenmeestvoorkomendeziekteanders')),[`annuleringcontraindicatietoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringcontraindicatietoelichting')),[`annuleringnaamhospice`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamhospice')),[`annuleringnaamverpleeghuis`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringnaamverpleeghuis')),[`annuleringtoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'annuleringtoelichting')),[`zorgsettingvooropnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropnameanders')),[`verwijzeranders`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzeranders')),[`verwijzerziekenhuis`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuis')),[`verwijzerziekenhuistoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzerziekenhuistoelichting')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`trajectdatuminformatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatuminformatievraag')),[`trajectdatumvraagvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumvraagvooropname')),[`trajectdatumannuleringvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumannuleringvooropname')),[`trajectdatumopname`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumopname')),[`trajectdatumoverlijden`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumoverlijden')),[`trajectdatumuitplaatsing`]: (getObjectProperty(___arguments.context.dataModel, 'trajectdatumuitplaatsing')),[`locatiezorg`]: (getObjectProperty(___arguments.context.dataModel, 'locatiezorg')),[`informatievraag`]: (getObjectProperty(___arguments.context.dataModel, 'informatievraag')),[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisredengeenondersteuninganders')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceredengeenondersteuninganders')),[`vptzinzet`]: (getObjectProperty(___arguments.context.dataModel, 'vptzinzet')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.dataModel, 'zorgsettingvooropname')),[`verwijzer`]: (getObjectProperty(___arguments.context.dataModel, 'verwijzer')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.context.dataModel, 'thuisbehoefteondersteuninganders')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.context.dataModel, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.context.dataModel, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.context.dataModel, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.context.dataModel, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.context.dataModel, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.context.dataModel, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.context.dataModel, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.context.dataModel, 'hospicecrisiszorg')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`externhospicesoortondersteuning`]: (getObjectProperty(___arguments.context.dataModel, 'externhospicesoortondersteuning')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.context.dataModel, 'hospiceuitplaatsingstabilistatie')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaar')),[`overledenofvertrekwaarnaaranders`]: (getObjectProperty(___arguments.context.dataModel, 'overledenofvertrekwaarnaaranders')) }) ));
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.appData['missingdata'] = false;
    ___arguments.context.pageData['bevestigingopslaan'] = true;
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/7e1a909bf40c9a713fbb25dcc82a9148/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.pageData, 'viewwaarontvangtdepatientdezorg')) == false ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumvraagvooropname')) != null ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65'), 'trajectdatumopname')) != null ? true : false));

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (!___arguments.newValue) {
    ___arguments.context.getComponentDataStoreByUid('93d83377f3bc4344286be0e396c26f65')['locatiezorg'] = null;
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/53a822af18bafd150bd1b2961d9fca2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/583b22ba2a214bcc5a9f4148de46bb0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/cd233f880b858e743956b2d65fa42cca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/089715f15ca3430b00b6a6dc0f75eb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/26ef2f3a685c0416df5eb62d074e9941/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/1aba47677cb7663e2033a1da287a8cac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/9932f36b993d02b815c7afcee51c84ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/0d6c86833885bbc8d3e3ddd6dd82b6da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/acda9323b39b6f46eb9ac6393812989b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/6ba5385f0b9429275442fa0159cfee51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/6805aa117dea00b755aa736905f8526e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/a5479337e2b6c189bb9f2ecd83d21f87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/3897480d4f2cd72a3cf11f77b6154286/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e12b9ad910b9f36fcab5f72a6339790f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Datum ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/3dd1c0f207f29cb4c39ad9b5434e005e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function hashpersonaldatacheck() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')) == null) {
    (function (message) { alert(message) })('Kenmerk dient ingevuld te worden');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))) != 4) {
    (function (message) { alert(message) })('De 4 cijfers van de postcode moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')) == null) {
    (function (message) { alert(message) })('Geboortedatum dient ingevuld te worden');
  } else {
    ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['spinner'] = true;
    await hashpersonaldatacheck();
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('clienten').bulkUpdate( (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join('')), ({ [`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Data.of('checkcodes').bulkUpdate( (['clientnummer=\'',clientnummer,'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')), ({ [`clientgeboortedatum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),[`clientpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')),[`checkcode`]: (await Backendless.Cache.get('hash')) }) );
    await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodezuidlimburg`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'checkcode': (await Backendless.Cache.get('hash')),'oldcheckcode': (await Backendless.Cache.get('oldcheckcode')) });
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.pageData['change'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('db78f3a467a44c8d30ea4bbaf456bd01');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/bd9250790022e23128fe77d3864f67d2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['kenmerk'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'kenmerk'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e4ccbecc4c73de6130aa9d8a1b77dc51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientpostcode'] = ___arguments.value;
  await searchcheckcodes();

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/88ec679d7628b0163f79cbb8d51a1853/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/da3dc4f3e36319dececa129e9c0e5a59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/1cdd178db2b7e28c57f8f3ec69298788/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['kenmerk'] = (getObjectProperty(___arguments.context.appData, 'kenmerk'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientpostcode'] = (getObjectProperty(___arguments.context.appData, 'clientpostcode'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['clientgeboortedatum'] = (getObjectProperty(___arguments.context.appData, 'clientgeboortedatum'));
  await Backendless.Cache.put('oldcheckcode', (getObjectProperty(___arguments.context.dataModel, 'checkcode')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/50273806c51f2dee7ff34306b27d62e1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var clientnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NEW')) == true) {
    clientnummer = (getObjectProperty(___arguments.context.appData, 'clientnummer'));
  } else {
    clientnummer = (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer'))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50273806c51f2dee7ff34306b27d62e1', (await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND clientnummer=\'',clientnummer,'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/63cd1de5c795e644cfcbb321fb8e5264/bundle.js', [], () => ({
  /* content */
  /* handler:onComplete */
  async ['onComplete'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  ___arguments.context.getComponentDataStoreByUid('1cdd178db2b7e28c57f8f3ec69298788')['clientgeboortedatum'] = ___arguments['value'];
  await searchcheckcodes();

  },
  /* handler:onComplete */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/719d0e821819ff9558abb51ef6fe4e83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/1a5a28de6ec3747ef343f9e7da4fe9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'change')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/04645dbdd7430f55096388e263ec5f28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'change')) == false) {
    ___arguments.context.pageData['change'] = true;
  } else {
    ___arguments.context.pageData['change'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/2993a06e8824485cc41c471c51df3f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Contra-indicatie opname')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/07bb4c7f293f995e919bfc8a9e6dcc8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/29eff59680ba58374595c4a15d3218c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Overgeplaatst naar een ander hospice')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/c4d84565f1aca773666f3436c58b69b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2395fd42ed6e2307531dff7e7977bd8b'), 'hospiceredengeenondersteuning')) == 'Verpleeghuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/53d441b373243eca73e7315e56bd8aee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzer'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/c54335e318ef11ffb5cc27abe11e0181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/2efb01df6f6cd6c1cdd7082f4af448a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'zorgsettingvooropname')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/6cced3686ca2c84459c59be795f420e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzerziekenhuis')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/b53b85bb05b1f88b79bf13119945f346/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21'), 'verwijzer')) == 'Ziekenhuis')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/7cb728d25e9f9a253c930436dfe8f87c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerziekenhuis'] = ___arguments['value'];
  ___arguments.context.getComponentDataStoreByUid('761c47547dc70bbf85cbd6beda4cce21')['verwijzerziekenhuistoelichting'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/67c5db92dfeb3464e377ddd92cfddd53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var clientnummerslist, count, clientnummers, item, checkcodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function searchcheckcodes() {
  await Backendless.Cache.remove('hash');
  await Backendless.Request.post(`${Backendless.appPath}/services/Hashing/hashpersonaldatacheck`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'clientvoornaam': null,'clientgeboortenaam': null,'clientgeslacht': null,'clientgeboortedatum': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'clientpostcode': (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) });
  await new Promise(r => setTimeout(r, 1000 || 0));
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',(await Backendless.Cache.get('hash')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}

/**
 * Describe this function...
 */
async function searchcheckcodes_oud_18_01_2025() {
  checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')),'properties': ['clientnummer', 'hospice'] }));
  count = (await Backendless.Data.of('checkcodes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')))));
  clientnummers = (await Promise.all((await Backendless.Data.of('checkcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['checkcode=\'',String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode')) + String(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setProperties('clientnummer').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'clientnummer'));})));
  clientnummerslist = clientnummers.join('\', \'');
  if (count == 1) {
    (function (message) { alert(message) })((['Er bestaat al een cliënt met deze postcode-geboortedatumcombinatie: ',String('clientnummer: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  } else if (count > 1) {
    (function (message) { alert(message) })((['Er bestaan al meerdere cliënten met deze postcode-geboortedatumcombinatie: ',String('cliëntnummers: ') + String(clientnummerslist),'. Controleer of deze cliënt al bestaat in de cliëntenlijst.'].join('')));
  }
}


  if (getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientpostcode'))) == 4 && (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'clientgeboortedatum')) != null) {
    await searchcheckcodes();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/2b1850b2bb8811ece866052a18ecd3d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bevestigingopslaan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/e148090895d881a863345da6b1987208/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788'), 'overledenmeestvoorkomendeziekte')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekteanders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/33021ada079828b821de56c87e56e788/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  temp = (getObjectProperty(___arguments.context.pageData, 'overlijden'));

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('33021ada079828b821de56c87e56e788')));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/d5e1bd589e580c4deea79bd8ee17ad77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788'), 'overledenmeestvoorkomendeziekte')) == 'Anders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZuid-Limburg-backup/components/4038a6d4a2d8bb1fbce8fb085108d2d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['missingdata'] = true;
  ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekte'] = ___arguments['value'];
  if (___arguments['value'] != 'Anders') {
    ___arguments.context.getComponentDataStoreByUid('33021ada079828b821de56c87e56e788')['overledenmeestvoorkomendeziekteanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijst/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, k, clientenlijst2, item, clientenlijst, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleactiviteiten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientenlijst/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijst/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeclientarnhem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientgroningen', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeclientgroningen', undefined);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == false) {
    A = 'Datum aanmelding';
  }
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67ea79e5edfb40fc14ab7c2968b462e')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    B = 'Leeftijd';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    C = 'Geboortedatum';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('clientenlijstgroningen').bulkDelete( (['checkcode=\'',String(getObjectProperty(___arguments.deletedObject, 'postcode')) + String(new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.deletedObject, 'geboortedatum')))),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save( ({ [`actie`]: 'client verwijdert',[`actiedoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`actiedoorusername`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')),[`naam`]: (getObjectProperty(___arguments.deletedObject, 'naam')),[`username`]: (getObjectProperty(___arguments.deletedObject, 'username')),[`hospice`]: (getObjectProperty(___arguments.deletedObject, 'hospice')),[`netwerkpz`]: (getObjectProperty(___arguments.deletedObject, 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.deletedObject, 'kenmerk')),[`postcode`]: (getObjectProperty(___arguments.deletedObject, 'postcode')),[`geboortedatum`]: (getObjectProperty(___arguments.deletedObject, 'geboortedatum')),[`checkcode`]: (getObjectProperty(___arguments.deletedObject, 'checkcode')),[`locatiezorg`]: (getObjectProperty(___arguments.deletedObject, 'locatiezorg')),[`datumaanmelding`]: (getObjectProperty(___arguments.deletedObject, 'datumaanmelding')),[`datumannulering`]: (getObjectProperty(___arguments.deletedObject, 'datumannulering')),[`thuisredengeenondersteuning`]: (getObjectProperty(___arguments.deletedObject, 'thuisredengeenondersteuning')),[`thuisredengeenondersteuninganders`]: (getObjectProperty(___arguments.deletedObject, 'thuisredengeenondersteuninganders')),[`hospiceredengeenondersteuning`]: (getObjectProperty(___arguments.deletedObject, 'hospiceredengeenondersteuning')),[`hospiceredengeenondersteuninganders`]: (getObjectProperty(___arguments.deletedObject, 'hospiceredengeenondersteuninganders')),[`datumopname`]: (getObjectProperty(___arguments.deletedObject, 'datumopname')),[`vptzinzet`]: (getObjectProperty(___arguments.deletedObject, 'vptzinzet')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.deletedObject, 'thuiscrisiszorg')),[`thuisbehoefteondersteuning`]: (getObjectProperty(___arguments.deletedObject, 'thuisbehoefteondersteuning')),[`thuisbehoefteondersteuninganders`]: (getObjectProperty(___arguments.deletedObject, 'thuisbehoefteondersteuninganders')),[`indicspecifiekedeskundigheid`]: (getObjectProperty(___arguments.deletedObject, 'indicspecifiekedeskundigheid')),[`indicinschatting`]: (getObjectProperty(___arguments.deletedObject, 'indicinschatting')),[`indicoverbelast`]: (getObjectProperty(___arguments.deletedObject, 'indicoverbelast')),[`indicontbrekensociaal`]: (getObjectProperty(___arguments.deletedObject, 'indicontbrekensociaal')),[`indicspecifiekewens`]: (getObjectProperty(___arguments.deletedObject, 'indicspecifiekewens')),[`indicteweinig`]: (getObjectProperty(___arguments.deletedObject, 'indicteweinig')),[`indicanders`]: (getObjectProperty(___arguments.deletedObject, 'indicanders')),[`indicgeenzicht`]: (getObjectProperty(___arguments.deletedObject, 'indicgeenzicht')),[`hospiceindicatorenopnameanders`]: (getObjectProperty(___arguments.deletedObject, 'hospiceindicatorenopnameanders')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.deletedObject, 'hospicerespijtzorg')),[`hospicecrisiszorg`]: (getObjectProperty(___arguments.deletedObject, 'hospicecrisiszorg')),[`hospiceuitplaatsingstabilistatie`]: (getObjectProperty(___arguments.deletedObject, 'hospiceuitplaatsingstabilistatie')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.deletedObject, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.deletedObject, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.deletedObject, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`externhospicesoortondersteuning`]: (getObjectProperty(___arguments.deletedObject, 'externhospicesoortondersteuning')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.deletedObject, 'zorgsettingvooropname')),[`zorgsettingwelkziekenhuis`]: (getObjectProperty(___arguments.deletedObject, 'zorgsettingwelkziekenhuis')),[`verwijzer`]: (getObjectProperty(___arguments.deletedObject, 'verwijzer')),[`verwijzeranders`]: (getObjectProperty(___arguments.deletedObject, 'verwijzeranders')),[`overledenofvertrek`]: (getObjectProperty(___arguments.deletedObject, 'overledenofvertrek')),[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.deletedObject, 'overledenofvertrekwaarnaar')),[`datumoverlijdenofvertrek`]: (getObjectProperty(___arguments.deletedObject, 'datumoverlijdenofvertrek')) }) );

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('groningen'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleclienten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = 'Actief';
  ___arguments.context.pageData['statusjaar'] = (new Date((new Date())).getFullYear());
  console.log(new Date((new Date())).getFullYear());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fb1d189f241b1ad86a3a725b0bf81248', (await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['statusfilter'] = 'Actief';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/21ca19ce97ce91bfb697e284da676668/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['viewinformatievraag'] = (getObjectProperty(___arguments.context.dataModel, 'viewinformatievraag'));
  ___arguments.context.appData['viewvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewvraagvooropname'));
  ___arguments.context.appData['viewannuleringvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewannuleringvraagvooropname'));
  ___arguments.context.appData['viewopname'] = (getObjectProperty(___arguments.context.dataModel, 'viewopname'));
  ___arguments.context.appData['viewoverlijden'] = (getObjectProperty(___arguments.context.dataModel, 'viewoverlijden'));
  ___arguments.context.appData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.appData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'labeluitplaatsingofuitgeleide'));
  ___arguments.context.appData['setvptzinzet'] = (getObjectProperty(___arguments.context.dataModel, 'setvptzinzet'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/9047360d23d26106f82f8f31934d232a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/167caa88fbecd83a0a3b72cb1cf9f8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/4fb515e659e7652116dced66978a8e51/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/c2f12fd67c5f166df5a48a74494a9316/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/c8353a05f4022fa10db688c6ff166263/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/e2b34a6156fcc22be507304666798059/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'',(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogroningenlieke') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientGroningenLieke', undefined);
  } else {
  }
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremove`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'clientnummer': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodegroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchallgroningen`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/5115a281bd094a8cd99b994e10d110eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/f79ee60d77c3ff0ebe5c47ef0658f1a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/861cb49a1534110c36d8c60f473d2356/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/fa7abde5692bf19167c983d5f4b9fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/3326e1d43e93b23f822767ea1ebd9c17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/07ed9fa8c5e131e6e8f91ed3e2e38958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/b45357cba5bde4e7970ee47a16f50d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/3833441c503c83836168899854868aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/48e58cc9965d5897aec90f7a2d53c055/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/c5a2ebe78bdad0d28ad4e943ad3ce2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/54c1ce06959176886cfbc58f37f41e74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/882e45172b8c63911f7a009f58cc5d4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/d5974557fa2875bc3ab1e338a47f3852/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/220c6a348e5ded8d75567e8c84630fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/7ab8a011fcaee29c9b545bc8c78b8361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/cd43ad72054c53f9c33f25211036002b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide'))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/413ac598215f661b8c688fa820d50a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/ef13b0848fc9592670f1e0b234be1a61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/3bf1813ccacbee475c13e92863cbe688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Uitplaatsing of uitgeleide','\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/f00d8db6d2f449234bf77f861e35565f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'statusjaar')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/bfc486649873a1ba1cf9aa1ad6b58a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/d6e66b7ded2c3519daffd9ce1141a614/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/f6a17ab139cec6bbf1b74ea3c8d12f27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/4c5eb62155e3c1050bfb5d8f5e1c39a3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/bbf951c47a461ba14611c008a2940e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/d53891bcaade805c33eb9927d267bb17/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/131981c812c64bc875b64e987f0874c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  temp = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder')) == true;

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogroningen')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvexportclienten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvexportclienten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['exportgroningen/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'/clientgegevens.csv'].join('')),'tableName': 'clienten','tableOptions': ({ [`where`]: ['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['hospice', 'anoniem', 'clientvoornaam', 'clientgeboortenaam', 'clientadres', 'clientpostcode', 'clientgeboorteplaats', 'clientgeboortedatum', 'clientgeslacht', 'clientleeftijd', 'clientleeftijdgroep', 'contactverwijzertoelichting', 'hospiceaanmeldenbijander', 'hospicecrisiszorg', 'hospiceredengeenondersteuning', 'hospicerespijtzorg', 'exportdatuminformatievraag', 'exportdatumopname', 'exportdatumuitplaatsing', 'verwijzer'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['hospice', 'anoniem', 'clientvoornaam', 'clientgeboortenaam', 'clientadres', 'clientpostcode', 'clientgeboorteplaats', 'clientgeboortedatum', 'clientgeslacht', 'clientleeftijd', 'clientleeftijdgroep', 'contactverwijzertoelichting', 'hospiceaanmeldenbijander', 'hospicecrisiszorg', 'hospiceredengeenondersteuning', 'hospicerespijtzorg', 'exportdatuminformatievraag', 'exportdatumopname', 'exportdatumuitplaatsing', 'verwijzer'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvexportclienten, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijstGroningen/components/68ffded84e1f9408b8984c28bd485538/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('clienten').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))).setProperties(['aanmaakjaar']).setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwe'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleclienten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fb1d189f241b1ad86a3a725b0bf81248', (await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/21ca19ce97ce91bfb697e284da676668/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['viewinformatievraag'] = (getObjectProperty(___arguments.context.dataModel, 'viewinformatievraag'));
  ___arguments.context.appData['viewvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewvraagvooropname'));
  ___arguments.context.appData['viewannuleringvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewannuleringvraagvooropname'));
  ___arguments.context.appData['viewopname'] = (getObjectProperty(___arguments.context.dataModel, 'viewopname'));
  ___arguments.context.appData['viewoverlijden'] = (getObjectProperty(___arguments.context.dataModel, 'viewoverlijden'));
  ___arguments.context.appData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.appData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'labeluitplaatsingofuitgeleide'));
  ___arguments.context.appData['setvptzinzet'] = (getObjectProperty(___arguments.context.dataModel, 'setvptzinzet'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/9047360d23d26106f82f8f31934d232a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/167caa88fbecd83a0a3b72cb1cf9f8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Aanmelding voor opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/4fb515e659e7652116dced66978a8e51/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering aanmelding voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/c2f12fd67c5f166df5a48a74494a9316/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/c8353a05f4022fa10db688c6ff166263/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/e2b34a6156fcc22be507304666798059/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Afsluiting zorgtraject','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogroningenlieke') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientGroningenLieke', undefined);
  } else {
  }
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/5115a281bd094a8cd99b994e10d110eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/f79ee60d77c3ff0ebe5c47ef0658f1a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/861cb49a1534110c36d8c60f473d2356/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/fa7abde5692bf19167c983d5f4b9fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/3326e1d43e93b23f822767ea1ebd9c17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/07ed9fa8c5e131e6e8f91ed3e2e38958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/b45357cba5bde4e7970ee47a16f50d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/3833441c503c83836168899854868aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Aanmelding voor opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/48e58cc9965d5897aec90f7a2d53c055/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering aanmelding voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/c5a2ebe78bdad0d28ad4e943ad3ce2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/54c1ce06959176886cfbc58f37f41e74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/882e45172b8c63911f7a009f58cc5d4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/d5974557fa2875bc3ab1e338a47f3852/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/220c6a348e5ded8d75567e8c84630fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/7ab8a011fcaee29c9b545bc8c78b8361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/cd43ad72054c53f9c33f25211036002b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide'))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/413ac598215f661b8c688fa820d50a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/ef13b0848fc9592670f1e0b234be1a61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/3bf1813ccacbee475c13e92863cbe688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Afsluiting zorgtraject','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/f00d8db6d2f449234bf77f861e35565f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/bfc486649873a1ba1cf9aa1ad6b58a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/d6e66b7ded2c3519daffd9ce1141a614/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/f6a17ab139cec6bbf1b74ea3c8d12f27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/4c5eb62155e3c1050bfb5d8f5e1c39a3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/bbf951c47a461ba14611c008a2940e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/d53891bcaade805c33eb9927d267bb17/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/9abe330cc857b32367072c2e98a9b1d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Verwijzing terminale thuiszorg','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/96b8174f24c19a612bb895f147dd6a39/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Verwijzing terminale thuiszorg','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodeshospicesmatchremoveoostveluwe`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.deletedObject, 'clientnummer'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.get(`${Backendless.appPath}/services/updatecheckcodecount/updatecheckcodeoostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'checkcode': JSON.stringify((getObjectProperty(___arguments.deletedObject, 'checkcode'))) }).send();
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Request.post(`${Backendless.appPath}/services/updatecheckcodecount/checkcodehospicesmatchalloostveluwe`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

  },
  /* handler:onObjectDelete */
  /* handler:onAllowDeleteAssignment */
  async ['onAllowDeleteAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'beheerder'))

  },
  /* handler:onAllowDeleteAssignment */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/737c4084fec8e348e113264efa6d439d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'verwijzingterminalethuiszorg') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstOost-Veluwe/components/04158245386bf4aea207656ec55d7b37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'verwijzingterminalethuiszorg' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('zuidgelderland'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleclienten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fb1d189f241b1ad86a3a725b0bf81248', (await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == false) {
    A = 'Datum aanmelding';
  }
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67ea79e5edfb40fc14ab7c2968b462e')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    B = 'Leeftijd';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    C = 'Geboortedatum';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/21ca19ce97ce91bfb697e284da676668/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['viewinformatievraag'] = (getObjectProperty(___arguments.context.dataModel, 'viewinformatievraag'));
  ___arguments.context.appData['viewvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewvraagvooropname'));
  ___arguments.context.appData['viewannuleringvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewannuleringvraagvooropname'));
  ___arguments.context.appData['viewopname'] = (getObjectProperty(___arguments.context.dataModel, 'viewopname'));
  ___arguments.context.appData['viewoverlijden'] = (getObjectProperty(___arguments.context.dataModel, 'viewoverlijden'));
  ___arguments.context.appData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.appData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'labeluitplaatsingofuitgeleide'));
  ___arguments.context.appData['setvptzinzet'] = (getObjectProperty(___arguments.context.dataModel, 'setvptzinzet'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/9047360d23d26106f82f8f31934d232a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/167caa88fbecd83a0a3b72cb1cf9f8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/4fb515e659e7652116dced66978a8e51/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/c2f12fd67c5f166df5a48a74494a9316/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/c8353a05f4022fa10db688c6ff166263/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/e2b34a6156fcc22be507304666798059/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Clientenlijst - ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onTitleAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'',(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')),'\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/5115a281bd094a8cd99b994e10d110eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/f79ee60d77c3ff0ebe5c47ef0658f1a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/861cb49a1534110c36d8c60f473d2356/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/fa7abde5692bf19167c983d5f4b9fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/3326e1d43e93b23f822767ea1ebd9c17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/07ed9fa8c5e131e6e8f91ed3e2e38958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/b45357cba5bde4e7970ee47a16f50d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/3833441c503c83836168899854868aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/48e58cc9965d5897aec90f7a2d53c055/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/c5a2ebe78bdad0d28ad4e943ad3ce2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/54c1ce06959176886cfbc58f37f41e74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/882e45172b8c63911f7a009f58cc5d4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/d5974557fa2875bc3ab1e338a47f3852/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/220c6a348e5ded8d75567e8c84630fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/7ab8a011fcaee29c9b545bc8c78b8361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/cd43ad72054c53f9c33f25211036002b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide'))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/413ac598215f661b8c688fa820d50a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/ef13b0848fc9592670f1e0b234be1a61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/3bf1813ccacbee475c13e92863cbe688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'',(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')),'\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/f00d8db6d2f449234bf77f861e35565f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/bbf951c47a461ba14611c008a2940e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/4c5eb62155e3c1050bfb5d8f5e1c39a3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/f6a17ab139cec6bbf1b74ea3c8d12f27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/bfc486649873a1ba1cf9aa1ad6b58a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/d6e66b7ded2c3519daffd9ce1141a614/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Gelderland/components/d53891bcaade805c33eb9927d267bb17/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('zuidlimburg'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleclienten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fb1d189f241b1ad86a3a725b0bf81248', (await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == false) {
    A = 'Datum aanmelding';
  }
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67ea79e5edfb40fc14ab7c2968b462e')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    B = 'Leeftijd';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    C = 'Geboortedatum';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/21ca19ce97ce91bfb697e284da676668/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['viewinformatievraag'] = (getObjectProperty(___arguments.context.dataModel, 'viewinformatievraag'));
  ___arguments.context.appData['viewvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewvraagvooropname'));
  ___arguments.context.appData['viewannuleringvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewannuleringvraagvooropname'));
  ___arguments.context.appData['viewopname'] = (getObjectProperty(___arguments.context.dataModel, 'viewopname'));
  ___arguments.context.appData['viewoverlijden'] = (getObjectProperty(___arguments.context.dataModel, 'viewoverlijden'));
  ___arguments.context.appData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.appData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'labeluitplaatsingofuitgeleide'));
  ___arguments.context.appData['setvptzinzet'] = (getObjectProperty(___arguments.context.dataModel, 'setvptzinzet'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/9047360d23d26106f82f8f31934d232a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/167caa88fbecd83a0a3b72cb1cf9f8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/4fb515e659e7652116dced66978a8e51/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/c2f12fd67c5f166df5a48a74494a9316/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/c8353a05f4022fa10db688c6ff166263/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/e2b34a6156fcc22be507304666798059/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Clientenlijst - ') + String(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')))

  },
  /* handler:onTitleAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'',(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')),'\' AND statusnew LIKE\'','Afgesloten','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function On_Object_Delete() {
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('checkcodes').bulkDelete( (['clientnummer=\'',(getObjectProperty(___arguments.deletedObject, 'clientnummer')),'\''].join('')) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);
}


  await On_Object_Delete();

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/5115a281bd094a8cd99b994e10d110eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/f79ee60d77c3ff0ebe5c47ef0658f1a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/861cb49a1534110c36d8c60f473d2356/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/fa7abde5692bf19167c983d5f4b9fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/3326e1d43e93b23f822767ea1ebd9c17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/07ed9fa8c5e131e6e8f91ed3e2e38958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/b45357cba5bde4e7970ee47a16f50d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Informatievraag','\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/3833441c503c83836168899854868aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Vraag voor opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/48e58cc9965d5897aec90f7a2d53c055/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Annulering vraag voor opname','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/c5a2ebe78bdad0d28ad4e943ad3ce2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewinformatievraag'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/54c1ce06959176886cfbc58f37f41e74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/882e45172b8c63911f7a009f58cc5d4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewannuleringvraagvooropname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/d5974557fa2875bc3ab1e338a47f3852/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewopname'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/220c6a348e5ded8d75567e8c84630fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewoverlijden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/7ab8a011fcaee29c9b545bc8c78b8361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'viewuitplaatsingofuitgeleide'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/cd43ad72054c53f9c33f25211036002b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide'))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'uitplaatsingofuitgeleide') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/413ac598215f661b8c688fa820d50a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Opname','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/ef13b0848fc9592670f1e0b234be1a61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var statusfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'','Overlijden','\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/3bf1813ccacbee475c13e92863cbe688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statuszorgtraject=\'',(getObjectProperty(___arguments.context.appData, 'labeluitplaatsingofuitgeleide')),'\' AND statusnew LIKE\'','Afgesloten','\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/f00d8db6d2f449234bf77f861e35565f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND statusnew LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/bbf951c47a461ba14611c008a2940e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'overlijden') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/4c5eb62155e3c1050bfb5d8f5e1c39a3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/f6a17ab139cec6bbf1b74ea3c8d12f27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'annuleringvraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Afgesloten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/bfc486649873a1ba1cf9aa1ad6b58a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'vraagvooropname') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/d6e66b7ded2c3519daffd9ce1141a614/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'informatievraag') == true) {
    ___arguments.context.pageData['statusfilter'] = 'Actief';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/clientenlijstZuid-Limburg/components/d53891bcaade805c33eb9927d267bb17/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleclienten') == true) {
    ___arguments.context.pageData['statusfilter'] = '%';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createclientarnhem/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var datumoverlijdenofvertrek, overledenofvertrek;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('16fbf577616ba29a27475fe1fed99c8e')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'leeftijd')) == null) {
    (function (message) { alert(message) })('De leeftijd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ba6a4051219ffd4ee68490dd2148b2c1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'zorgsettingvooropname')) == null) {
    (function (message) { alert(message) })('De zorgsetting voor opname dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6738aecdae8610e75d9b1d82f433ffb8')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'zorgsettingwelkziekenhuis')) == null) {
    (function (message) { alert(message) })('Welk ziekenhuis dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c3fcb01a83c3096352406641ab438aa')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == null) {
    (function (message) { alert(message) })('Of de cliënt is overleden of vertrokken dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a1e82e5af66cf8087a81f2c6b458f8de')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'overledenofvertrekwaarnaar')) == null) {
    (function (message) { alert(message) })('Waar de cliënt naar vertrokken is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32180de7ee9bc0fae2e817ead26aef6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datumopname')) == null) {
    (function (message) { alert(message) })('De datum van opname dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b55d09849674a6f6a32e1515e003a3ce')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datumoverlijdenofvertrek')) == null) {
    (function (message) { alert(message) })('De datum van overlijden of vertrek dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5e61d759ab962ff86d49a5181a7aadb4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datumaanmelding')) == null) {
    (function (message) { alert(message) })('De datum van aanmelding dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aad597adb7fab92177593714eb8381c8')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datumannulering')) == null) {
    (function (message) { alert(message) })('De datum van annulering dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bd48131ef0eb34d112de820617ac8fb5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'redenannulering')) == null) {
    (function (message) { alert(message) })('De reden van annulering dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f86b52dd113c749e94958f73e646c3ff')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzondersteuning')) == null) {
    (function (message) { alert(message) })('Sprake van ondersteuning vanuit VPTZ/Nabij dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7a6773da9c19284645f43dfdd2e5ccd')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzbezoekwenselijk')) == null) {
    (function (message) { alert(message) })('Wenselijkheid/ mogelijkheid thuis vrijwilliger dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a93411c4dd2aea075d5eeaee2d1ae93f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'vptzmogelijkheidondersteuning')) == null) {
    (function (message) { alert(message) })('Gewezen op ondersteuning thuis dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5647db75aa952ab4568349e5bebb45a6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')) == null) {
    (function (message) { alert(message) })('De gewenste uitplaatsing die niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a64d0ca808eaff15abc7c3ee7513f1d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')) == null) {
    (function (message) { alert(message) })('De reden dat de gewenste uitplaatsing niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('136b07c425f1562c8433ecbaa3fb8a28')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdredenander')) == null) {
    (function (message) { alert(message) })('De andere reden dat de gewenste uitplaatsing niet gerealiseerd is dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76bd57ac607cdfda86dee12818ee52d2')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'thuiscrisiszorg')) == null) {
    (function (message) { alert(message) })('De sprake van crisiszorg dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1dde5997846fabb99540807b0e702ee')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'hospicerespijtzorg')) == null) {
    (function (message) { alert(message) })('De sprake van respijtzorg dient ingevuld te worden');
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bd48131ef0eb34d112de820617ac8fb5')), 'display')) == true) {
      overledenofvertrek = 'Opname geannuleerd';
      datumoverlijdenofvertrek = (getObjectProperty(___arguments.context.pageData, 'datumannulering'));
    } else {
      overledenofvertrek = (getObjectProperty(___arguments.context.pageData, 'overledenofvertrek'));
      datumoverlijdenofvertrek = (getObjectProperty(___arguments.context.pageData, 'datumoverlijdenofvertrek'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('clienten').save( ({ [`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`kenmerk`]: (getObjectProperty(___arguments.context.pageData, 'kenmerk')),[`datumaanmelding`]: (getObjectProperty(___arguments.context.pageData, 'datumaanmelding')),[`datumannulering`]: (getObjectProperty(___arguments.context.pageData, 'datumannulering')),[`redenannulering`]: (getObjectProperty(___arguments.context.pageData, 'redenannulering')),[`redenannuleringtoelichting`]: (getObjectProperty(___arguments.context.pageData, 'redenannuleringtoelichting')),[`leeftijd`]: (getObjectProperty(___arguments.context.pageData, 'leeftijd')),[`zorgsettingvooropname`]: (getObjectProperty(___arguments.context.pageData, 'zorgsettingvooropname')),[`zorgsettingwelkziekenhuis`]: (getObjectProperty(___arguments.context.pageData, 'zorgsettingwelkziekenhuis')),[`overledenofvertrek`]: overledenofvertrek,[`overledenofvertrekwaarnaar`]: (getObjectProperty(___arguments.context.pageData, 'overledenofvertrekwaarnaar')),[`datumopname`]: (getObjectProperty(___arguments.context.pageData, 'datumopname')),[`datumoverlijdenofvertrek`]: datumoverlijdenofvertrek,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`vptzondersteuning`]: (getObjectProperty(___arguments.context.pageData, 'vptzondersteuning')),[`vptzbezoekwenselijk`]: (getObjectProperty(___arguments.context.pageData, 'vptzbezoekwenselijk')),[`vptzmogelijkheidondersteuning`]: (getObjectProperty(___arguments.context.pageData, 'vptzmogelijkheidondersteuning')),[`hospiceuitplaatsingnietgerealiseerd`]: (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')),[`hospiceuitplaatsingnietgerealiseerdreden`]: (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')),[`hospiceuitplaatsingnietgerealiseerdredenander`]: (getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdredenander')),[`thuiscrisiszorg`]: (getObjectProperty(___arguments.context.pageData, 'thuiscrisiszorg')),[`hospicerespijtzorg`]: (getObjectProperty(___arguments.context.pageData, 'hospicerespijtzorg')) }) ));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hospiceclienten', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hospiceclienten', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createclientarnhem/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createclientarnhem/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createclientarnhem/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['aanmelden'] = false;
  ___arguments.context.pageData['annuleren'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createclientarnhem/components/9e0a707dbfadf7173f3ef59d3c2c41ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zorgsettingvooropname')) == 'Ziekenhuis' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/6738aecdae8610e75d9b1d82f433ffb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zorgsettingvooropname')) == 'Ziekenhuis' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createclientarnhem/components/a1e82e5af66cf8087a81f2c6b458f8de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/b181ee54ed538fde3029a95e3f8d8d0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/ba6a4051219ffd4ee68490dd2148b2c1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['zorgsettingwelkziekenhuis'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/1c3fcb01a83c3096352406641ab438aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.pageData['datumoverlijdenofvertrek'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/13461817ad3fe3074de521c90b838a95/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == null) {
    text = 'Datum overlijden of vertrek';
  } else if ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden') {
    text = 'Datum overlijden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken') {
    text = 'Datum vertrek';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/b55d09849674a6f6a32e1515e003a3ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datumoverlijdenofvertrek'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datumoverlijdenofvertrek'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createclientarnhem/components/5e9101d7bf8a12d81adbc67442cf9536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'redenannulering')) == 'Anders') {
    text = 'Eventuele toelichting:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'redenannulering')) == 'Anders') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/29ffb2f91f2620fbe4de4a3e4ee76369/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'redenannulering')) == 'Anders') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/efda7ec3938a096802fec9f4ab6451a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false) {
    ___arguments.context.pageData['aanmelden'] = true;
  } else {
    ___arguments.context.pageData['aanmelden'] = false;
  }
  ___arguments.context.pageData['datumannulering'] = null;
  ___arguments.context.pageData['redenannulering'] = null;
  ___arguments.context.pageData['redenannuleringtoelichting'] = null;
  ___arguments.context.pageData['datumopname'] = null;
  ___arguments.context.pageData['zorgsettingwelkziekenhuis'] = null;
  ___arguments.context.pageData['overledenofvertrek'] = null;
  ___arguments.context.pageData['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.pageData['datumoverlijdenofvertrek'] = null;
  ___arguments.context.pageData['vptzondersteuning'] = null;
  ___arguments.context.pageData['vptzbezoekwenselijk'] = null;
  ___arguments.context.pageData['vptzmogelijkheidondersteuning'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createclientarnhem/components/635b9b3cfa0449ff4e743a3953ee758a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false) {
    ___arguments.context.pageData['annuleren'] = true;
  } else {
    ___arguments.context.pageData['annuleren'] = false;
  }
  ___arguments.context.pageData['datumannulering'] = null;
  ___arguments.context.pageData['redenannulering'] = null;
  ___arguments.context.pageData['redenannuleringtoelichting'] = null;
  ___arguments.context.pageData['datumopname'] = null;
  ___arguments.context.pageData['overledenofvertrek'] = null;
  ___arguments.context.pageData['overledenofvertrekwaarnaar'] = null;
  ___arguments.context.pageData['datumoverlijdenofvertrek'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createclientarnhem/components/5e61d759ab962ff86d49a5181a7aadb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/d55d05c7518e07fcb822212568e29907/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datumaanmelding'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datumaanmelding'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createclientarnhem/components/aad597adb7fab92177593714eb8381c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datumannulering'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datumannulering'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/a32180de7ee9bc0fae2e817ead26aef6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datumopname'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datumopname'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/3e8df2facb434138ed237f0a57999c5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'vptzondersteuning')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/b7a6773da9c19284645f43dfdd2e5ccd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'vptzondersteuning')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/f86b52dd113c749e94958f73e646c3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.pageData['vptzbezoekwenselijk'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/08e1e4ebd0559c4503f206ca1d3f1c2e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/bd1c0cba24c9b8321f7cad159f78c8d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/a93411c4dd2aea075d5eeaee2d1ae93f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is vertrokken' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : ((getObjectProperty(___arguments.context.pageData, 'overledenofvertrek')) == 'De cliënt is overleden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/53eb59f6adcc2836d6037399b12d7085/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/7a64d0ca808eaff15abc7c3ee7513f1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerd')) == 'Ja' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/331967e50f86748ea80c88bab8524827/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/136b07c425f1562c8433ecbaa3fb8a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospiceuitplaatsingnietgerealiseerdreden')) == 'Andere reden' && (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/9a75ca82269a9d56f64d38543fbdb55a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/8adf30aaf608ce2275185609460261df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/bd48131ef0eb34d112de820617ac8fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'annuleren'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/5c946c2bd1753cfea6e778e65f27eee3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/a89240e3e29b439e79a3ab4663f293e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/16fbf577616ba29a27475fe1fed99c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/1123d6126c5f85cf6e4f13fdc6bb8077/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/c7499bc312a4b6051434c286cf243cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/76bd57ac607cdfda86dee12818ee52d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/26b248ade0178f8ac39f7eb52c7f1486/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/b1dde5997846fabb99540807b0e702ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false;
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/2d04a337178f0da5ce5f530c2b29e815/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/31521b2c0188e01314a69355fa541584/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/5647db75aa952ab4568349e5bebb45a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createclientarnhem/components/9be4ec31269652dba6477b081f6b8d9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aanmelden')) == false && (getObjectProperty(___arguments.context.pageData, 'annuleren')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard/components/4d34bee6924156ba10a49ab4af2d8872/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Rozenheuvel') {
    URL2 = 'https://lookerstudio.google.com/reporting/a338b09c-1662-4152-9f4c-c80345983881';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'De Hazelaar') {
    URL2 = 'https://lookerstudio.google.com/reporting/3e0b3a77-5401-461e-95d8-d1b34aac108c';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'De Goudvlinder') {
    URL2 = 'https://lookerstudio.google.com/reporting/3e0b3a77-5401-461e-95d8-d1b34aac108c';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'De Baroktuin') {
    URL2 = 'https://lookerstudio.google.com/reporting/3e0b3a77-5401-461e-95d8-d1b34aac108c';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Zuid-Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7789c28d-432f-4d8e-8f43-6b8fa6475d7a/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Waelwick') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7789c28d-432f-4d8e-8f43-6b8fa6475d7a/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Wijchen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a2c73798-bb03-4899-b206-e1e0999f1491/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Bethlehem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/4c3cf470-a085-41ee-a06d-5eed0aed7dc8/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Linde') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/bc0b5cbc-a7e0-4ac3-8edd-e6a5823e63f5/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'De brug Maas en Waal') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/bb37e14d-36d6-417f-b85d-5f8c275f932a/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Groningen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/afbdcb9c-208c-48d6-b28a-27ef2ace323f/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Gasthuis Groningen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d4029633-8fe1-4457-9806-787c643a1995/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Gasthuis Hoogezand-Sappemeer') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0c41be58-72c4-42ca-a07e-2854d82902e9/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Mantel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/53634ed1-f2fe-4f86-a269-0354cbe66542/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Schutse') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ec9b94c2-8085-4291-8b54-5cc8ebce4f17/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Mare Heymanscentrum') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c0c562b4-0c58-4e27-be9a-d9951c84e3dd/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Tineke Breiderhuis - Hospice Veen en Wolden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/b3e13865-1ac1-4ffe-84b0-4e7e33bf36c6/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Sint Maartenhuis') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e8b4252f-3bc0-4bec-970a-38004143b736/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Vredeborgh') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/736fd05b-3e9d-4aed-b132-8e9adddf8a16/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Spreng') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/378a55a3-96d4-4cd6-b51d-965e32ad618a/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Casa Vera') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ef9bf42a-5e07-49ec-9359-9f28c7a1bf49/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Zutphen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/5463d496-0fae-4b17-aae0-cd108743404e/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Apeldoorn') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3a2705b6-271c-469e-a560-791ee32e4190/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Buurtzorghuis Warnsveld') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a4a76ce6-9b54-436f-99ac-2684cb021535/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Oost-Veluwe') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/50de31f8-3d6f-4d1a-9877-a98c8cb37800/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Zuid-Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/1805beba-65f6-433c-84ff-38f4b5739938/page/p_37mf9rmkud';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Geerlinshospice') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/664a047c-48bf-49cb-ab66-5fc4d9b69baf/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Bronnenbos') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0757f9e4-5f8e-490d-9d5c-df11064ce9a9/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Bronnerhof') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c66559ca-e897-4227-9d9f-30f6f2a31742/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Martinus') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6a5c12e0-7bf3-476b-8397-eadab954279e/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Osiris') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6b4b057b-5163-4991-9d59-68b07785436a/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Trajectum') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/92c212eb-025e-42c4-a2c9-cc4e2bab70c1/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Vlinderhof') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/cc5afad7-10f3-40c7-a6f4-a3460aa6065b/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice de Mantelhof') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/8e005164-e939-4436-b081-de86214a1bb2/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Daniken') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/cdbbae62-12c1-4e69-bafc-94ed9bb2910f/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Hospice Mariaveld') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ffa906fd-a60a-44fe-9c70-06aad2bdc097/page/p_l3e4lblfqd';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardregionaal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardregionaal/components/4d34bee6924156ba10a49ab4af2d8872/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/84a2b1f0-37b8-4772-bc4d-5c3a05a50e9e/page/p_8j1usxh3ed';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/4ef0899d-0e99-4b45-b48c-510a370f5dc7/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d5dfd74a-b846-4b35-9fc5-799b92249cc0/page/vxfDD';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7789c28d-432f-4d8e-8f43-6b8fa6475d7a/page/vxfDD';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/exports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/exports/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/e37efcaeef75025918261d6cb7859dff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvclienten;


  csvclienten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/clienten.csv','tableName': 'clienten','tableOptions': ({ [`where`]: 'netwerkpz=\'Arnhem en de Liemers\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['clientnummer', 'datumaanmelding', 'datumannulering', 'datumopname', 'datumopnamegoed', 'datumoverlijdenofvertrek', 'datumoverlijdenofvertrekgoed', 'hospice', 'kenmerk', 'leeftijd', 'opnamejaar', 'overledenofvertrek', 'overledenofvertrekwaarnaar', 'redenannulering', 'redenannuleringtoelichting', 'status', 'verblijfsduur', 'verblijfsduurcategorie', 'zorgsettingvooropname', 'zorgsettingwelkziekenhuis', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['clientnummer', 'datumaanmelding', 'datumannulering', 'datumopname', 'datumopnamegoed', 'datumoverlijdenofvertrek', 'datumoverlijdenofvertrekgoed', 'hospice', 'kenmerk', 'leeftijd', 'opnamejaar', 'overledenofvertrek', 'overledenofvertrekwaarnaar', 'redenannulering', 'redenannuleringtoelichting', 'status', 'verblijfsduur', 'verblijfsduurcategorie', 'zorgsettingvooropname', 'zorgsettingwelkziekenhuis', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvclienten, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/2be5059bd7037acbfd7790147ab19e8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvalgemenegegevens;


  csvalgemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/algemenegegevens.csv','tableName': 'algemenegegevens','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['aantalbedden', 'hospice', 'locatie', 'soorthospice', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aantalbedden', 'hospice', 'locatie', 'soorthospice', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvalgemenegegevens, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/0b1bbfcf51fdc48fdb0665e2e818f147/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvwijzigingbedden;


  csvwijzigingbedden = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/wijzigingbedden.csv','tableName': 'wijzigingbedden','tableOptions': ({ [`where`]: 'hospice is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 100,[`properties`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvwijzigingbedden, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/97c6282d7e29a989ed0f455d4ba40cbe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvclienten;


  csvclienten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/exportclienten.csv','tableName': 'clienten','tableOptions': ({ [`where`]: ['netwerkpz=\'Groningen\' AND hospice<>\'Groningen\' OR ','netwerkpz=\'Zuid-Gelderland\'  AND hospice<>\'Zuid-Gelderland\' AND hospice<>\'Hospice de Linde\' OR ','netwerkpz=\'Zuid-Limburg\'  AND hospice<>\'Zuid-Limburg\' OR ','netwerkpz=\'Oost-Veluwe\'  AND hospice<>\'Oost-Veluwe\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['annuleringcontraindicatietoelichting', 'annuleringnaamhospice', 'annuleringnaamverpleeghuis', 'annuleringtoelichting', 'clientleeftijd', 'clientgeslacht', 'clientleeftijdgroep', 'clientnummer', 'clientpostcodecijfers', 'date(created) as created', 'externhospicesoortondersteuning', 'hospice', 'hospicecrisiszorg', 'hospiceindicatorenopnameanders', 'hospiceredengeenondersteuning', 'hospiceredengeenondersteuninganders', 'hospicerespijtzorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'hospiceuitplaatsingstabilistatie', 'indicanders', 'indicgeenzicht', 'indicinschatting', 'indicontbrekensociaal', 'indicoverbelast', 'indicspecifiekedeskundigheid', 'indicspecifiekewens', 'indicteweinig', 'locatiezorg', 'netwerkpz', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'thuiscrisiszorg', 'thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders', 'thuisredengeenondersteuning', 'thuisredengeenondersteuninganders', 'date(thuistrajectdatumannuleringvooropname) as thuistrajectdatumannuleringvooropname', 'date(thuistrajectdatuminformatievraag) as thuistrajectdatuminformatievraag', 'date(thuistrajectdatumopname) as thuistrajectdatumopname', 'date(thuistrajectdatumoverlijden) as thuistrajectdatumoverlijden', 'date(thuistrajectdatumuitplaatsing) as thuistrajectdatumuitplaatsing', 'date(thuistrajectdatumvraagvooropname) as thuistrajectdatumvraagvooropname', 'thuistrajectopnamejaar', 'thuistrajectverblijfsduur', 'thuistrajectverblijfsduurcategorie', 'thuisverwijzer', 'thuisverwijzeradres', 'thuisverwijzeragbcode', 'thuisverwijzeremail', 'thuisverwijzernaamplaats', 'thuisverwijzerplaats', 'thuisverwijzerpostcode', 'thuisverwijzertelefoonnummer', 'thuisvptzinzet', 'thuiszorgsettingvooropname', 'date(trajectdatumannuleringvooropname) as trajectdatumannuleringvooropname', 'date(trajectdatuminformatievraag) as trajectdatuminformatievraag', 'date(trajectdatumopname) as trajectdatumopname', 'date(trajectdatumoverlijden) as trajectdatumoverlijden', 'date(trajectdatumuitplaatsing) as trajectdatumuitplaatsing', 'date(trajectdatumvraagvooropname) as trajectdatumvraagvooropname', 'trajectopnamejaar', 'trajectverblijfsduur', 'trajectverblijfsduurcategorie', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzeranders', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzerziekenhuis', 'verwijzerziekenhuistoelichting', 'vptzinzet', 'zorgsettingvooropname', 'zorgsettingvooropnameanders', 'statuszorgtrajectfinal', 'trajectvertrekjaar', 'thuistrajectvertrekjaar', 'verwijzerzorgsoort', 'thuisverwijzerzorgsoort', 'trajectdagenopnameoverlijden', 'trajectdagenopnameoverlijdencategorie', 'trajectdagenoverlijdenuitgeleide', 'trajectdagenoverlijdenuitgeleidecategorie', 'trajectdagenvraagopnameopname', 'trajectdagenvraagopnameopnamecategorie', 'thuistrajectdagenopnameoverlijden', 'thuistrajectdagenopnameoverlijdencategorie', 'thuistrajectdagenopnameuitplaatsing', 'thuistrajectdagenopnameuitplaatsingcateg', 'thuistrajectdagenvraagopnameopname', 'thuistrajectdagenvraagopnameopnamecategorie', 'trajectdagenopnameuitplaatsing', 'trajectdagenopnameuitplaatsingcategorie', 'hospiceredenafsluiten', 'hospiceredenafsluitenlocatie', 'hospiceinzetlaatstedagen', 'trajectlimburg', 'clientgeboorteplaats as clientwoonplaats', 'overledenaanvullend', 'overledenmeestvoorkomendeziekte'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['annuleringcontraindicatietoelichting', 'annuleringnaamhospice', 'annuleringnaamverpleeghuis', 'annuleringtoelichting', 'clientleeftijd', 'clientgeslacht', 'clientleeftijdgroep', 'clientnummer', 'clientpostcodecijfers', 'created', 'externhospicesoortondersteuning', 'hospice', 'hospicecrisiszorg', 'hospiceindicatorenopnameanders', 'hospiceredengeenondersteuning', 'hospiceredengeenondersteuninganders', 'hospicerespijtzorg', 'hospiceuitplaatsingnietgerealiseerd', 'hospiceuitplaatsingnietgerealiseerdreden', 'hospiceuitplaatsingnietgerealiseerdredenander', 'hospiceuitplaatsingstabilistatie', 'indicanders', 'indicgeenzicht', 'indicinschatting', 'indicontbrekensociaal', 'indicoverbelast', 'indicspecifiekedeskundigheid', 'indicspecifiekewens', 'indicteweinig', 'locatiezorg', 'netwerkpz', 'overledenofvertrekwaarnaar', 'overledenofvertrekwaarnaaranders', 'thuisbehoefteondersteuning', 'thuisbehoefteondersteuninganders', 'thuiscrisiszorg', 'thuisoverledenofvertrekwaarnaar', 'thuisoverledenofvertrekwaarnaaranders', 'thuisredengeenondersteuning', 'thuisredengeenondersteuninganders', 'thuistrajectdatumannuleringvooropname', 'thuistrajectdatuminformatievraag', 'thuistrajectdatumopname', 'thuistrajectdatumoverlijden', 'thuistrajectdatumuitplaatsing', 'thuistrajectdatumvraagvooropname', 'thuistrajectopnamejaar', 'thuistrajectverblijfsduur', 'thuistrajectverblijfsduurcategorie', 'thuisverwijzer', 'thuisverwijzeradres', 'thuisverwijzeragbcode', 'thuisverwijzeremail', 'thuisverwijzernaamplaats', 'thuisverwijzerplaats', 'thuisverwijzerpostcode', 'thuisverwijzertelefoonnummer', 'thuisvptzinzet', 'thuiszorgsettingvooropname', 'trajectdatumannuleringvooropname', 'trajectdatuminformatievraag', 'trajectdatumopname', 'trajectdatumoverlijden', 'trajectdatumuitplaatsing', 'trajectdatumvraagvooropname', 'trajectopnamejaar', 'trajectverblijfsduur', 'trajectverblijfsduurcategorie', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzeranders', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzer', 'verwijzerziekenhuis', 'verwijzerziekenhuistoelichting', 'vptzinzet', 'zorgsettingvooropname', 'zorgsettingvooropnameanders', 'statuszorgtrajectfinal', 'trajectvertrekjaar', 'thuistrajectvertrekjaar', 'verwijzerzorgsoort', 'thuisverwijzerzorgsoort', 'trajectdagenopnameoverlijden', 'trajectdagenopnameoverlijdencategorie', 'trajectdagenoverlijdenuitgeleide', 'trajectdagenoverlijdenuitgeleidecategorie', 'trajectdagenvraagopnameopname', 'trajectdagenvraagopnameopnamecategorie', 'thuistrajectdagenopnameoverlijden', 'thuistrajectdagenopnameoverlijdencategorie', 'thuistrajectdagenopnameuitplaatsing', 'thuistrajectdagenopnameuitplaatsingcateg', 'thuistrajectdagenvraagopnameopname', 'thuistrajectdagenvraagopnameopnamecategorie', 'trajectdagenopnameuitplaatsing', 'trajectdagenopnameuitplaatsingcategorie', 'hospiceredenafsluiten', 'hospiceredenafsluitenlocatie', 'hospiceinzetlaatstedagen', 'trajectlimburg', 'clientwoonplaats', 'overledenaanvullend', 'overledenmeestvoorkomendeziekte'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvclienten, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/09251a08557fcf07baa6d0c4abcc7463/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvalgemenegegevens;


  csvalgemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/exportalgemenegegevens.csv','tableName': 'algemenegegevens','tableOptions': ({ [`where`]: 'hospice<>\'Groningen\' AND hospice<>\'Zuid-Gelderland\' AND  hospice<>\'Zuid-Limburg\' AND hospice<>\'Oost-Veluwe\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['netwerkpz', 'aantalbedden', 'hospice', 'locatie', 'soorthospice', 'regio', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['netwerkpz', 'aantalbedden', 'hospice', 'locatie', 'soorthospice', 'regio', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvalgemenegegevens, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/8ec868122ff61a1ebedeedfb555c7b47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvwijzigingbedden;


  csvwijzigingbedden = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/wijzigingbeddengroningen.csv','tableName': 'wijzigingbeddengroningen','tableOptions': ({ [`where`]: 'hospice is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvwijzigingbedden, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/3cafb2bd033b7166d85579f941243459/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvwijzigingbedden;


  csvwijzigingbedden = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/wijzigingbeddenzuidgelderland.csv','tableName': 'wijzigingbeddenzuidgelderland','tableOptions': ({ [`where`]: 'hospice is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvwijzigingbedden, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/356b5c885e640ff8517857889ba8d5c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvexportclienten;


  csvexportclienten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportgroningen/clientgegevensgroningen.csv','tableName': 'clienten','tableOptions': ({ [`where`]: ['netwerkpz=\'','Groningen','\' AND hospice <>\'Groningen\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['createddatum', 'hospice', 'anoniem', 'clientvoornaam', 'clientgeboortenaam', 'clientadres', 'clientpostcode', 'clientgeboorteplaats', 'clientgeboortedatum', 'clientgeslacht', 'clientleeftijd', 'clientleeftijdgroep', 'hospiceaanmeldenbijander', 'hospicecrisiszorg', 'hospiceredengeenondersteuning', 'hospicerespijtzorg', 'exportdatuminformatievraag', 'exportdatumannuleringvooropname', 'exportdatumopname', 'exportdatumuitplaatsing', 'exportdatumoverlijden', 'verwijzer', 'contactverwijzertoelichting'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['createddatum', 'hospice', 'anoniem', 'clientvoornaam', 'clientgeboortenaam', 'clientadres', 'clientpostcode', 'clientgeboorteplaats', 'clientgeboortedatum', 'clientgeslacht', 'clientleeftijd', 'clientleeftijdgroep', 'hospiceaanmeldenbijander', 'hospicecrisiszorg', 'hospiceredengeenondersteuning', 'hospicerespijtzorg', 'exportdatuminformatievraag', 'exportdatumannuleringvooropname', 'exportdatumopname', 'exportdatumuitplaatsing', 'exportdatumoverlijden', 'verwijzer', 'contactverwijzertoelichting'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvexportclienten, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/4c086638f3716d88d4da1812b9c81083/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvwijzigingbedden;


  csvwijzigingbedden = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/wijzigingbeddenoostveluwe.csv','tableName': 'wijzigingbeddenoostveluwe','tableOptions': ({ [`where`]: 'hospice is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvwijzigingbedden, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/3ff2f858582f728ee268dd08fcb97c56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvwijzigingbedden;


  csvwijzigingbedden = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/wijzigingbeddenzuidlimburg.csv','tableName': 'wijzigingbeddenzuidlimburg','tableOptions': ({ [`where`]: 'hospice is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'hospiceregio', 'objectId', 'ownerId', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['datumwijziging', 'hospice', 'hospicedatumwijziging', 'jaar', 'nieuwaantalbedden', 'hospiceregio', 'objectId', 'ownerId', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvwijzigingbedden, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/98d304049c1844711d890f5fa0c4b9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'Groningen\' AND hospice<>\'Groningen\' OR ','netwerkpz=\'Zuid-Gelderland\'  AND hospice<>\'Zuid-Gelderland\' AND hospice<>\'Hospice de Linde\' OR ','netwerkpz=\'Zuid-Limburg\'  AND hospice<>\'Zuid-Limburg\' OR ','netwerkpz=\'Oost-Veluwe\'  AND hospice<>\'Oost-Veluwe\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/exports/components/f963779e2838c95d14e804b8a9f81db1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('clienten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('netwerkpz=\'Arnhem en de Liemers\'')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  test = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100)));
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`hospice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'hospice')) }), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('De hospice dient geselecteerd te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'username': String(new Date()),'password': 'CVL2022isBegonnen!?','email': (getObjectProperty(___arguments.context.pageData, 'email')),'hospice': (getObjectProperty(___arguments.context.pageData, 'hospice')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'netwerkpz': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`clienten`]: true,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`rol`]: 'gebruiker' }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['hospice'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gebruikersbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bde9e67d676a4d4fc38326367d93cfb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus', 'username']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`hospice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')) }), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('De hospice dient geselecteerd te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'username': String(new Date()),'password': 'CVL2022isBegonnen!?','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'hospice': (getObjectProperty(___arguments.context.pageData, 'hospice')),'netwerkpz': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'hospice')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`clienten`]: true,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`rol`]: 'gebruiker' }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['hospice'] = null;
    ___arguments.context.pageData['naam'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setGroupBy('hospice').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a708f9b83b78de72ed51fe296c2ea9c6', (await Backendless.Data.of('setclientenlijst').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus', 'username']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus', 'username']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus', 'username']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/bde9e67d676a4d4fc38326367d93cfb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernew/components/c7f827fec2588bdf05bbfb4451e87dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['viewinformatievraag'] = (getObjectProperty(___arguments.context.dataModel, 'viewinformatievraag'));
  ___arguments.context.appData['viewvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewvraagvooropname'));
  ___arguments.context.appData['viewannuleringvraagvooropname'] = (getObjectProperty(___arguments.context.dataModel, 'viewannuleringvraagvooropname'));
  ___arguments.context.appData['viewopname'] = (getObjectProperty(___arguments.context.dataModel, 'viewopname'));
  ___arguments.context.appData['viewoverlijden'] = (getObjectProperty(___arguments.context.dataModel, 'viewoverlijden'));
  ___arguments.context.appData['viewuitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'viewuitplaatsingofuitgeleide'));
  ___arguments.context.appData['labeluitplaatsingofuitgeleide'] = (getObjectProperty(___arguments.context.dataModel, 'labeluitplaatsingofuitgeleide'));
  ___arguments.context.appData['setvptzinzet'] = (getObjectProperty(___arguments.context.dataModel, 'setvptzinzet'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`hospice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'hospice')) }), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('De hospice dient geselecteerd te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'username': String(new Date()),'password': 'CVL2022isBegonnen!?','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'hospice': (getObjectProperty(___arguments.context.pageData, 'hospice')),'netwerkpz': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'hospice')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`clienten`]: true,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`rol`]: 'gebruiker' }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['hospice'] = null;
    ___arguments.context.pageData['naam'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setGroupBy('hospice').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheernewwachtlijstbeheer/components/bde9e67d676a4d4fc38326367d93cfb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`hospice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'hospice')) }), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('De hospice dient geselecteerd te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'username': String(new Date()),'password': 'CVL2022isBegonnen!?','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'hospice': (getObjectProperty(___arguments.context.pageData, 'hospice')),'netwerkpz': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'hospice')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`clienten`]: true,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`hospice`]: (getObjectProperty(___arguments.context.pageData, 'hospice')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`rol`]: 'gebruiker' }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['hospice'] = null;
    ___arguments.context.pageData['naam'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setGroupBy('hospice').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND netwerkpz=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\' AND naam NOT LIKE \'lorio%\''].join(''))).setProperties(['naam', 'hospice', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheerperhospice/components/bde9e67d676a4d4fc38326367d93cfb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/helpdesk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/helpdesk/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesknew/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/helpdesknew/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['email'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesknewwachtlijstbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/helpdesknewwachtlijstbeheer/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['email'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/b4e8b57329ba9b3c520c9c2433d24fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Inzage in alle clienten van betreffende hospice',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: undefined }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hospiceclienten', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/525d3c3e9ae354e50069c3388b04f3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Lorio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/41120622-aa74-4e9e-8ac9-1ea0d8914dc5', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3e0b3a77-5401-461e-95d8-d1b34aac108c', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/b1552a32f7853c686a04402fd58dcf95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('algemenegegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d31925bbd59cf537b5e7f9ad9fd5c57', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/0021ac391567825f0b2fb66f67c5de5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/4a7870b61279d126f4c477f2dc77f1a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/1b84a1e44048d2c8b2d1e4acfc0ffb43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/2d8116c1f317173162ec3b1ed6431e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('declaratiesindienen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d5e4004805ab103a37114e53854ae9c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/225c13b318c16667346b1399374dfe7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d5b99dec7138de878fbdaa0d3d6c10ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('exports', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'lorioexports'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/adf1d32fa48e1a9a49524c9ee1cfae58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/s/uJSA37f_Mgo', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Rozenheuvel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/bd3fc1e74666f9a211e56539fc3196b4/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    URL2 = String(Backendless.appPath) + String('/files/images/Logo-Arnhem-Liemers.png');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bd3fc1e74666f9a211e56539fc3196b4'))['height'] = '100px';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    URL2 = String(Backendless.appPath) + String('/files/images/Logo-Groningen.png');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bd3fc1e74666f9a211e56539fc3196b4'))['height'] = '150px';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/hospiceclienten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginahospiceclienten'] = 'alleactiviteiten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginahospiceclienten'));
  ___arguments.context.pageData['statusfilter'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/hospiceclienten/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hospiceclienten/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hospiceclienten/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hospiceclienten/components/e30f956f40595365da44e8c750f3a3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createclientarnhem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createclientgroningen', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createclientgroningen', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hospiceclienten/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeclientarnhem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeclientgroningen', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeclientgroningen', undefined);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['hospice=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'aanmeldingen')) == false) {
    A = 'Datum aanmelding';
  }
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67ea79e5edfb40fc14ab7c2968b462e')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    B = 'Leeftijd';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Arnhem en de Liemers') {
    C = 'Geboortedatum';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client verwijdert',[`pagina`]: 'hospiceclienten',[`datum`]: (new Date()),[`clientnummer`]: (getObjectProperty(___arguments.deletedObject, 'clientnummer')) }) );
  await Backendless.Data.of('historieclienten').save(___arguments.deletedObject, true);

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12c454e2886534edcf4393894d22219', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a69240f4cce6798bf5d2c918c74c2f4', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ce3e81b02364eaa3c0c11e2f895e801')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7dfd192d040ea3656b0b8c42084ff3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/9b250b5ac5ef73d362b40c5ef967bc42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#89b087';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/8abb41ce996c4b251fb9cfd598ae3f9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.UserService.logout();
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await Backendless.UserService.logout();
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), false);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('groningen')) {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs') {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
          } else {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
          }
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
        }
      } else if ((await Backendless.UserService.getUserRoles()).includes('zuidgelderland')) {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Gelderland', undefined);
        }
      } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwe')) {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstOost-Veluwe', undefined);
        }
      } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwewachtlijstbeheer')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('wachtlijstbeheerOost-Veluwe', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('newusers', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('zuidlimburg')) {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Limburg', undefined);
        }
      }
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0ea61c9bfc8fb45df3185d0f605189d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/00c12203fb5fb62c8d517401c5968862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/a93bf7d2200d316ea8b84df54d54268d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1djBArrai6DniHaFHvoAtTI27atjb_t5p/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/e25e730f4496710a17447c23a4ebcf75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/9cee8611c65586ee7e197b9748a61e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/GebruikersvoorwaardenHospicesv1.2.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/8d13f77ed0f6d6fba43dc24c3881d24e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/newusers/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/4a67327458c19016e76ef8c6c29d9487/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('netwerkpz').setSortBy('netwerkpz ASC').setGroupBy('netwerkpz').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'netwerkpz')),[`label`]: (getObjectProperty(item, 'netwerkpz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['username'] = null;
  ___arguments.context.pageData['hospice'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/newusers/components/6bffa1831d56fc9d986bf61b85b50b14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, coordinatorlist, coordinator, j, userslist, users, k, clientenlist, clienten, gebruikersnetwerkpzlist, gebruikersnetwerkpz, checkcodes2list, checkcodes2, users2list, checkcodeslist, checkcodes, setclientenlijstlist, setclientenlijst, bewonerskenmerkenlist, bewonerskenmerken, algemenegegevenslist, algemenegegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['username', 'objectId', 'hospice', 'netwerkpz', 'naam', 'lastLogin', 'userStatus', 'beheerder', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`username`]: (getObjectProperty(j, 'username')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`hospice`]: (getObjectProperty(j, 'hospice')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')),[`naam`]: (getObjectProperty(j, 'naam')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`beheerder`]: (getObjectProperty(j, 'beheerder')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  coordinator = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\' AND coordinator = TRUE'].join('')) }));
  coordinatorlist = (await Promise.all(coordinator.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in coordinatorlist) {
    l = coordinatorlist[l_index];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsclienten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    clienten = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['objectId'] }));
    clientenlist = (await Promise.all(clienten.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in clientenlist) {
      k = clientenlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSCLIENTEN UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersnetwerkpz() {
  await Backendless.Data.of('gebruikersnetwerkpz').bulkDelete( (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['objectId', 'netwerkpz'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    await Backendless.Data.of('gebruikersnetwerkpz').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')) }) );
  }
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var j_index4 in userslist) {
    j = userslist[j_index4];
    gebruikersnetwerkpz = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    gebruikersnetwerkpzlist = (await Promise.all(gebruikersnetwerkpz.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index2 in gebruikersnetwerkpzlist) {
      k = gebruikersnetwerkpzlist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'gebruikersnetwerkpz',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\' AND userStatus=\'ENABLED\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('PERMISSIONSUSERS UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionscheckcodes() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['userobjectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var k_index3 in userslist) {
    k = userslist[k_index3];
    checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    checkcodeslist = (await Promise.all(checkcodes.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index5 in checkcodeslist) {
      j = checkcodeslist[j_index5];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index3 in users2list) {
    m = users2list[m_index3];
    checkcodes2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    checkcodes2list = (await Promise.all(checkcodes2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index4 in checkcodes2list) {
      l = checkcodes2list[l_index4];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSCHECKCODES UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionssetclientenlijst() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index4 in users2list) {
    m = users2list[m_index4];
    setclientenlijst = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'setclientenlijst','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    setclientenlijstlist = (await Promise.all(setclientenlijst.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index5 in setclientenlijstlist) {
      l = setclientenlijstlist[l_index5];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'setclientenlijst',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSSETCLIENTENLIJST UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsbewonerskenmerken() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index5 in users2list) {
    m = users2list[m_index5];
    bewonerskenmerken = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'bewonerskenmerken','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    bewonerskenmerkenlist = (await Promise.all(bewonerskenmerken.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index6 in bewonerskenmerkenlist) {
      l = bewonerskenmerkenlist[l_index6];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'bewonerskenmerken',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSBEWONERSKENMERKEN UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsalgemenegegevens() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index6 in users2list) {
    m = users2list[m_index6];
    algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index7 in algemenegegevenslist) {
      l = algemenegegevenslist[l_index7];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsclienten();
    await permissionsgebruikersbeheer();
    await permissionsgebruikersnetwerkpz();
    await permissionsusers();
    await permissionscheckcodes();
    await permissionssetclientenlijst();
    await permissionsbewonerskenmerken();
    await permissionsalgemenegegevens();
    (function (message) { alert(message) })((['Permissions zijn toegekend voor dit hospice in de volgende tabellen: \n','clienten \n','gebruikersbeheer \n','gebruikersnetwerkpz \n','Users \n','checkcodes \n','setclientenlijst \n','bewonerskenmerken \n','algemenegegevens'].join('')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/50d88a533309a7c111aecc370bf5e64a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join(''))).setProperties('username').setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74a987dbc553d5f494b245b5be829e17', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/newusers/components/cda16edb19fd7ad40e4359bdbeab01f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dataalgemeen, item, j, clientenobjectidlist, clientenobjectid, m, l, algemenegegevenslist, algemenegegevens, users2list, users2, gebruikersbeheerlist, gebruikersbeheer, userslist2, coordinatorlist, coordinator, userslist, users, k, clientenlist, clienten, checkcodes2list, checkcodes2, checkcodeslist, checkcodes, setclientenlijstlist, setclientenlijst, bewonerskenmerkenlist, bewonerskenmerken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function algemene_wachtlijst_proces_oost_veluwe() {
  clientenobjectid = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['netwerkpz=\'','Oost-Veluwe','\''].join('')) }));
  clientenobjectidlist = (await Promise.all(clientenobjectid.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in clientenobjectidlist) {
    j = clientenobjectidlist[j_index];
    dataalgemeen = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['objectId=\'',j,'\''].join('')),'properties': ['clientnummer', 'netwerkpz', 'hospice', 'statuszorgtrajectfinal', 'objectId', 'delenakkoord', 'clientdirectgeplaatst'] })).map(async item => {; return ({ [`clientnummer`]: (getObjectProperty(item, 'clientnummer')),[`netwerkpz`]: (getObjectProperty(item, 'netwerkpz')),[`hospice`]: (getObjectProperty(item, 'hospice')),[`statuszorgtrajectfinal`]: (getObjectProperty(item, 'statuszorgtrajectfinal')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`delenakkoord`]: (getObjectProperty(item, 'delenakkoord')),[`clientdirectgeplaatst`]: (getObjectProperty(item, 'clientdirectgeplaatst')) });})))[0];
    if ((getObjectProperty(dataalgemeen, 'netwerkpz')) == 'Oost-Veluwe') {
      if ((getObjectProperty(dataalgemeen, 'statuszorgtrajectfinal')) == 'Aanmelding voor opname' || (getObjectProperty(dataalgemeen, 'statuszorgtrajectfinal')) == 'Verwijzing terminale thuiszorg') {
        if ((getObjectProperty(dataalgemeen, 'delenakkoord')) == 'Ja' && (getObjectProperty(dataalgemeen, 'clientdirectgeplaatst')) == 'Ja') {
          await permissions_instellen_voor_iedereen();
        } else if (getObjectProperty(dataalgemeen, 'delenakkoord')) {
          await permissions_instellen_voor_1_hospice();
        }
      } else if ((getObjectProperty(dataalgemeen, 'statuszorgtrajectfinal')) != 'Aanmelding voor opname' || (getObjectProperty(dataalgemeen, 'statuszorgtrajectfinal')) != 'Verwijzing terminale thuiszorg') {
        await permissions_instellen_voor_1_hospice();
      }
    }
  }
}

/**
 * Describe this function...
 */
async function permissionsalgemenegegevensoostveluwe() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in algemenegegevenslist) {
      l = algemenegegevenslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['username', 'objectId', 'hospice', 'netwerkpz', 'naam', 'lastLogin', 'userStatus', 'beheerder', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`username`]: (getObjectProperty(j, 'username')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`hospice`]: (getObjectProperty(j, 'hospice')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')),[`naam`]: (getObjectProperty(j, 'naam')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`beheerder`]: (getObjectProperty(j, 'beheerder')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  coordinator = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\' AND coordinator = TRUE'].join('')) }));
  coordinatorlist = (await Promise.all(coordinator.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in coordinatorlist) {
    l = coordinatorlist[l_index2];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index3 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == 'Oost-Veluwe') {
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND netwerkpz=\'','Oost-Veluwe','\''].join('')) }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index4 in userslist2) {
      l = userslist2[l_index4];
      gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'','Oost-Veluwe','\''].join('')) }));
      gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index4 in gebruikersbeheerlist) {
        m = gebruikersbeheerlist[m_index4];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
      }
    }
  }
  console.log('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsclienten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    clienten = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['objectId'] }));
    clientenlist = (await Promise.all(clienten.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in clientenlist) {
      k = clientenlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSCLIENTEN UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index5 in userslist2) {
    l = userslist2[l_index5];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('PERMISSIONSUSERS UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionscheckcodes() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var k_index2 in userslist) {
    k = userslist[k_index2];
    checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    checkcodeslist = (await Promise.all(checkcodes.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index4 in checkcodeslist) {
      j = checkcodeslist[j_index4];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index5 in users2list) {
    m = users2list[m_index5];
    checkcodes2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    checkcodes2list = (await Promise.all(checkcodes2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index6 in checkcodes2list) {
      l = checkcodes2list[l_index6];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSCHECKCODES UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionssetclientenlijst() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var m_index6 in users2list) {
    m = users2list[m_index6];
    setclientenlijst = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'setclientenlijst','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    setclientenlijstlist = (await Promise.all(setclientenlijst.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index7 in setclientenlijstlist) {
      l = setclientenlijstlist[l_index7];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'setclientenlijst',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSSETCLIENTENLIJST UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsbewonerskenmerken() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var m_index7 in users2list) {
    m = users2list[m_index7];
    bewonerskenmerken = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'bewonerskenmerken','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    bewonerskenmerkenlist = (await Promise.all(bewonerskenmerken.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index8 in bewonerskenmerkenlist) {
      l = bewonerskenmerkenlist[l_index8];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'bewonerskenmerken',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSBEWONERSKENMERKEN UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsalgemenegegevens() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == 'Oost-Veluwe') {
    for (var m_index8 in users2list) {
      m = users2list[m_index8];
      algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
      algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index9 in algemenegegevenslist) {
        l = algemenegegevenslist[l_index9];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      }
    }
  } else {
    for (var m_index9 in users2list) {
      m = users2list[m_index9];
      algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
      algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index10 in algemenegegevenslist) {
        l = algemenegegevenslist[l_index10];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      }
    }
    console.log('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
  }
}

/**
 * Describe this function...
 */
async function oude_code() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
}

/**
 * Describe this function...
 */
async function permissions_instellen_voor_iedereen() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var m_index10 in users2list) {
    m = users2list[m_index10];
    await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
    await Backendless.Data.Permissions.REMOVE.grantForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
  }
  console.log('PERMISSIONS ALGEMENE WACHTLIJST PROCES UITGEVOERD>> iedereen');
}

/**
 * Describe this function...
 */
async function permissions_instellen_voor_1_hospice() {
  if ((getObjectProperty(___arguments.context.pageData, 'hospice')) != (getObjectProperty(dataalgemeen, 'hospice'))) {
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
    users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index11 in users2list) {
      m = users2list[m_index11];
      await Backendless.Data.Permissions.FIND.denyForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.denyForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.denyForUser(m, ({ [`___class`]: 'clienten',[`objectId`]: (getObjectProperty(dataalgemeen, 'objectId')) }));
    }
    console.log('PERMISSIONS ALGEMENE WACHTLIJST PROCES UITGEVOERD >>> 1 hospice');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else if ((getObjectProperty(___arguments.context.pageData, 'username')) == null) {
    (function (message) { alert(message) })('Selecteer een user');
  } else {
    await permissionsclienten();
    await permissionsgebruikersbeheer();
    await permissionsusers();
    await permissionscheckcodes();
    await permissionssetclientenlijst();
    await permissionsbewonerskenmerken();
    await permissionsalgemenegegevens();
    if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == 'Oost-Veluwe') {
      await algemene_wachtlijst_proces_oost_veluwe();
      await permissionsalgemenegegevensoostveluwe();
    }
    (function (message) { alert(message) })((['Permissions zijn toegekend voor deze user in de volgende tabellen: \n','clienten \n','gebruikersbeheer \n','Users \n','checkcodes \n','setclientenlijst \n','bewonerskenmerken \n','algemenegegevens'].join('')));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/newusers/components/67f403196da705f23d86dfac2267d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var aanvrager, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'netwerkpz')) == 'Zuid-Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzuidgelderland', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'netwerkpz')) == 'Groningen') {
    await Backendless.Messaging.sendEmailFromTemplate('newusergroningen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'netwerkpz')) == 'Arnhem en de Liemers') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserarnhemendeliemers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'netwerkpz')) == 'Oost-Veluwe') {
    await Backendless.Messaging.sendEmailFromTemplate('newuseroostveluwe', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'netwerkpz')) == 'Zuid-Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzuidlimburg', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  }
  aanvrager = (await Promise.all((await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty(___arguments.context.dataModel, 'naam')),'\' AND netwerkpz=\'',(getObjectProperty(___arguments.context.dataModel, 'netwerkpz')),'\' AND hospice=\'',(getObjectProperty(___arguments.context.dataModel, 'hospice')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`aangemelddooremail`]: (getObjectProperty(item, 'aangemelddooremail')) });})))[0];
  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(aanvrager, 'aangemelddooremail'));
  await Backendless.Messaging.sendEmailFromTemplate('newuseraangemaakt', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`netwerkpz`]: (getObjectProperty(___arguments.context.dataModel, 'netwerkpz')),[`hospice`]: (getObjectProperty(___arguments.context.dataModel, 'hospice')) }), undefined);
  (function (message) { alert(message) })('De email is verzonden naar de aanvrager');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/55ba459dcfaed94d751afdc9cdd8191d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setGroupBy('hospice').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['username'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/newusers/components/3c46bf080591e52937d1171cdf247b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, clientenlist, item, clienten, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsclienten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    clienten = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['objectId'] }));
    clientenlist = (await Promise.all(clienten.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in clientenlist) {
      k = clientenlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSCLIENTEN UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSCLIENTEN UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsclienten();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/d35d2ecc5053f5d217e97dd6aa67a7fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, coordinatorlist, coordinator, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['username', 'objectId', 'hospice', 'netwerkpz', 'naam', 'lastLogin', 'userStatus', 'beheerder', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`username`]: (getObjectProperty(j, 'username')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`hospice`]: (getObjectProperty(j, 'hospice')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')),[`naam`]: (getObjectProperty(j, 'naam')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`beheerder`]: (getObjectProperty(j, 'beheerder')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  coordinator = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\' AND coordinator = TRUE'].join('')) }));
  coordinatorlist = (await Promise.all(coordinator.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in coordinatorlist) {
    l = coordinatorlist[l_index];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsgebruikersbeheer();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/a68db61433b22daeb3e3c9beb0d3c9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\' AND userStatus=\'ENABLED\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('PERMISSIONSUSERS UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSUSERS UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsusers();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/6bc1eb1890ed658b37646039cf91449f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, l, checkcodes2list, item, checkcodes2, users2list, users2, k, j, checkcodeslist, checkcodes, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionscheckcodes() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['userobjectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var k_index in userslist) {
    k = userslist[k_index];
    checkcodes = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    checkcodeslist = (await Promise.all(checkcodes.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index in checkcodeslist) {
      j = checkcodeslist[j_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(k, ({ [`___class`]: 'checkcodes',[`objectId`]: j }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    checkcodes2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'checkcodes','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    checkcodes2list = (await Promise.all(checkcodes2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in checkcodes2list) {
      l = checkcodes2list[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'checkcodes',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSCHECKCODES UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSCHECKCODES UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionscheckcodes();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/6d83db8d08a3a7c2f23623f3f7fcfbdf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, l, setclientenlijstlist, item, setclientenlijst, users2list, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionssetclientenlijst() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    setclientenlijst = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'setclientenlijst','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    setclientenlijstlist = (await Promise.all(setclientenlijst.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in setclientenlijstlist) {
      l = setclientenlijstlist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'setclientenlijst',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSSETCLIENTENLIJST UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSSETCLIENTENLIJST UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionssetclientenlijst();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/06afe53f20dd88c4c8a3fa47993e261e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, l, bewonerskenmerkenlist, item, bewonerskenmerken, users2list, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsbewonerskenmerken() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    bewonerskenmerken = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'bewonerskenmerken','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    bewonerskenmerkenlist = (await Promise.all(bewonerskenmerken.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in bewonerskenmerkenlist) {
      l = bewonerskenmerkenlist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'bewonerskenmerken',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSBEWONERSKENMERKEN UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSBEWONERSKENMERKEN UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsbewonerskenmerken();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/a82c20491441c4b947942eddaf1c1456/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, l, algemenegegevenslist, item, algemenegegevens, users2list, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsalgemenegegevens() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')),'properties': ['userobjectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in algemenegegevenslist) {
      l = algemenegegevenslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else {
    await permissionsalgemenegegevens();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/38544ae3bb434cbcbd9fdb98942eef03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gebruikersnetwerkpzlist, item, gebruikersnetwerkpz, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersnetwerkpz() {
  await Backendless.Data.of('gebruikersnetwerkpz').bulkDelete( (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['objectId', 'netwerkpz'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersnetwerkpz').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')) }) );
  }
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    gebruikersnetwerkpz = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    gebruikersnetwerkpzlist = (await Promise.all(gebruikersnetwerkpz.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in gebruikersnetwerkpzlist) {
      k = gebruikersnetwerkpzlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'gebruikersnetwerkpz',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else {
    await permissionsgebruikersnetwerkpz();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/ccf5c42ddb3886f64d6d90d4844b3eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('netwerkpz').setSortBy('netwerkpz ASC').setGroupBy('netwerkpz').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'netwerkpz')),[`label`]: (getObjectProperty(item, 'netwerkpz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/newusers/components/3d88a48a09581f68bb64c10e48c7ddf7/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join(''))).setProperties('hospice').setSortBy('hospice ASC').setGroupBy('hospice').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'hospice')),[`label`]: (getObjectProperty(item, 'hospice')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/newusers/components/bfb66cb2f42e8afcf5b28649842d0c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, newuser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newuser = (await Backendless.UserService.register( new Backendless.User({ 'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'hospice')),'username': (getObjectProperty(___arguments.context.pageData, 'usernameregister')),'password': 'CVL2022isBegonnen!@!','hospice': (getObjectProperty(___arguments.context.pageData, 'hospice')),'netwerkpz': (getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'beheerder': (getObjectProperty(___arguments.context.pageData, 'beheerder')),'gebruikersbeheer': (getObjectProperty(___arguments.context.pageData, 'gebruikersbeheer')),'coordinator': (getObjectProperty(___arguments.context.pageData, 'coordinator')) }) ));
  (function (message) { alert(message) })((['User is geregistreerd: \n',['Naam: ',(getObjectProperty(newuser, 'naam')),' \n'].join(''),['Email: ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Username:  ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Netwerkpz:  ',(getObjectProperty(newuser, 'netwerkpz')),' \n'].join(''),['Hospice:  ',(getObjectProperty(newuser, 'hospice')),' \n'].join(''),['Beheerder:  ',(getObjectProperty(newuser, 'beheerder')),' \n'].join(''),['Gebruikersbeheer:  ',(getObjectProperty(newuser, 'gebruikersbeheer')),' \n'].join('')].join('')));
  var j_list = ['naam', 'email', 'organisatie', 'usernameregister', 'beheerder', 'gebruikersbeheer', 'coordinator'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/05ab59ac7c3b9157ad86d6a130cb67a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\' AND dashboardnaam <>\'lorio\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/newusers/components/9449ebc70bf23e2a1d64b969cf6647d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/newusers/components/7fd34b2d2aeacf5722c21c6be2de601d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, l, algemenegegevenslist, item, algemenegegevens, users2list, users2, j, k, clientenlist, clienten, userslist, users, gebruikersbeheerlist, gebruikersbeheer, userslist2, coordinatorlist, coordinator;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsalgemenegegevens() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  users2list = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var m_index in users2list) {
    m = users2list[m_index];
    algemenegegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'algemenegegevens','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    algemenegegevenslist = (await Promise.all(algemenegegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in algemenegegevenslist) {
      l = algemenegegevenslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'algemenegegevens',[`objectId`]: l }));
    }
  }
  console.log('PERMISSIONSALGEMENEGEGEVENS UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsclienten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    clienten = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'clienten','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['objectId'] }));
    clientenlist = (await Promise.all(clienten.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in clientenlist) {
      k = clientenlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'clienten',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSCLIENTEN UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['username', 'objectId', 'hospice', 'netwerkpz', 'naam', 'lastLogin', 'userStatus', 'beheerder', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`username`]: (getObjectProperty(j, 'username')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`hospice`]: (getObjectProperty(j, 'hospice')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')),[`naam`]: (getObjectProperty(j, 'naam')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`beheerder`]: (getObjectProperty(j, 'beheerder')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  coordinator = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\' AND gebruikersbeheer= TRUE'].join('')) }));
  coordinatorlist = (await Promise.all(coordinator.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in coordinatorlist) {
    l = coordinatorlist[l_index2];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['hospice=\'',(getObjectProperty(___arguments.context.pageData, 'hospice')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index3 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSBEHEER UITGEVOERD');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('PERMISSIONSUSERS UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else if ((getObjectProperty(___arguments.context.pageData, 'hospice')) == null) {
    (function (message) { alert(message) })('Selecteer een hospice');
  } else if ((getObjectProperty(___arguments.context.pageData, 'username')) == null) {
    (function (message) { alert(message) })('Selecteer een user');
  } else {
    await permissionsalgemenegegevens();
    await permissionsclienten();
    await permissionsgebruikersbeheer();
    await permissionsusers();
    (function (message) { alert(message) })((['Permissions zijn toegekend voor deze user in de volgende tabellen: \n','algemenegegevens \n','clienten \n','gebruikersbeheer \n','Users \n'].join('')));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/newusers/components/f70251393c7354b6429211b805c35bc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gebruikersnetwerkpzlist, item, gebruikersnetwerkpz, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersnetwerkpz() {
  await Backendless.Data.of('gebruikersnetwerkpz').bulkDelete( (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['objectId', 'netwerkpz'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersnetwerkpz').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`netwerkpz`]: (getObjectProperty(j, 'netwerkpz')) }) );
  }
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')),'properties': ['userobjectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    gebruikersnetwerkpz = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersnetwerkpz','whereClause': (['netwerkpz=\'',(getObjectProperty(___arguments.context.pageData, 'netwerkpz')),'\''].join('')) }));
    gebruikersnetwerkpzlist = (await Promise.all(gebruikersnetwerkpz.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in gebruikersnetwerkpzlist) {
      k = gebruikersnetwerkpzlist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'gebruikersnetwerkpz',[`objectId`]: k }));
    }
  }
  console.log('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
  (function (message) { alert(message) })('PERMISSIONSGEBRUIKERSNETWERKPZ UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'netwerkpz')) == null) {
    (function (message) { alert(message) })('Selecteer een netwerkpz');
  } else {
    await permissionsgebruikersnetwerkpz();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newusers/components/53a84c6869612864278338515108a0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, recordslist, item, records, refdate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('groningen'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwe'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwewachtlijstbeheer'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('zuidgelderland'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('zuidlimburg'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
}

/**
 * Describe this function...
 */
async function do_something2() {
  if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('groningen')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('zuidgelderland')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Gelderland', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwe')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstOost-Veluwe', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwewachtlijstbeheer')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('wachtlijstbeheerOost-Veluwe', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('newusers', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('zuidlimburg')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Limburg', undefined);
    }
  }
}


  refdate = ((new Date((new Date()).getTime() - (7894848 * 1000))).valueOf());
  records = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'vragenlijstemails','whereClause': (['sendinvite != true AND ','startdate <=\'',refdate,'\''].join('')) }));
  recordslist = (await Promise.all(records.map(async item => {; return item;})));
  for (var j_index in recordslist) {
    j = recordslist[j_index];
    await Backendless.Messaging.sendEmailFromTemplate('vragenlijstemailtest', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(j, 'email')), ccAddresses: undefined, bccAddresses: 'info@lorio.nl', query: '', uniqueEmails: true }), ({ [`sendlink`]: (getObjectProperty(j, 'sendlink')) }), undefined);
    await Backendless.Data.of('vragenlijstemails').bulkUpdate( (['objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join('')), ({ [`senddate`]: (new Date()),[`sendinvite`]: true }) );
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('groningen')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstGroningen', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('zuidgelderland')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Gelderland', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwe')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstOost-Veluwe', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('oostveluwewachtlijstbeheer')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('wachtlijstbeheerOost-Veluwe', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('newusers', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('zuidlimburg')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientenlijstZuid-Limburg', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/strippenkaart/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/strippenkaart/components/4d34bee6924156ba10a49ab4af2d8872/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
    URL2 = 'https://docs.google.com/spreadsheets/d/1KeOGX72z-bMsuU-q0AweEyk1RwkUkcr_xyrhmrHEiIo/edit?usp=sharing';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
    URL2 = 'https://docs.google.com/spreadsheets/d/1PT9cr77Cvd_hrNVvjogl743EXGC7B7l97pXB9ijmlM8/edit?usp=sharing';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/vektis/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vektis/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    await Backendless.Request.post(`${Backendless.appPath}/services/Vektis/raadplegenzorgsoortenzorgverlener`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/de9799651946cdd5cf5698c1f88f7a98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/raadplegenactieveagbcodes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/a80b7e7c12b17aef721b78bc706ee2d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisondernemingstap1`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/5d995f26343ff8e5db078a0352470082/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisondernemingstap2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/f804d6b6294f3c64225970a47aef55b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/raadplegenreferentiesprovincies`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/fb4715b88a29c359f90dc1e411c13e8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisvestigingstap1`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/76331c55f4f454b597568868f4e5f8b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisvestigingstap2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/f74851628fe10d96d8ff0555947a003c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasiszorgverlenerstap1`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/6c42bee6666e24e1a848cbdc3db193c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasiszorgverlenerstap2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/dad8a19418895f2eb6c201160d0bf22a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/raadplegenzorgsoortenondernemingvestiging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/18cd13bef9d1ee4eb25c75e104c5da3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisondernemingstap3`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/5a0d4d7505349b98e5ea0128f1a4db61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisvestigingstap3`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vektis/components/231f5be2fc6d10773fe799ead777a866/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'password')) == 'Lieke' && (getObjectProperty(___arguments.context.pageData, 'run')) == 'run') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', true);
    if ((getObjectProperty(___arguments.context.pageData, 'confirm')) == 'jazeker') {
      await Backendless.Request.get(`${Backendless.appPath}/services/Vektis/vektisbasisgegevenslijst`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a49ab2693aed9c1f3f6175fb0444167', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwe'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['aantalopgenomen1'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Oost-Veluwe','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen2'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Apeldoorn','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen3'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice de Spreng','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen4'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Casa Vera','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen5'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Zutphen','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen6'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Buurtzorghuis Warnsveld','\''].join('')))));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) != 'Transfer bureau' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == false) {
    ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
    ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
    ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
    await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filter'))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/9119fe9d96dce35478d31a4b480d1574/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Oost-Veluwe','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden1'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/7c66b762a48d5c326ad9880f417b5645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden1')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen1')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/7ec4d266dad8fbf238119e6e238cdd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden2')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen2')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/e3852551822f8c2d5078d251cee5ab3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden3')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen3')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/5dc643bfab4ad0ecd8bf56ecb367f809/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden4')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen4')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/2157af747b82538d203db07ec154ee1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden5')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen5')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/f291ecfca475ca4937593566d9be43c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Apeldoorn','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden2'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/770c35538c78986532cecba47aa16276/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice de Spreng','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden3'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/899c0b0457aeaba6cfbe25ed89287547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Casa Vera','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden4'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/11ed666202126401e39409c6f7e69a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Zutphen','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden5'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/aaed4a1b26b6d59cbd62bf2dfeb42242/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/cfa2bf647afaae0321354f7ca766f4aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen2'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/d087833ea1956ffb0a1e88ef8506904e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen3'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/7683a337e8c1d7a965842fa37eec016c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen4'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/b36f0385b73296d82743ef18d7c897e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen5'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/c39af8e1920ccc4e5a9dd5eea752dc26/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['filter'] = (['netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/42e6f357d0732d75677b68fb2a6b2c4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Oost-Veluwe','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Oost-Veluwe','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/822c2aab7cbe009ece1606f94d77f9df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Apeldoorn','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Hospice Apeldoorn','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/f444f3a959ee963b41bf438791f2e92c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice de Spreng','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Hospice de Spreng','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/8b6fe7de2af461d9d437c11edaa54a93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Casa Vera','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Hospice Casa Vera','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/32965724f1cffabb37c623858ebb5c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Zutphen','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Hospice Zutphen','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/9679878b47b57701e4ed39c506d3ec05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/6b4e3f02e4f4fe0b0efcf77df5295955/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Buurtzorghuis Warnsveld','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden6'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/d2c19835a1f2666dbf623e91fcbfc5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen6'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/bf992ef4c05717a49d6c7a6189873c43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden6')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen6')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/aac92d06af8a44b59242c3b6641fd197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Buurtzorghuis Warnsveld','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' AND clientdirectgeplaatst=\'Ja\'',' OR hospice=\'','Buurtzorghuis Warnsveld','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\'',' AND clientdirectgeplaatst=\'Ja\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstOost-Veluwe/components/a02e0ecd729f6e5db19888412297c0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriooostveluwe')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('oostveluwewachtlijstbeheer'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['aantalopgenomen1'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Oost-Veluwe','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen2'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Apeldoorn','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen3'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice de Spreng','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen4'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Casa Vera','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen5'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Zutphen','\''].join('')))));
  ___arguments.context.pageData['aantalopgenomen6'] = (await Backendless.Data.of('wachtlijstopgenomen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Buurtzorghuis Warnsveld','\''].join('')))));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5115a281bd094a8cd99b994e10d110eb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/63bcb30cd052ddf885e5014f70231df5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud() {
  ___arguments.context.appData['clientnummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'clientnummer'))));
  ___arguments.context.appData['clientobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['status'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  await Backendless.Data.of('historielog').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`hospice`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')),[`netwerkpz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')),[`actie`]: 'Client geopend',[`pagina`]: 'changeclient',[`datum`]: (new Date()),[`clientnummer`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'clientnummer')))) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogroningenlieke') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientGroningenLieke', undefined);
  } else {
  }
}

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filter'))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/9119fe9d96dce35478d31a4b480d1574/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Oost-Veluwe','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden1'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/7c66b762a48d5c326ad9880f417b5645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden1')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen1')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/7ec4d266dad8fbf238119e6e238cdd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden2')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen2')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/e3852551822f8c2d5078d251cee5ab3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden3')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen3')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/5dc643bfab4ad0ecd8bf56ecb367f809/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden4')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen4')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/2157af747b82538d203db07ec154ee1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden5')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen5')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/f291ecfca475ca4937593566d9be43c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Apeldoorn','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden2'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/770c35538c78986532cecba47aa16276/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice de Spreng','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden3'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/899c0b0457aeaba6cfbe25ed89287547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Casa Vera','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden4'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/11ed666202126401e39409c6f7e69a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Hospice Zutphen','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden5'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/aaed4a1b26b6d59cbd62bf2dfeb42242/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/cfa2bf647afaae0321354f7ca766f4aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen2'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/d087833ea1956ffb0a1e88ef8506904e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen3'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/7683a337e8c1d7a965842fa37eec016c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen4'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/b36f0385b73296d82743ef18d7c897e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen5'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/c39af8e1920ccc4e5a9dd5eea752dc26/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['filter'] = (['netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/42e6f357d0732d75677b68fb2a6b2c4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Oost-Veluwe','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Oost-Veluwe','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/822c2aab7cbe009ece1606f94d77f9df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Apeldoorn','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Hospice Apeldoorn','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/f444f3a959ee963b41bf438791f2e92c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice de Spreng','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Hospice de Spreng','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/8b6fe7de2af461d9d437c11edaa54a93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Casa Vera','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Hospice Casa Vera','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/32965724f1cffabb37c623858ebb5c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Hospice Zutphen','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Hospice Zutphen','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/9679878b47b57701e4ed39c506d3ec05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR netwerkpz=\'Oost-Veluwe\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/6b4e3f02e4f4fe0b0efcf77df5295955/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var aantalbedden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  aantalbedden = (await Promise.all((await Backendless.Data.of('algemenegegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['hospice=\'','Buurtzorghuis Warnsveld','\''].join(''))).setPageSize(10))).map(async aantalbedden => {; return ({ [`aantalbedden`]: (getObjectProperty(aantalbedden, 'aantalbedden')) });})))[0];
  ___arguments.context.pageData['aantalbedden6'] = (getObjectProperty(aantalbedden, 'aantalbedden'));

  return (getObjectProperty(aantalbedden, 'aantalbedden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/d2c19835a1f2666dbf623e91fcbfc5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen6'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/bf992ef4c05717a49d6c7a6189873c43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'aantalbedden6')) - (getObjectProperty(___arguments.context.pageData, 'aantalopgenomen6')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/aac92d06af8a44b59242c3b6641fd197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filter'] = (['hospice=\'','Buurtzorghuis Warnsveld','\'',' AND statuszorgtraject=\'Aanmelding voor opname\'',' OR hospice=\'','Buurtzorghuis Warnsveld','\'',' AND statuszorgtraject=\'Verwijzing terminale thuiszorg\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/wachtlijstbeheerOost-Veluwe/components/a02e0ecd729f6e5db19888412297c0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Oost-Veluwe')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/36536e31e64df51c4ee25de1b968d765/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/466ee43f40b71cc65a7db3290806dbce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/085ed5ab194b5e8da5da9118d478582e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    ___arguments.context.appData['clientnummer'] = null;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/d2139ef13d1e7e6af30cab14dc241ce5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    ___arguments.context.appData['clientnummer'] = null;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/d9485e5dad5ec37dba2175167a888f89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/f4c789bee74176c6e31ae6e7dd2d905f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/8bcbcc9b33a7d07d75cc0d1155615a45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('algemenegegevens') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/d74420ea99b96fb2069438b25a2a1d49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('algemenegegevens') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/4a9c80ac57ca0d3dd09bb1ec8a744b7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Oost-Veluwe') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheerperhospice', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function my_10_09_2025() {
  old = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true);
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/d0061f1d23039034d6bf217cfe5c6fc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'hospice')) == 'Oost-Veluwe') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheerperhospice', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernew', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function my_10_09_2025() {
  old = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true);
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/3ffe0e580b0f9cc19b47ff479027e6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/8ccdfa85a4d13e4e207f2e42a3840995/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('VPTZvragen', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setvptzinzet')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/58481cffda84f41d4d6d01912a059b4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/871e807239b8fa9ad498648c66b12d99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('VPTZvragen', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setvptzinzet')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/55cc2c72b4fc5211c4cb894c1f161ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/7b46682ce34c25aa94f5e971213efda6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/d9a35bc7cdaaffa295be5a957674ba5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesknew', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/2b95625466089d369ae8ea7bc0bd8f65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesknew', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/342ffaa209b1a319a2a57564a0ed9182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fpGhUfTRdPrZWK76mJw3zRIiE7Uwzc1E/view?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1HHxMITKF3L6IZvzd4l_kZfCfrTilEUBY/view?usp=drive_link', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1OrRVfRwWHRE7xip482fvPLX8jOIybeJ8/view?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fpGhUfTRdPrZWK76mJw3zRIiE7Uwzc1E/view?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/c9234ee4199163d5af3c3f169748a28c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fpGhUfTRdPrZWK76mJw3zRIiE7Uwzc1E/view?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1HHxMITKF3L6IZvzd4l_kZfCfrTilEUBY/view?usp=drive_link', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1OrRVfRwWHRE7xip482fvPLX8jOIybeJ8/view?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/092d6ceca6f83f2bfe9dcf12ce7be44d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1eJnRdTyInaOSItpPJlEP0CN4MUQyLtn8Z37i1y6iAN0/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1JjjSVPqaJl1YTC3oS0EYo_uDWUMGTjX3xm_EqEjmrPA/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/429525434bfa366ff268ee59af582a0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1eJnRdTyInaOSItpPJlEP0CN4MUQyLtn8Z37i1y6iAN0/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1JjjSVPqaJl1YTC3oS0EYo_uDWUMGTjX3xm_EqEjmrPA/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/5458880901c9ef7607671bb9d2643648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('strippenkaart', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'strippenkaart')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/cf23c5e3be5c4d6b13ac3f3844b4b7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('strippenkaart', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'strippenkaart')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/cc67903f85e33e5502c586a6ba287c23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/3aeb1a240eb57b83f14be1ab0cf3e0e1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'strippenkaart')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutGroningen/components/1677202a25dfbf8a1bf6756fcb2a05ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardregionaal', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/f57a22c6827f48027daf1325f707dd03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Limburg' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardregionaal', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/af6cdbb8ed88eea104f84e781938d70f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('wachtlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/38f4e1e82c586e6c4db81c48009f7ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Oost-Veluwe' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('wachtlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutGroningen/components/1735828f60a3bb1c52bf36c957ecae76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/36536e31e64df51c4ee25de1b968d765/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/466ee43f40b71cc65a7db3290806dbce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/55cc2c72b4fc5211c4cb894c1f161ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/7b46682ce34c25aa94f5e971213efda6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/25373cff6d4e6704410fbccf18cc4f48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('newusers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/e3c470de9f2cc669106be1a37fd91aeb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('newusers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/880d42d8934ae605574544eba37f7e66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vektis', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/3b49da29998cd977040fc756ef72d424/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vektis', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/a7dcef1ab67165be48ac9e6f2539e0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('exports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutLorio/components/4c83b62c797604ce67cbccabbfe43372/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('exports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/36536e31e64df51c4ee25de1b968d765/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/466ee43f40b71cc65a7db3290806dbce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8403b0d1e64167b8da9adaa98f0a4a39', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45c8ff37fc141b3f371febb7810c3087', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/085ed5ab194b5e8da5da9118d478582e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    ___arguments.context.appData['clientnummer'] = null;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/d2139ef13d1e7e6af30cab14dc241ce5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    ___arguments.context.appData['clientnummer'] = null;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('client') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/d9485e5dad5ec37dba2175167a888f89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/f4c789bee74176c6e31ae6e7dd2d905f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('clientenlijst') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/8bcbcc9b33a7d07d75cc0d1155615a45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('algemenegegevens') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/d74420ea99b96fb2069438b25a2a1d49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((String('algemenegegevens') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz'))), undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/4a9c80ac57ca0d3dd09bb1ec8a744b7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernewwachtlijstbeheer', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/d0061f1d23039034d6bf217cfe5c6fc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheernewwachtlijstbeheer', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'gebruikersbeheer')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/3ffe0e580b0f9cc19b47ff479027e6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/8ccdfa85a4d13e4e207f2e42a3840995/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('VPTZvragen', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty(___arguments.context.appData, 'setvptzinzet')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true);

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/58481cffda84f41d4d6d01912a059b4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/871e807239b8fa9ad498648c66b12d99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('VPTZvragen', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty(___arguments.context.appData, 'setvptzinzet')) == true ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true);

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/55cc2c72b4fc5211c4cb894c1f161ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/7b46682ce34c25aa94f5e971213efda6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u uitlogt.');
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/85e64163ca8fc36e0bdd02faca141a67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/ffa8cc6d9d5c72f7b62172831f89d84f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/d9a35bc7cdaaffa295be5a957674ba5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesknewwachtlijstbeheer', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/2b95625466089d369ae8ea7bc0bd8f65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesknewwachtlijstbeheer', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/342ffaa209b1a319a2a57564a0ed9182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fpGhUfTRdPrZWK76mJw3zRIiE7Uwzc1E/view?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1HHxMITKF3L6IZvzd4l_kZfCfrTilEUBY/view?usp=drive_link', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/c9234ee4199163d5af3c3f169748a28c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fpGhUfTRdPrZWK76mJw3zRIiE7Uwzc1E/view?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1HHxMITKF3L6IZvzd4l_kZfCfrTilEUBY/view?usp=drive_link', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/092d6ceca6f83f2bfe9dcf12ce7be44d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1eJnRdTyInaOSItpPJlEP0CN4MUQyLtn8Z37i1y6iAN0/edit?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/429525434bfa366ff268ee59af582a0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Zuid-Gelderland') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1GZBkbbIgkivWV0enD0AYDG1UPBsAyh-r2nSZS-C_gNI/edit?usp=sharing', true, undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1eJnRdTyInaOSItpPJlEP0CN4MUQyLtn8Z37i1y6iAN0/edit?usp=sharing', true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/5458880901c9ef7607671bb9d2643648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('strippenkaart', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/cf23c5e3be5c4d6b13ac3f3844b4b7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('strippenkaart', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/cc67903f85e33e5502c586a6ba287c23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  notused = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : false) : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/3aeb1a240eb57b83f14be1ab0cf3e0e1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'coordinator')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zg010abs' ? true : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/1677202a25dfbf8a1bf6756fcb2a05ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardregionaal', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/f57a22c6827f48027daf1325f707dd03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerkpz')) == 'Groningen')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'missingdata')) == true) {
    (function (message) { alert(message) })('Klik eerst op opslaan voordat u naar een andere pagina gaat.');
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardregionaal', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/78ff5d5947b146ed316e990e85b88a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('wachtlijstbeheerOost-Veluwe', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/LayoutWachtlijstbeheer/components/e2763d2f5455665a6223641df3cac631/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('wachtlijstbeheerOost-Veluwe', undefined);

  },
  /* handler:onClick */
  /* content */
}))

